window.WORTHAVISIT_REVIEWS = [
  {
    "id": "ky-co-beach",
    "name": "Ky Co Beach",
    "address": "Quy Nhon Dong, Gia Lai 591300, Vietnam",
    "city": "Quy Nhon",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Beaches & Nature",
    "subcategory": "Beaches",
    "rating": 2,
    "date": "2026-06-30",
    "review": "This place has changed since I last came in 2018. Of course that is expected but not this much. Crowds came in drones on boats, buses, taxis. They have made this tranquil beach into a massive tourist attraction. Now having to pay for a shuttle and entrance. 170 k per person. Then if you want to use the cabanas they are 300k.\nThey have 3 restaurants that are overcrowded and rubbish all over the floor. Too many tour groups to sit and enjoy your drink quietly. People come for the photos not caring about the environment. They made a fake waterfall and even have a seal show. Guys that’s animal abuse !! Making animals perform is abuse please educate yourself and your children.\nThe water is still such a beautiful crystal blue but of course there is rubbish floating around. Sure all this tourism is great for making money but this gem is no longer worth the visit. Skip it if you want some place quiet. Perfect for you if you just want photos and tick it off the list. Note: less people in the water when it is the middle of the day. Everyone wants to nap and keep out of the sun.",
    "questions": [
      {
        "label": "Visited on",
        "value": "Weekday"
      },
      {
        "label": "Wait time",
        "value": "Up to 10 min"
      },
      {
        "label": "Reservation recommended",
        "value": "No"
      }
    ],
    "tags": [
      "Beaches & Nature",
      "Quy Nhon",
      "Vietnam",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2307fe5753f84473",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2307fe5753f84473",
    "maps_embed": "https://www.google.com/maps?q=Ky%20Co%20Beach%20Quy%20Nhon%20Dong%2C%20Gia%20Lai%20591300%2C%20Vietnam&output=embed",
    "lat": 13.8499207,
    "lng": 109.291844,
    "seo_title": "Ky Co Beach Review: Is It Worth A Visit?",
    "seo_description": "This place has changed since I last came in 2018. Of course that is expected but not this much. Crowds came in drones on boats, buses, taxis. They hav…",
    "image": ""
  },
  {
    "id": "koze-mini-apartment",
    "name": "Koze mini apartment",
    "address": "11d Đ. Hoàng Diệu, Cam Ly - Đà Lạt, Lâm Đồng, Vietnam",
    "city": "Đà Lạt",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Stays",
    "subcategory": "Apartments",
    "rating": 4,
    "date": "2026-06-30",
    "review": "Pros:\nHas a nice kitchen\nGood shower pressure\nWashing machine\nLocation off main road so less noise\nGood WiFi\n\nCons:\nVery hard bed not comfortable at all\nCould smell smoke in room at night\nShower would leak all over floor\nNo couch\n\nTip: let them know before hand what time you’ll arrive so they can be there to unlock otherwise you’ll need to wait.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Location",
        "value": "3/5"
      },
      {
        "label": "Safety",
        "value": "Felt safe staying in here"
      },
      {
        "label": "Walkability",
        "value": "Busy streets nearby so sometimes hard to cross but that’s Vietnam"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Safety, Walkability"
      }
    ],
    "tags": [
      "Stays",
      "Đà Lạt",
      "Vietnam",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb273ab8fbe1b985c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb273ab8fbe1b985c",
    "maps_embed": "https://www.google.com/maps?q=Koze%20mini%20apartment%2011d%20%C4%90.%20Ho%C3%A0ng%20Di%E1%BB%87u%2C%20Cam%20Ly%20-%20%C4%90%C3%A0%20L%E1%BA%A1t%2C%20L%C3%A2m%20%C4%90%E1%BB%93ng%2C%20Vietnam&output=embed",
    "lat": 11.942502,
    "lng": 108.4303993,
    "seo_title": "Koze mini apartment Review: Is It Worth A Visit?",
    "seo_description": "Pros: Has a nice kitchen Good shower pressure Washing machine Location off main road so less noise Good WiFi Cons: Very hard bed not comfortable at al…",
    "image": ""
  },
  {
    "id": "ivegan-supershop-nha-trang-healthy-plant-based-cafe",
    "name": "IVEGAN SUPERSHOP NHA TRANG - HEALTHY PLANT-BASED CAFE",
    "address": "92/20 Hùng Vương, Nha Trang, Khánh Hòa 57106, Vietnam",
    "city": "Nha Trang",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-06-26",
    "review": "Nice to have lots of vegan options. I had the tempeh bagel. I haven’t found tempeh in Vietnam yet so it was nice to have for a change.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "₫1–100,000"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Noise level",
        "value": "Very quiet"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Loads of vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Nha Trang",
      "Vietnam",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2117898d0afbf50d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2117898d0afbf50d",
    "maps_embed": "https://www.google.com/maps?q=IVEGAN%20SUPERSHOP%20NHA%20TRANG%20-%20HEALTHY%20PLANT-BASED%20CAFE%2092/20%20H%C3%B9ng%20V%C6%B0%C6%A1ng%2C%20Nha%20Trang%2C%20Kh%C3%A1nh%20H%C3%B2a%2057106%2C%20Vietnam&output=embed",
    "lat": 12.2375309,
    "lng": 109.194766,
    "seo_title": "IVEGAN SUPERSHOP NHA TRANG - HEALTHY PLANT-BASED CAFE Review: Is It Worth A Visit?",
    "seo_description": "Nice to have lots of vegan options. I had the tempeh bagel. I haven’t found tempeh in Vietnam yet so it was nice to have for a change.",
    "image": ""
  },
  {
    "id": "maisaba-seminyak-loft-villas",
    "name": "Maisaba Seminyak Loft & Villas",
    "address": "Jl. Sunset Road No.105, Seminyak, Kec. Kuta, Kabupaten Badung, Bali 80361, Indonesia",
    "city": "Seminyak",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 3,
    "date": "2026-06-22",
    "review": "Pros:\n-own kitchen and water filter with hot and cold water\n-bed was soft\n-separate kitchen and room area\n-nice pool (but the seats were right outside our room which didn’t give much privacy)\nCons:\n-off a main road so hard to cross. (Also some dogs tried to attack us)\n-hot water ran out after 2 mins\n-dark in the day and then bright at night from all the lights coming through\n-needs a good scrub in the bathroom.(see photos)\n-quite noisy at night. Can hear neighbours slamming doors and people talking. Also road traffic.\n-stayed 5 nights wanted to cancel. Wouldn’t let us. They did no room service the whole time we were there.\n-plugged in adapter and it blew up",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "3/5"
      },
      {
        "label": "Service",
        "value": "1/5"
      },
      {
        "label": "Location",
        "value": "2/5"
      }
    ],
    "tags": [
      "Stays",
      "Seminyak",
      "Indonesia",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc668d9856f6cb576",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc668d9856f6cb576",
    "maps_embed": "https://www.google.com/maps?q=Maisaba%20Seminyak%20Loft%20%26%20Villas%20Jl.%20Sunset%20Road%20No.105%2C%20Seminyak%2C%20Kec.%20Kuta%2C%20Kabupaten%20Badung%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6875533,
    "lng": 115.1715959,
    "seo_title": "Maisaba Seminyak Loft & Villas Review: Is It Worth A Visit?",
    "seo_description": "Pros: -own kitchen and water filter with hot and cold water -bed was soft -separate kitchen and room area -nice pool (but the seats were right outside…",
    "image": ""
  },
  {
    "id": "2n-lounge",
    "name": "2N Lounge",
    "address": "226 Cống Quỳnh, Bến Thành, Hồ Chí Minh 70000, Vietnam",
    "city": "Hồ Chí Minh",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-06-19",
    "review": "I did the shampoo and added a scrub. My hair felt very clean and soft after. They even blow dry your hair at the end. Very good prices.",
    "questions": [],
    "tags": [
      "Wellness",
      "Hồ Chí Minh",
      "Vietnam",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3adf5b76894dfd16",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3adf5b76894dfd16",
    "maps_embed": "https://www.google.com/maps?q=2N%20Lounge%20226%20C%E1%BB%91ng%20Qu%E1%BB%B3nh%2C%20B%E1%BA%BFn%20Th%C3%A0nh%2C%20H%E1%BB%93%20Ch%C3%AD%20Minh%2070000%2C%20Vietnam&output=embed",
    "lat": 10.766437,
    "lng": 106.689272,
    "seo_title": "2N Lounge Review: Is It Worth A Visit?",
    "seo_description": "I did the shampoo and added a scrub. My hair felt very clean and soft after. They even blow dry your hair at the end. Very good prices.",
    "image": ""
  },
  {
    "id": "ono-poke-co",
    "name": "Ono Poke Co.",
    "address": "94 Xuân Thủy, An Khánh, Hồ Chí Minh 700000, Vietnam",
    "city": "Hồ Chí Minh",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-06-17",
    "review": "Fresh tasty poke bowl.\nGreat they can do vegan ones.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Noise level",
        "value": "Very quiet"
      },
      {
        "label": "Group size",
        "value": "2 people"
      },
      {
        "label": "Vegetarian options",
        "value": "Tofu"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Hồ Chí Minh",
      "Vietnam",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb5f6b922b7755779",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb5f6b922b7755779",
    "maps_embed": "https://www.google.com/maps?q=Ono%20Poke%20Co.%2094%20Xu%C3%A2n%20Th%E1%BB%A7y%2C%20An%20Kh%C3%A1nh%2C%20H%E1%BB%93%20Ch%C3%AD%20Minh%20700000%2C%20Vietnam&output=embed",
    "lat": 10.8037164,
    "lng": 106.7349952,
    "seo_title": "Ono Poke Co. Review: Is It Worth A Visit?",
    "seo_description": "Fresh tasty poke bowl. Great they can do vegan ones.",
    "image": ""
  },
  {
    "id": "azura-skin-clinic-thao-dien",
    "name": "AZURA Skin Clinic - Thao Dien",
    "address": "An Khánh, Hồ Chí Minh 713000, Vietnam",
    "city": "Hồ Chí Minh",
    "country": "Vietnam",
    "country_code": "VN",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-06-17",
    "review": "Came here to get mole removal. They were able to see me right away without an appointment. Very good price and very professional. I recommend coming here for your treatments",
    "questions": [],
    "tags": [
      "Wellness",
      "Hồ Chí Minh",
      "Vietnam",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbec290e0398f67",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbec290e0398f67",
    "maps_embed": "https://www.google.com/maps?q=AZURA%20Skin%20Clinic%20-%20Thao%20Dien%20An%20Kh%C3%A1nh%2C%20H%E1%BB%93%20Ch%C3%AD%20Minh%20713000%2C%20Vietnam&output=embed",
    "lat": 10.8078635,
    "lng": 106.7334934,
    "seo_title": "AZURA Skin Clinic - Thao Dien Review: Is It Worth A Visit?",
    "seo_description": "Came here to get mole removal. They were able to see me right away without an appointment. Very good price and very professional. I recommend coming h…",
    "image": ""
  },
  {
    "id": "minang-vegan",
    "name": "Minang Vegan",
    "address": "Jl. Bidadari No.1 No.79, Padangsambian Klod, Kec. Denpasar Bar., Kota Denpasar, Bali 80361, Indonesia",
    "city": "Kota Denpasar",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 1,
    "date": "2026-06-10",
    "review": "Was not open when I went there on Tuesday at 5:30pm in Seminyak even though it said they were open on Google . Also have mean dogs nearby when I was walking they barked at us and chased us",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Kota Denpasar",
      "Indonesia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe3a2c840352acd0a",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe3a2c840352acd0a",
    "maps_embed": "https://www.google.com/maps?q=Minang%20Vegan%20Jl.%20Bidadari%20No.1%20No.79%2C%20Padangsambian%20Klod%2C%20Kec.%20Denpasar%20Bar.%2C%20Kota%20Denpasar%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6831891,
    "lng": 115.1744876,
    "seo_title": "Minang Vegan Review: Is It Worth A Visit?",
    "seo_description": "Was not open when I went there on Tuesday at 5:30pm in Seminyak even though it said they were open on Google . Also have mean dogs nearby when I was w…",
    "image": ""
  },
  {
    "id": "heri-house-ubud",
    "name": "Heri House Ubud",
    "address": "Jl. Subak Sok Wayah No.1, Ubud, Kecamatan Ubud, Kabupaten Gianyar, Bali 80571, Indonesia",
    "city": "Ubud",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 5,
    "date": "2026-06-09",
    "review": "Pros:\n-down a quiet street, great for morning runs\n-bright room loads of natural light\n-great curtains, make room very dark to sleep\n-bed is very comfortable and big\n-great shower. Good pressure and lots of hot water.\n-cute bath with great view\n-very private room with own entrance\n-clean (except the fridge which had some mould)\n-breakfast delivered to your room\n-there is a secret shortcut behind the place but it is difficult so don’t do when rainy. It leads to the main road.\nCons:\n-Car cannot drop you off (but they can help with your bags with a motorbike)\n-sign is hard to see so you might walk past the place (just know it’s opposite Monkey bar)\n-shower drain did get blocked a few times but we just Poured hot water down the drain\n-no fan or vent in bathroom\n-you have to ask for housecleaning which I didn’t know about.\n-no hand towel or bath mat\n-no pool\n\nOverall I loved this place and we kept extending our stay",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Rooms",
        "value": "Quite spacious. Wardrobe with shelves inside"
      },
      {
        "label": "Safety",
        "value": "Felt very safe"
      },
      {
        "label": "Walkability",
        "value": "Easy to walk to cafes"
      },
      {
        "label": "Hotel highlights",
        "value": "Great value"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms, Safety, Walkability"
      }
    ],
    "tags": [
      "Stays",
      "Ubud",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x14e24a686d1c5e75",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x14e24a686d1c5e75",
    "maps_embed": "https://www.google.com/maps?q=Heri%20House%20Ubud%20Jl.%20Subak%20Sok%20Wayah%20No.1%2C%20Ubud%2C%20Kecamatan%20Ubud%2C%20Kabupaten%20Gianyar%2C%20Bali%2080571%2C%20Indonesia&output=embed",
    "lat": -8.5040573,
    "lng": 115.2559024,
    "seo_title": "Heri House Ubud Review: Is It Worth A Visit?",
    "seo_description": "Pros: -down a quiet street, great for morning runs -bright room loads of natural light -great curtains, make room very dark to sleep -bed is very comf…",
    "image": ""
  },
  {
    "id": "dragonfly-cafe-gelato",
    "name": "Dragonfly Cafe & Gelato",
    "address": "Jl. Subak Sok Wayah, Abangan, Kecamatan Ubud, Kabupaten Gianyar, Bali 80571, Indonesia",
    "city": "Ubud",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 2,
    "date": "2026-06-09",
    "review": "Review for cafe. Great that it has vegan options. I ordered miso soup with noodles. Came to be 77k was way too expensive for what it was. I could go to a fancy restaurant and spend only 10 or 20k more and have something 100 times better. Prices need to be lower. My partner was also disappointed with his meal and he got the burger. The juice was good. Area was nice but farmers were burning right next door.",
    "questions": [
      {
        "label": "Service",
        "value": "2/5"
      },
      {
        "label": "Location",
        "value": "3/5"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Ubud",
      "Indonesia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcf85fa1ff242223f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcf85fa1ff242223f",
    "maps_embed": "https://www.google.com/maps?q=Dragonfly%20Cafe%20%26%20Gelato%20Jl.%20Subak%20Sok%20Wayah%2C%20Abangan%2C%20Kecamatan%20Ubud%2C%20Kabupaten%20Gianyar%2C%20Bali%2080571%2C%20Indonesia&output=embed",
    "lat": -8.499558,
    "lng": 115.2584487,
    "seo_title": "Dragonfly Cafe & Gelato Review: Is It Worth A Visit?",
    "seo_description": "Review for cafe. Great that it has vegan options. I ordered miso soup with noodles. Came to be 77k was way too expensive for what it was. I could go t…",
    "image": ""
  },
  {
    "id": "wayan-s-coconut-juice-bar",
    "name": "Wayan's Coconut Juice Bar",
    "address": "F7V3+C8X, Jl. Penestanan, Sayan, Kecamatan Ubud, Kabupaten Gianyar, Bali 80571, Indonesia",
    "city": "Ubud",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 1,
    "date": "2026-06-09",
    "review": "Ordered one juice -coconut,aloe & lemon. It was not great, very bitter which gave me a bad taste. I thought it was only 35k as menu had nothing about tax. Ended up costing 46k which was far to high for something that tasted so bad. Sadly I don’t recommend this place and I don’t often leave bad reviews like this.",
    "questions": [
      {
        "label": "Price per person",
        "value": "Rp 25–50K"
      },
      {
        "label": "Food",
        "value": "1/5"
      },
      {
        "label": "Service",
        "value": "3/5"
      },
      {
        "label": "Atmosphere",
        "value": "1/5"
      },
      {
        "label": "Noise level",
        "value": "Very quiet"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      }
    ],
    "tags": [
      "Practical Finds",
      "Ubud",
      "Indonesia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6dada14619a551bc",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6dada14619a551bc",
    "maps_embed": "https://www.google.com/maps?q=Wayan%27s%20Coconut%20Juice%20Bar%20F7V3%2BC8X%2C%20Jl.%20Penestanan%2C%20Sayan%2C%20Kecamatan%20Ubud%2C%20Kabupaten%20Gianyar%2C%20Bali%2080571%2C%20Indonesia&output=embed",
    "lat": -8.5063827,
    "lng": 115.2533638,
    "seo_title": "Wayan's Coconut Juice Bar Review: Is It Worth A Visit?",
    "seo_description": "Ordered one juice -coconut,aloe & lemon. It was not great, very bitter which gave me a bad taste. I thought it was only 35k as menu had nothing about …",
    "image": ""
  },
  {
    "id": "the-lift-bali-gym-fitness-community",
    "name": "The Lift Bali - Gym & Fitness Community",
    "address": "Jl. I Ketut Natih No.88, Purwakerti, Kec. Abang, Kabupaten Karangasem, Bali 80852, Indonesia",
    "city": "Kabupaten Karangasem",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 4,
    "date": "2026-06-04",
    "review": "4 stars because the price is pretty high. The most expensive one I went to in Bali/lombok and I went all around. However, the equipment is new and there is different areas to workout in. Upstairs, downstairs and outside. I didn’t use the sauna area so can’t comment on that (it does cost extra).\nParking your motorbike was a bit of a hassle as people park behind you and you need to move them.",
    "questions": [],
    "tags": [
      "Gyms",
      "Kabupaten Karangasem",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa49cde35875bdbd",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa49cde35875bdbd",
    "maps_embed": "https://www.google.com/maps?q=The%20Lift%20Bali%20-%20Gym%20%26%20Fitness%20Community%20Jl.%20I%20Ketut%20Natih%20No.88%2C%20Purwakerti%2C%20Kec.%20Abang%2C%20Kabupaten%20Karangasem%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3356876,
    "lng": 115.6488874,
    "seo_title": "The Lift Bali - Gym & Fitness Community Review: Is It Worth A Visit?",
    "seo_description": "4 stars because the price is pretty high. The most expensive one I went to in Bali/lombok and I went all around. However, the equipment is new and the…",
    "image": ""
  },
  {
    "id": "good-stuff-cafe-eco-store-amed",
    "name": "Good Stuff Cafe & Eco Store Amed",
    "address": "Jl. Melasti, Amed, Biaslantang, Kec. Abang, Kabupaten Karangasem, Bali 80852, Indonesia",
    "city": "Amed",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-06-04",
    "review": "Came here multiple times. Great food and lots of vegan options. Lots of yummy cakes in the fridge inside",
    "questions": [
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "Rp 100–125K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Moderate noise"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Amed",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xff4883400622928e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xff4883400622928e",
    "maps_embed": "https://www.google.com/maps?q=Good%20Stuff%20Cafe%20%26%20Eco%20Store%20Amed%20Jl.%20Melasti%2C%20Amed%2C%20Biaslantang%2C%20Kec.%20Abang%2C%20Kabupaten%20Karangasem%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3354793,
    "lng": 115.6321558,
    "seo_title": "Good Stuff Cafe & Eco Store Amed Review: Is It Worth A Visit?",
    "seo_description": "Came here multiple times. Great food and lots of vegan options. Lots of yummy cakes in the fridge inside",
    "image": ""
  },
  {
    "id": "oneway-espresso",
    "name": "Oneway Espresso",
    "address": "Jl. I Ketut Natih, Purwakerti, Kec. Abang, Kabupaten Karangasem, Bali 80852, Indonesia",
    "city": "Kabupaten Karangasem",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-06-04",
    "review": "Came here for the vegan ramen. Did not disappoint. Also had the poke bowl but it felt like a lot of rice. Nice place with good aircon.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "Rp 100–125K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Noise level",
        "value": "Quiet, easy to talk"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Kabupaten Karangasem",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dce09053aecfc6f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dce09053aecfc6f",
    "maps_embed": "https://www.google.com/maps?q=Oneway%20Espresso%20Jl.%20I%20Ketut%20Natih%2C%20Purwakerti%2C%20Kec.%20Abang%2C%20Kabupaten%20Karangasem%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3338589,
    "lng": 115.6394779,
    "seo_title": "Oneway Espresso Review: Is It Worth A Visit?",
    "seo_description": "Came here for the vegan ramen. Did not disappoint. Also had the poke bowl but it felt like a lot of rice. Nice place with good aircon.",
    "image": ""
  },
  {
    "id": "blue-earth-village",
    "name": "Blue Earth Village",
    "address": "Amed St, Bunutan, Abang, Karangasem Regency, Bali 80852, Indonesia",
    "city": "Amed",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 4,
    "date": "2026-06-03",
    "review": "Had the vegan pizza. The view is great for sunset but does get busy!\nI did a yoga class here. Teacher was great but I thought the yoga class was held in a different Shala so was disappointed when it wasn’t the one with the view.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      }
    ],
    "tags": [
      "Vegan options",
      "Stays",
      "Amed",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6dd3cdb069174fea",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6dd3cdb069174fea",
    "maps_embed": "https://www.google.com/maps?q=Blue%20Earth%20Village%20Amed%20St%2C%20Bunutan%2C%20Abang%2C%20Karangasem%20Regency%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3386402,
    "lng": 115.6624298,
    "seo_title": "Blue Earth Village Review: Is It Worth A Visit?",
    "seo_description": "Had the vegan pizza. The view is great for sunset but does get busy! I did a yoga class here. Teacher was great but I thought the yoga class was held …",
    "image": ""
  },
  {
    "id": "japanese-ship-wreck-point",
    "name": "Japanese Ship Wreck Point",
    "address": "Jl. Karangasem - Seraya, Bunutan, Kec. Abang, Kabupaten Karangasem, Bali 80852, Indonesia",
    "city": "Kabupaten Karangasem",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Beaches & Nature",
    "subcategory": "Nature & Attractions",
    "rating": 3,
    "date": "2026-06-03",
    "review": "You need to arrive earlier to beat the crowd. We arrive 4 mins before the boats began to arrive. One literally anchored up above our heads and attached themselves to the ship wreck itself. The wreck didn’t seem to deep so easy to dive down. We drove from town and the drive was all good. There is some shops to hire snorkel and fins for 25k each.",
    "questions": [
      {
        "label": "Visited on",
        "value": "Weekday"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Reservation recommended",
        "value": "No"
      }
    ],
    "tags": [
      "Beaches & Nature",
      "Kabupaten Karangasem",
      "Indonesia",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xdc75babc0cfc227b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xdc75babc0cfc227b",
    "maps_embed": "https://www.google.com/maps?q=Japanese%20Ship%20Wreck%20Point%20Jl.%20Karangasem%20-%20Seraya%2C%20Bunutan%2C%20Kec.%20Abang%2C%20Kabupaten%20Karangasem%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3646513,
    "lng": 115.7006586,
    "seo_title": "Japanese Ship Wreck Point Review: Is It Worth A Visit?",
    "seo_description": "You need to arrive earlier to beat the crowd. We arrive 4 mins before the boats began to arrive. One literally anchored up above our heads and attache…",
    "image": ""
  },
  {
    "id": "pondok-tirta-homestay",
    "name": "Pondok Tirta Homestay",
    "address": "Jl. Melasti, Purwakerti, Kec. Abang, Kabupaten Karangasem, Bali 80852, Indonesia",
    "city": "Kabupaten Karangasem",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Homestays",
    "rating": 5,
    "date": "2026-06-03",
    "review": "Booked for 5 days and ended up staying for 2 weeks. The room was super spacious with a kitchen area and a big bathroom. The bathroom ceiling has some open which gives it nice air flow but some insects do come in, but the geckos will get them. The room has light blocking curtains so very easy to sleep in. Little bed outside to lay and chill. The pool is huge and super deep. The dive school sometimes use this. Loved the Warung that was attached. Are most meals here, great price. Overall, enjoyed my stay. It is a great location with lots of cafes and the beach at the end of the road.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "5/5"
      },
      {
        "label": "Rooms",
        "value": "Very big. The room we had was kind of dark in day time but the bathroom had a lot of natural light."
      },
      {
        "label": "Safety",
        "value": "I felt very safe. As a woman I would get up at 6am to go run. Some dogs would bark but all was good"
      },
      {
        "label": "Walkability",
        "value": "There is a short but through a rice paddy to get through to the other side."
      },
      {
        "label": "Food & drinks",
        "value": "Breakfast included"
      },
      {
        "label": "Noteworthy details",
        "value": "They come clean your room often which is so good"
      },
      {
        "label": "Hotel highlights",
        "value": "Great value"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms, Safety, Walkability, Food & drinks, Noteworthy details"
      }
    ],
    "tags": [
      "Stays",
      "Kabupaten Karangasem",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3d57981ecf1515f8",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3d57981ecf1515f8",
    "maps_embed": "https://www.google.com/maps?q=Pondok%20Tirta%20Homestay%20Jl.%20Melasti%2C%20Purwakerti%2C%20Kec.%20Abang%2C%20Kabupaten%20Karangasem%2C%20Bali%2080852%2C%20Indonesia&output=embed",
    "lat": -8.3333687,
    "lng": 115.6348098,
    "seo_title": "Pondok Tirta Homestay Review: Is It Worth A Visit?",
    "seo_description": "Booked for 5 days and ended up staying for 2 weeks. The room was super spacious with a kitchen area and a big bathroom. The bathroom ceiling has some …",
    "image": ""
  },
  {
    "id": "tanjung-aan-beach",
    "name": "Tanjung Aan Beach",
    "address": "West Nusa Tenggara, Indonesia",
    "city": "West Nusa Tenggara",
    "country": "Indonesia",
    "country_code": "",
    "category": "Beaches & Nature",
    "subcategory": "Beaches",
    "rating": 4,
    "date": "2026-05-10",
    "review": "This place is not too busy in the morning but by the afternoon everyone is here. A lot of people trying to sell you stuff. If you see this corn guy, you should definitely try.. spicy is spicy though. Yes, there is rubbish here but I did see some people cleaning. There is rubbish in the water but the water was the perfect temperature. Lots of sun beds to lay on and can watch the people surfing if you have good eyes. You can also rent a board and be taken out from this beach",
    "questions": [],
    "tags": [
      "Beaches & Nature",
      "West Nusa Tenggara",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1534bc2e04f15229",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1534bc2e04f15229",
    "maps_embed": "https://www.google.com/maps?q=Tanjung%20Aan%20Beach%20West%20Nusa%20Tenggara%2C%20Indonesia&output=embed",
    "lat": -8.9093097,
    "lng": 116.3211616,
    "seo_title": "Tanjung Aan Beach Review: Is It Worth A Visit?",
    "seo_description": "This place is not too busy in the morning but by the afternoon everyone is here. A lot of people trying to sell you stuff. If you see this corn guy, y…",
    "image": ""
  },
  {
    "id": "cantina-mexicana-kuta-lombok",
    "name": "Cantina Mexicana Kuta Lombok",
    "address": "Jalan Raya Kuta 6, Kuta Lombok, Puyut, Kuta, Lombok, Central Lombok Regency, West Nusa Tenggara 83753, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2026-05-10",
    "review": "Great that they have some vegan options. Tasty tacos. Cool place",
    "questions": [
      {
        "label": "Price per person",
        "value": "Rp 50–75K"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Very loud, hard to hear"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan Options. No vegan cheese"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Kuta",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x76be8830436ddf38",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x76be8830436ddf38",
    "maps_embed": "https://www.google.com/maps?q=Cantina%20Mexicana%20Kuta%20Lombok%20Jalan%20Raya%20Kuta%206%2C%20Kuta%20Lombok%2C%20Puyut%2C%20Kuta%2C%20Lombok%2C%20Central%20Lombok%20Regency%2C%20West%20Nusa%20Tenggara%2083753%2C%20Indonesia&output=embed",
    "lat": -8.8905272,
    "lng": 116.2769952,
    "seo_title": "Cantina Mexicana Kuta Lombok Review: Is It Worth A Visit?",
    "seo_description": "Great that they have some vegan options. Tasty tacos. Cool place",
    "image": ""
  },
  {
    "id": "palm-green-hotel",
    "name": "Palm Green Hotel",
    "address": "Jl. Mawun Mengalung, Kuta, Kec. Pujut, Kabupaten Lombok Tengah, Nusa Tenggara Bar. 83573, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 4,
    "date": "2026-05-10",
    "review": "Deluxe room - very spacious. Huge outdoor bathroom. Bath does not work. Bathroom did feel a bit dark as not much sunlight could get in. Lots of mosquitos do hang around so best to keep the door always closed. Nights patio area to chill. Pool was really nice. Unlimited coffee and water refill. Monkeys do come around sometimes so don’t leave food out",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Hotel highlights",
        "value": "Quiet"
      }
    ],
    "tags": [
      "Stays",
      "Kuta",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb859226e752302e4",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb859226e752302e4",
    "maps_embed": "https://www.google.com/maps?q=Palm%20Green%20Hotel%20Jl.%20Mawun%20Mengalung%2C%20Kuta%2C%20Kec.%20Pujut%2C%20Kabupaten%20Lombok%20Tengah%2C%20Nusa%20Tenggara%20Bar.%2083573%2C%20Indonesia&output=embed",
    "lat": -8.8866494,
    "lng": 116.2708056,
    "seo_title": "Palm Green Hotel Review: Is It Worth A Visit?",
    "seo_description": "Deluxe room - very spacious. Huge outdoor bathroom. Bath does not work. Bathroom did feel a bit dark as not much sunlight could get in. Lots of mosqui…",
    "image": ""
  },
  {
    "id": "bumblebee-gym-kuta-lombok",
    "name": "Bumblebee gym kuta Lombok",
    "address": "Jl. Pariwisata Pantai Kuta, Kuta, Kec. Pujut, Kabupaten Lombok Tengah, Nusa Tenggara Bar. 83573, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 4,
    "date": "2026-05-10",
    "review": "Lots of equipment but also a lot of people at times. I liked that the equipment seemed new and clean although some of the weights seemed old. It was quite hot in the gym but good to see some spray and wipe to clean the equipment.",
    "questions": [],
    "tags": [
      "Gyms",
      "Kuta",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8abf9c2f922ff799",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8abf9c2f922ff799",
    "maps_embed": "https://www.google.com/maps?q=Bumblebee%20gym%20kuta%20Lombok%20Jl.%20Pariwisata%20Pantai%20Kuta%2C%20Kuta%2C%20Kec.%20Pujut%2C%20Kabupaten%20Lombok%20Tengah%2C%20Nusa%20Tenggara%20Bar.%2083573%2C%20Indonesia&output=embed",
    "lat": -8.8900381,
    "lng": 116.2780942,
    "seo_title": "Bumblebee gym kuta Lombok Review: Is It Worth A Visit?",
    "seo_description": "Lots of equipment but also a lot of people at times. I liked that the equipment seemed new and clean although some of the weights seemed old. It was q…",
    "image": ""
  },
  {
    "id": "omah-gili-hotel",
    "name": "Omah Gili Hotel",
    "address": "Gili Air, Gili Indah, Pemenang, North Lombok Regency, West Nusa Tenggara 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 4,
    "date": "2026-05-10",
    "review": "Room was spacious and I loved the outdoor shower. I was surprised at how well the shower was. See video for water pressure. We were in the end room and it was very close to the neighbours roosters that crowed all the time. One sounded like a lady screaming lol. The breakfast was the best. Unlimited coffee from a machine. Lots of fruit and fresh pastries and treat as well as something off the menu.\nNice place, if you have kids careful in the pool as I cut my toe on a broken tile.\nBut this place is not to far from the port and is very close to the beach where the sun rises",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Safety",
        "value": "Very safe"
      },
      {
        "label": "Hotel highlights",
        "value": "Great value"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Safety"
      }
    ],
    "tags": [
      "Stays",
      "Gili Air",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2cdd06d99e819884",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2cdd06d99e819884",
    "maps_embed": "https://www.google.com/maps?q=Omah%20Gili%20Hotel%20Gili%20Air%2C%20Gili%20Indah%2C%20Pemenang%2C%20North%20Lombok%20Regency%2C%20West%20Nusa%20Tenggara%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3624298,
    "lng": 116.0859409,
    "seo_title": "Omah Gili Hotel Review: Is It Worth A Visit?",
    "seo_description": "Room was spacious and I loved the outdoor shower. I was surprised at how well the shower was. See video for water pressure. We were in the end room an…",
    "image": ""
  },
  {
    "id": "warung-sunny",
    "name": "Warung Sunny",
    "address": "Jl. Yoda, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2026-05-10",
    "review": "Lovely big outdoor restaurant with lots of seating. Gets quite hot as there are no fans but the food was great",
    "questions": [
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "Rp 50–75K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Moderate noise"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options with tofu and tempeh"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Lombok",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5655b218f543e3e8",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5655b218f543e3e8",
    "maps_embed": "https://www.google.com/maps?q=Warung%20Sunny%20Jl.%20Yoda%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3562403,
    "lng": 116.0812707,
    "seo_title": "Warung Sunny Review: Is It Worth A Visit?",
    "seo_description": "Lovely big outdoor restaurant with lots of seating. Gets quite hot as there are no fans but the food was great",
    "image": ""
  },
  {
    "id": "tetebatu-monkey-forest-gate",
    "name": "Tetebatu Monkey Forest Gate",
    "address": "Tetebatu Sikur, Tetebatu, Selong, Kabupaten Lombok Timur, Nusa Tenggara Bar. 83662, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Beaches & Nature",
    "subcategory": "Nature & Attractions",
    "rating": 5,
    "date": "2026-05-10",
    "review": "Very easy to spot the black monkeys. Our guide found them within 5 mins. We didn’t walk far. Best to go in the morning when they are active. It did rain the night before so was a bit muddy.",
    "questions": [
      {
        "label": "Visited on",
        "value": "Weekday"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Reservation recommended",
        "value": "No"
      }
    ],
    "tags": [
      "Beaches & Nature",
      "Lombok",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x37b86681f8e836ce",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x37b86681f8e836ce",
    "maps_embed": "https://www.google.com/maps?q=Tetebatu%20Monkey%20Forest%20Gate%20Tetebatu%20Sikur%2C%20Tetebatu%2C%20Selong%2C%20Kabupaten%20Lombok%20Timur%2C%20Nusa%20Tenggara%20Bar.%2083662%2C%20Indonesia&output=embed",
    "lat": -8.5330717,
    "lng": 116.4165277,
    "seo_title": "Tetebatu Monkey Forest Gate Review: Is It Worth A Visit?",
    "seo_description": "Very easy to spot the black monkeys. Our guide found them within 5 mins. We didn’t walk far. Best to go in the morning when they are active. It did ra…",
    "image": ""
  },
  {
    "id": "g-wash-laundry",
    "name": "G'wash Laundry",
    "address": "Gg. Optimist, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "",
    "category": "Practical Finds",
    "subcategory": "Laundry",
    "rating": 3,
    "date": "2026-05-10",
    "review": "Posting 3 stars as some of my clothes came back smelling weird like wet dog. I paid for 1 day but it took two. I didn’t want my stuff in the dryer. Maybe that’s why. Did get back every item which was great",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Lombok",
      "Indonesia",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd14b539855e6f932",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd14b539855e6f932",
    "maps_embed": "https://www.google.com/maps?q=G%27wash%20Laundry%20Gg.%20Optimist%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3610265,
    "lng": 116.0850036,
    "seo_title": "G'wash Laundry Review: Is It Worth A Visit?",
    "seo_description": "Posting 3 stars as some of my clothes came back smelling weird like wet dog. I paid for 1 day but it took two. I didn’t want my stuff in the dryer. Ma…",
    "image": ""
  },
  {
    "id": "teras-bambu",
    "name": "Teras bambu",
    "address": "J3RM+39G, Jl. Mojo, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-05-09",
    "review": "Great spot with a cool upstairs with beanbags. The meal I choose had lots of flavour and was very impressed with it. Only downside was it did take a little while to arrive. Which is usually ok but I was catching the ferry that morning. But he did apologise so not sure if that usually happens. But it’s a good place to eat at for a healthy meal",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 75–100K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Group size",
        "value": "2 people"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Lombok",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x15defcd6c1a2b0bb",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x15defcd6c1a2b0bb",
    "maps_embed": "https://www.google.com/maps?q=Teras%20bambu%20J3RM%2B39G%2C%20Jl.%20Mojo%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3598023,
    "lng": 116.0834581,
    "seo_title": "Teras bambu Review: Is It Worth A Visit?",
    "seo_description": "Great spot with a cool upstairs with beanbags. The meal I choose had lots of flavour and was very impressed with it. Only downside was it did take a l…",
    "image": ""
  },
  {
    "id": "dapoer-mommy-gili-air",
    "name": "Dapoer Mommy Gili Air",
    "address": "Sunset Boulevard, Gili Air, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2026-05-09",
    "review": "Came here when the power was out. They still managed to cook for us. I had a vegan curry. Was very flavourful. Would be good if they could add some fairy lights so it wouldn’t be so dark when they have power outages.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "Rp 25–50K"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Gili Air",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2bb656440791abdf",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2bb656440791abdf",
    "maps_embed": "https://www.google.com/maps?q=Dapoer%20Mommy%20Gili%20Air%20Sunset%20Boulevard%2C%20Gili%20Air%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3579325,
    "lng": 116.0800584,
    "seo_title": "Dapoer Mommy Gili Air Review: Is It Worth A Visit?",
    "seo_description": "Came here when the power was out. They still managed to cook for us. I had a vegan curry. Was very flavourful. Would be good if they could add some fa…",
    "image": ""
  },
  {
    "id": "elissa-caf-gili-air",
    "name": "Elissa Café Gili Air",
    "address": "Jl. Seni, Gili Air, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-05-09",
    "review": "Best coffee I had in Gili they even roast their own coffee beans. The vegan snicker bar was amazing and the vibe is so cool. A place you must visit when on Gili Air.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Other"
      },
      {
        "label": "Price per person",
        "value": "Rp 50–75K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Had a couple of vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8e4e2c044c48b2fe",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8e4e2c044c48b2fe",
    "maps_embed": "https://www.google.com/maps?q=Elissa%20Caf%C3%A9%20Gili%20Air%20Jl.%20Seni%2C%20Gili%20Air%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3614906,
    "lng": 116.0840209,
    "seo_title": "Elissa Café Gili Air Review: Is It Worth A Visit?",
    "seo_description": "Best coffee I had in Gili they even roast their own coffee beans. The vegan snicker bar was amazing and the vibe is so cool. A place you must visit wh…",
    "image": ""
  },
  {
    "id": "jaya-trekker-tetebatu-lombok-trekking-mount-rinjani-guide",
    "name": "Jaya Trekker, Tetebatu Lombok Trekking Mount Rinjani Guide",
    "address": "Tetebatu, Sikur, East Lombok Regency, West Nusa Tenggara 83663, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "",
    "category": "Beaches & Nature",
    "subcategory": "Hikes",
    "rating": 5,
    "date": "2026-05-06",
    "review": "We completed the 2D1N hike to the second summit and had an incredible experience with Jaya Trekking. Our guide, Sue, and porter, Yan, were exceptional. They went above and beyond by preparing delicious, fully vegan meals and keeping us fueled with plenty of snacks.\n\nThe trek itself is very challenging, so I was incredibly grateful that they handled all the heavy lifting—including setting up our tents—leaving me with only a small daypack to worry about. Their support made a tough climb much more enjoyable. Highly recommend this team! Great company to go with.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "Lombok",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaf1fd19262ab6979",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaf1fd19262ab6979",
    "maps_embed": "https://www.google.com/maps?q=Jaya%20Trekker%2C%20Tetebatu%20Lombok%20Trekking%20Mount%20Rinjani%20Guide%20Tetebatu%2C%20Sikur%2C%20East%20Lombok%20Regency%2C%20West%20Nusa%20Tenggara%2083663%2C%20Indonesia&output=embed",
    "lat": -8.5539676,
    "lng": 116.42001,
    "seo_title": "Jaya Trekker, Tetebatu Lombok Trekking Mount Rinjani Guide Review: Is It Worth A Visit?",
    "seo_description": "We completed the 2D1N hike to the second summit and had an incredible experience with Jaya Trekking. Our guide, Sue, and porter, Yan, were exceptional…",
    "image": ""
  },
  {
    "id": "gili-coffee-roasters",
    "name": "GILI COFFEE ROASTERS",
    "address": "Sunset Boulevard, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 5,
    "date": "2026-04-25",
    "review": "The smoothie bowl was very good!\nNot sure if it was the best coffee I had on the island. We got ice Americano with a side of soy milk which was an extra 10k which I think was a bit much for that. Overall a cool vibe with lots of different seating areas. Very busy place",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 75–100K"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Quiet, easy to talk"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options."
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Lombok",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc214e1e35217253e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc214e1e35217253e",
    "maps_embed": "https://www.google.com/maps?q=GILI%20COFFEE%20ROASTERS%20Sunset%20Boulevard%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3576566,
    "lng": 116.0815538,
    "seo_title": "GILI COFFEE ROASTERS Review: Is It Worth A Visit?",
    "seo_description": "The smoothie bowl was very good! Not sure if it was the best coffee I had on the island. We got ice Americano with a side of soy milk which was an ext…",
    "image": ""
  },
  {
    "id": "pearl-naturelle-nature-s-beauty-atelier",
    "name": "Pearl Naturelle 〜 Nature’s Beauty Atelier",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 1,
    "date": "2026-04-25",
    "review": "Does not exists anymore. Just another massage parlour now.",
    "questions": [],
    "tags": [
      "Wellness",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec7177195321aeaf",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec7177195321aeaf",
    "maps_embed": "https://www.google.com/maps?q=Pearl%20Naturelle%20%E3%80%9C%20Nature%E2%80%99s%20Beauty%20Atelier&output=embed",
    "lat": -6.4780589,
    "lng": 92.1058936,
    "seo_title": "Pearl Naturelle 〜 Nature’s Beauty Atelier Review: Is It Worth A Visit?",
    "seo_description": "Does not exists anymore. Just another massage parlour now.",
    "image": ""
  },
  {
    "id": "the-gym-gili-air",
    "name": "The Gym Gili Air",
    "address": "Jl. Mojo, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Very clean gym with new equipment. AC worked well and it wasn’t busy. You can come back as many times as you want in the same day. They also have larger pool out the back you can use. Really enjoyed this gym. The guy working here is very friendly. 120k all day pass.\nThey have lockers to use and give you a small towel. No water refill",
    "questions": [],
    "tags": [
      "Gyms",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30738dfd36b7eb42",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30738dfd36b7eb42",
    "maps_embed": "https://www.google.com/maps?q=The%20Gym%20Gili%20Air%20Jl.%20Mojo%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3628752,
    "lng": 116.0830432,
    "seo_title": "The Gym Gili Air Review: Is It Worth A Visit?",
    "seo_description": "Very clean gym with new equipment. AC worked well and it wasn’t busy. You can come back as many times as you want in the same day. They also have larg…",
    "image": ""
  },
  {
    "id": "gili-air-gym-holidayfit",
    "name": "Gili air gym_holidayfit",
    "address": "Beach, Gili Terawangan - Gili Air No.1, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 4,
    "date": "2026-04-25",
    "review": "Gym is spacious and has most equipment. Went twice first time didn’t feel like AC worked but second time felt cooler. Some of the equipment is a bit old but still works. The room at the back was way too hot to work out in. Wasn’t too busy and probably the cheapest gym on the island. 80k which only included a cold towel. They also have lockers available",
    "questions": [],
    "tags": [
      "Gyms",
      "Gili Air",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec95f4d208688251",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec95f4d208688251",
    "maps_embed": "https://www.google.com/maps?q=Gili%20air%20gym_holidayfit%20Beach%2C%20Gili%20Terawangan%20-%20Gili%20Air%20No.1%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3545039,
    "lng": 116.084836,
    "seo_title": "Gili air gym_holidayfit Review: Is It Worth A Visit?",
    "seo_description": "Gym is spacious and has most equipment. Went twice first time didn’t feel like AC worked but second time felt cooler. Some of the equipment is a bit o…",
    "image": ""
  },
  {
    "id": "firda-warung",
    "name": "Firda Warung",
    "address": "Jl. Mojo, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Lombok",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Lots of choices to choose from. Lots of vegan options. Food is fresh.came here twice food came quick first time then the second time took a lot longer. Prices are decent",
    "questions": [
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 25–50K"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan option"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Lombok",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6563881ca30cc85b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6563881ca30cc85b",
    "maps_embed": "https://www.google.com/maps?q=Firda%20Warung%20Jl.%20Mojo%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3622752,
    "lng": 116.0833206,
    "seo_title": "Firda Warung Review: Is It Worth A Visit?",
    "seo_description": "Lots of choices to choose from. Lots of vegan options. Food is fresh.came here twice food came quick first time then the second time took a lot longer…",
    "image": ""
  },
  {
    "id": "juju-zero-waste-store-vegan-cafe",
    "name": "JUJU Zero Waste Store & Vegan Cafe",
    "address": "Jl. Mojo, Gili Air, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Great menu and the food tasted great. More on the expensive side but worth the splurge. Great people watching spot as well as cute shop connected to it.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 75–100K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Plenty of vegan choices"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe3ed7d68f0f906dc",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe3ed7d68f0f906dc",
    "maps_embed": "https://www.google.com/maps?q=JUJU%20Zero%20Waste%20Store%20%26%20Vegan%20Cafe%20Jl.%20Mojo%2C%20Gili%20Air%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3613475,
    "lng": 116.0835788,
    "seo_title": "JUJU Zero Waste Store & Vegan Cafe Review: Is It Worth A Visit?",
    "seo_description": "Great menu and the food tasted great. More on the expensive side but worth the splurge. Great people watching spot as well as cute shop connected to i…",
    "image": ""
  },
  {
    "id": "warung-mexicana",
    "name": "Warung Mexicana",
    "address": "Desa Gili Indah, Gili Air, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Awesome local spot. This guy does it all! He made our food so well and it came out pretty quick. I got the falafel Mexican wrap and was very pleased with my choice. Also very good prices.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 25–50K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Recommended dishes",
        "value": "Falafel Burrito"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Many vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbc730b6f3014444d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbc730b6f3014444d",
    "maps_embed": "https://www.google.com/maps?q=Warung%20Mexicana%20Desa%20Gili%20Indah%2C%20Gili%20Air%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3620629,
    "lng": 116.0823852,
    "seo_title": "Warung Mexicana Review: Is It Worth A Visit?",
    "seo_description": "Awesome local spot. This guy does it all! He made our food so well and it came out pretty quick. I got the falafel Mexican wrap and was very pleased w…",
    "image": ""
  },
  {
    "id": "lockdown-kitchen-gili-air",
    "name": "Lockdown Kitchen Gili Air",
    "address": "Gili Air, Pemenang, North Lombok Regency, West Nusa Tenggara 83552, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2026-04-25",
    "review": "This place has a lot of great things on the menu. I really enjoyed my meals. The only downside was they did mess up some of the food. Some of it went into my partner’s meal instead of mine. The second time I came I also asked for no egg. She repeated back and then it still came with egg. Also I don’t like that people can smoke at the tables. But great value and I like they give complimentary banana chips and water  🙂",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 50–75K"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Group size",
        "value": "3-4 people"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Plenty of vegan choices"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Gili Air",
      "Indonesia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x57c663b551622f57",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x57c663b551622f57",
    "maps_embed": "https://www.google.com/maps?q=Lockdown%20Kitchen%20Gili%20Air%20Gili%20Air%2C%20Pemenang%2C%20North%20Lombok%20Regency%2C%20West%20Nusa%20Tenggara%2083552%2C%20Indonesia&output=embed",
    "lat": -8.3586888,
    "lng": 116.0829676,
    "seo_title": "Lockdown Kitchen Gili Air Review: Is It Worth A Visit?",
    "seo_description": "This place has a lot of great things on the menu. I really enjoyed my meals. The only downside was they did mess up some of the food. Some of it went …",
    "image": ""
  },
  {
    "id": "pachamama-organic-cafe-villa-spa",
    "name": "Pachamama Organic Cafe • Villa • Spa",
    "address": "Gili Air, Jl. Svea, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83000, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Came here multiple times because this place is so good. Food tasted fresh and the sauces were delish!  The staff here are so friendly. Love the vibe of the place such a cool decorative throughout space.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Food & drinks",
        "value": "Wholesome"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Food & drinks"
      }
    ],
    "tags": [
      "Wellness",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30022df7778b4a41",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30022df7778b4a41",
    "maps_embed": "https://www.google.com/maps?q=Pachamama%20Organic%20Cafe%20%E2%80%A2%20Villa%20%E2%80%A2%20Spa%20Gili%20Air%2C%20Jl.%20Svea%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083000%2C%20Indonesia&output=embed",
    "lat": -8.3532133,
    "lng": 116.0852127,
    "seo_title": "Pachamama Organic Cafe • Villa • Spa Review: Is It Worth A Visit?",
    "seo_description": "Came here multiple times because this place is so good. Food tasted fresh and the sauces were delish! The staff here are so friendly. Love the vibe of…",
    "image": ""
  },
  {
    "id": "aura-bowls",
    "name": "Aura Bowls",
    "address": "Unnamed Road, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Amed",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Lots to choose from on the menu. Omg the smoothie was so good as well as the food. Great value.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 75–100K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Moderate noise"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options !!"
      },
      {
        "label": "Parking space",
        "value": "Plenty of parking"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions, Parking"
      }
    ],
    "tags": [
      "Vegan options",
      "Wellness",
      "Amed",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfa4ec84a2c581bd",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfa4ec84a2c581bd",
    "maps_embed": "https://www.google.com/maps?q=Aura%20Bowls%20Unnamed%20Road%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3618373,
    "lng": 116.0851791,
    "seo_title": "Aura Bowls Review: Is It Worth A Visit?",
    "seo_description": "Lots to choose from on the menu. Omg the smoothie was so good as well as the food. Great value.",
    "image": ""
  },
  {
    "id": "coral-drift-beach-bungalow",
    "name": "Coral Drift Beach Bungalow",
    "address": "Gili air, Gili Indah, Kec. Pemenang, Kabupaten Lombok Utara, Nusa Tenggara Bar. 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Such a cool spot! So glad we booked here. We kept extending our stay. You get your own private pool if you book the deluxe. The shower was my fave part. The water also gets very hot. I felt very safe here and the staff were so lovely. Breakfast was great and they bring it you you room at the time you ask. They are so helpful whenever we had any problems they would get on it right away. The beach is right out front. You can see from my last video. The most amazing sunsets are seen from this side of the island and you can snorkel here too, but you need to go out a little distance to see amazing coral and fish.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "5/5"
      },
      {
        "label": "Rooms",
        "value": "Quite spacious. Lots of room to put clothes."
      },
      {
        "label": "Nearby activities",
        "value": "Lots of restaurants out the front and along the street"
      },
      {
        "label": "Safety",
        "value": "Very safe. I would get up early at 6am and run the island by myself through all the streets."
      },
      {
        "label": "Walkability",
        "value": "Dirt road. Uneven ground to get to it by foot."
      },
      {
        "label": "Noteworthy details",
        "value": "Very private feel to the accommodation"
      },
      {
        "label": "Hotel highlights",
        "value": "Romantic, Quiet, Great value"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms, Nearby activities, Safety, Walkability, Noteworthy details"
      }
    ],
    "tags": [
      "Stays",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd9c8d637b983dd24",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd9c8d637b983dd24",
    "maps_embed": "https://www.google.com/maps?q=Coral%20Drift%20Beach%20Bungalow%20Gili%20air%2C%20Gili%20Indah%2C%20Kec.%20Pemenang%2C%20Kabupaten%20Lombok%20Utara%2C%20Nusa%20Tenggara%20Bar.%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3517234,
    "lng": 116.0808811,
    "seo_title": "Coral Drift Beach Bungalow Review: Is It Worth A Visit?",
    "seo_description": "Such a cool spot! So glad we booked here. We kept extending our stay. You get your own private pool if you book the deluxe. The shower was my fave par…",
    "image": ""
  },
  {
    "id": "moya-spa",
    "name": "moya spa",
    "address": "gili air, Pemenang, mataram, West Nusa Tenggara 83352, Indonesia",
    "city": "Gili Air",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-04-25",
    "review": "Best massage I’ve had since coming to Indonesia. The lady who did my massage knew what she was doing and very good pressure. Thank you so much. If I’m back to the island I will only go to this one !",
    "questions": [],
    "tags": [
      "Wellness",
      "Gili Air",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9b4add5328d8762f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9b4add5328d8762f",
    "maps_embed": "https://www.google.com/maps?q=moya%20spa%20gili%20air%2C%20Pemenang%2C%20mataram%2C%20West%20Nusa%20Tenggara%2083352%2C%20Indonesia&output=embed",
    "lat": -8.3561538,
    "lng": 116.0791213,
    "seo_title": "moya spa Review: Is It Worth A Visit?",
    "seo_description": "Best massage I’ve had since coming to Indonesia. The lady who did my massage knew what she was doing and very good pressure. Thank you so much. If I’m…",
    "image": ""
  },
  {
    "id": "canggu-gym-canggu-9ym",
    "name": "Canggu GYM (CANGGU 9YM)",
    "address": "Jl. Subak Canggu, Canggu, Kec. Kuta Utara, Kabupaten Badung, Bali 80361, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 5,
    "date": "2026-04-17",
    "review": "New clean equipment. Never really felt too busy. Lots of equipment. Only 100k for a day pass including ice bath and sauna. Big towels are extra 10k and you pay 50k deposit for a locker. Lovely staff.",
    "questions": [],
    "tags": [
      "Gyms",
      "Kuta",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x697df3409c623cc2",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x697df3409c623cc2",
    "maps_embed": "https://www.google.com/maps?q=Canggu%20GYM%20%28CANGGU%209YM%29%20Jl.%20Subak%20Canggu%2C%20Canggu%2C%20Kec.%20Kuta%20Utara%2C%20Kabupaten%20Badung%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6487234,
    "lng": 115.1405876,
    "seo_title": "Canggu GYM (CANGGU 9YM) Review: Is It Worth A Visit?",
    "seo_description": "New clean equipment. Never really felt too busy. Lots of equipment. Only 100k for a day pass including ice bath and sauna. Big towels are extra 10k an…",
    "image": ""
  },
  {
    "id": "serenity-eco-guesthouse-and-yoga",
    "name": "Serenity Eco Guesthouse and Yoga",
    "address": "Jl. Nelayan, Canggu, Kec. Kuta Utara, Kabupaten Badung, Bali 80361, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Stays",
    "subcategory": "Homestays",
    "rating": 1,
    "date": "2026-04-17",
    "review": "Posting only about the 70k breakfast buffet. Very disappointed. Not worth the price paid. I’m really sad to have to write this review but 70k is far to high for what is offered. The only good thing was the fruit.",
    "questions": [],
    "tags": [
      "Stays",
      "Kuta",
      "Indonesia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb5afe343172c7633",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb5afe343172c7633",
    "maps_embed": "https://www.google.com/maps?q=Serenity%20Eco%20Guesthouse%20and%20Yoga%20Jl.%20Nelayan%2C%20Canggu%2C%20Kec.%20Kuta%20Utara%2C%20Kabupaten%20Badung%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6595498,
    "lng": 115.1339354,
    "seo_title": "Serenity Eco Guesthouse and Yoga Review: Is It Worth A Visit?",
    "seo_description": "Posting only about the 70k breakfast buffet. Very disappointed. Not worth the price paid. I’m really sad to have to write this review but 70k is far t…",
    "image": ""
  },
  {
    "id": "doppio-cafe",
    "name": "Doppio Cafe",
    "address": "Jl. Nelayan No.25a, Canggu, Kec. Kuta Utara, Kabupaten Badung, Bali 80361, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2026-04-17",
    "review": "A few good vegan options to choose from. I had pancakes and corn fritters both very good. Love they have everything for no more than 55k including tax and service.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 75–100K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Noise level",
        "value": "Loud, but you can still talk"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Kuta",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7ee93eafe6b92e9c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7ee93eafe6b92e9c",
    "maps_embed": "https://www.google.com/maps?q=Doppio%20Cafe%20Jl.%20Nelayan%20No.25a%2C%20Canggu%2C%20Kec.%20Kuta%20Utara%2C%20Kabupaten%20Badung%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6559156,
    "lng": 115.1349493,
    "seo_title": "Doppio Cafe Review: Is It Worth A Visit?",
    "seo_description": "A few good vegan options to choose from. I had pancakes and corn fritters both very good. Love they have everything for no more than 55k including tax…",
    "image": ""
  },
  {
    "id": "kynd-community-canggu",
    "name": "KYND COMMUNITY CANGGU",
    "address": "Jl. Nelayan No.31, Canggu, Kec. Kuta Utara, Kabupaten Badung, Bali 80361, Indonesia",
    "city": "Kuta",
    "country": "Indonesia",
    "country_code": "ID",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 5,
    "date": "2026-04-15",
    "review": "Great place to enjoy a delicious meal. Coffee was great and no extra charge for the plant based milks. Staff are so friendly and the food came quick even though they were busy.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "Rp 175–200K"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Reservation",
        "value": "Reservations not required"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes !"
      },
      {
        "label": "Dietary restrictions",
        "value": "Loads of vegan Options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Kuta",
      "Indonesia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc62d402c61fa79c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc62d402c61fa79c",
    "maps_embed": "https://www.google.com/maps?q=KYND%20COMMUNITY%20CANGGU%20Jl.%20Nelayan%20No.31%2C%20Canggu%2C%20Kec.%20Kuta%20Utara%2C%20Kabupaten%20Badung%2C%20Bali%2080361%2C%20Indonesia&output=embed",
    "lat": -8.6575243,
    "lng": 115.1344418,
    "seo_title": "KYND COMMUNITY CANGGU Review: Is It Worth A Visit?",
    "seo_description": "Great place to enjoy a delicious meal. Coffee was great and no extra charge for the plant based milks. Staff are so friendly and the food came quick e…",
    "image": ""
  },
  {
    "id": "halong-bay",
    "name": "Halong Bay",
    "address": "4991249, Auckland Airport, Auckland 2022, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 4,
    "date": "2026-04-15",
    "review": "$20 go banh mi. Pricey but it is the airport. Tasted fresh and the bun was not soggy. Clean place to sit and eat.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$10–20"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Wait time",
        "value": "Up to 10 min"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes. Tofu"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x380035718cdfc7e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x380035718cdfc7e",
    "maps_embed": "https://www.google.com/maps?q=Halong%20Bay%204991249%2C%20Auckland%20Airport%2C%20Auckland%202022%2C%20New%20Zealand&output=embed",
    "lat": -37.0059684,
    "lng": 174.7829011,
    "seo_title": "Halong Bay Review: Is It Worth A Visit?",
    "seo_description": "$20 go banh mi. Pricey but it is the airport. Tasted fresh and the bun was not soggy. Clean place to sit and eat.",
    "image": ""
  },
  {
    "id": "eden-noodles-manukau-manukau",
    "name": "Eden Noodles Manukau四川担担面Manukau",
    "address": "7/613 Great South Road, Manukau City Centre, Auckland 2104, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2026-04-11",
    "review": "Great prices with many options. Lots of Vegan and vegetarian options too. Food had lots of flavour. A little bit spicy but still such a good deal",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$10–20"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Group size",
        "value": "Suitable for all group sizes"
      },
      {
        "label": "Vegetarian options",
        "value": "Vegan too"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan"
      },
      {
        "label": "Parking space",
        "value": "Plenty of parking"
      },
      {
        "label": "Parking options",
        "value": "Free parking lot"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions, Parking"
      }
    ],
    "tags": [
      "Vegan options",
      "Wellness",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe7855f38bea2214e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe7855f38bea2214e",
    "maps_embed": "https://www.google.com/maps?q=Eden%20Noodles%20Manukau%E5%9B%9B%E5%B7%9D%E6%8B%85%E6%8B%85%E9%9D%A2Manukau%207/613%20Great%20South%20Road%2C%20Manukau%20City%20Centre%2C%20Auckland%202104%2C%20New%20Zealand&output=embed",
    "lat": -36.9863821,
    "lng": 174.8800754,
    "seo_title": "Eden Noodles Manukau四川担担面Manukau Review: Is It Worth A Visit?",
    "seo_description": "Great prices with many options. Lots of Vegan and vegetarian options too. Food had lots of flavour. A little bit spicy but still such a good deal",
    "image": ""
  },
  {
    "id": "shibbys-frozen-yoghurt-a-a",
    "name": "Shibbys Frozen Yoghurt & Açaí",
    "address": "197 Broadway, Newmarket, Auckland 1023, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2026-03-30",
    "review": "Lots of options. The açai an coconut are vegan and they have some cookie dough and chocolate crumble that is vegan too. Can get quite expensive so be careful how much you load in your bowl",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x90f745f9c7e7e6de",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x90f745f9c7e7e6de",
    "maps_embed": "https://www.google.com/maps?q=Shibbys%20Frozen%20Yoghurt%20%26%20A%C3%A7a%C3%AD%20197%20Broadway%2C%20Newmarket%2C%20Auckland%201023%2C%20New%20Zealand&output=embed",
    "lat": -36.869073,
    "lng": 174.7776307,
    "seo_title": "Shibbys Frozen Yoghurt & Açaí Review: Is It Worth A Visit?",
    "seo_description": "Lots of options. The açai an coconut are vegan and they have some cookie dough and chocolate crumble that is vegan too. Can get quite expensive so be …",
    "image": ""
  },
  {
    "id": "mudita",
    "name": "Mudita",
    "address": "234 Ponsonby Road, Ponsonby, Auckland 1011, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 3,
    "date": "2026-03-30",
    "review": "I got the laksa. It did have a chilli pepper next to it but we did ask to clarify how spicy. Was told not that spicy. Omg it was soooo spicy. It was hard to enjoy the meal. Also was never asked how our meal was.\n\nIt’s great this place is fully Vegan. Has indoor and outdoor seating.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$20–30"
      },
      {
        "label": "Food",
        "value": "3/5"
      },
      {
        "label": "Service",
        "value": "3/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Dietary restrictions",
        "value": "Fully vegan. Which is awesome."
      },
      {
        "label": "Parking options",
        "value": "Free street parking, Paid street parking"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions, Parking"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x242b08ce0253823e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x242b08ce0253823e",
    "maps_embed": "https://www.google.com/maps?q=Mudita%20234%20Ponsonby%20Road%2C%20Ponsonby%2C%20Auckland%201011%2C%20New%20Zealand&output=embed",
    "lat": -36.8520739,
    "lng": 174.7447417,
    "seo_title": "Mudita Review: Is It Worth A Visit?",
    "seo_description": "I got the laksa. It did have a chilli pepper next to it but we did ask to clarify how spicy. Was told not that spicy. Omg it was soooo spicy. It was h…",
    "image": ""
  },
  {
    "id": "tokyo-bay-japanese",
    "name": "Tokyo Bay Japanese",
    "address": "20 The Strand, Takapuna, Auckland 0622, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 1,
    "date": "2025-11-24",
    "review": "This meal cost $34 plus had to buy rice for another $3.50. If you look at the meal you can easily do the math and no it cost probably no more than $5. The tofu glaze was a weird texture and made it hard to eat. Not a fan. The waitress was polite and kind but overall was a pretty average experience.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$30–40"
      },
      {
        "label": "Food",
        "value": "1/5"
      },
      {
        "label": "Service",
        "value": "3/5"
      },
      {
        "label": "Atmosphere",
        "value": "2/5"
      },
      {
        "label": "Noise level",
        "value": "Moderate noise"
      },
      {
        "label": "Seating type",
        "value": "Outdoor patio / terrace"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Parking space",
        "value": "Plenty of parking"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions, Parking"
      }
    ],
    "tags": [
      "Vegan options",
      "Wellness",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x633de3910531c093",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x633de3910531c093",
    "maps_embed": "https://www.google.com/maps?q=Tokyo%20Bay%20Japanese%2020%20The%20Strand%2C%20Takapuna%2C%20Auckland%200622%2C%20New%20Zealand&output=embed",
    "lat": -36.7869365,
    "lng": 174.7739441,
    "seo_title": "Tokyo Bay Japanese Review: Is It Worth A Visit?",
    "seo_description": "This meal cost $34 plus had to buy rice for another $3.50. If you look at the meal you can easily do the math and no it cost probably no more than $5.…",
    "image": ""
  },
  {
    "id": "queenstown-hill-walking-track",
    "name": "Queenstown Hill Walking Track",
    "address": "9300/58 Belfast Terrace, Queenstown 9300, New Zealand",
    "city": "Queenstown",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 4,
    "date": "2025-08-05",
    "review": "29th July. Weather was pretty good. Thought I would be colder but got hot and had to take jackets off on way up. There are 2 ways to go up. If you turn right it’s more scenic with lots of view points. There is a cute fairy garden on the way up.",
    "questions": [
      {
        "label": "Difficulty",
        "value": "Moderate"
      },
      {
        "label": "Route type",
        "value": "Loop"
      },
      {
        "label": "Time spent",
        "value": "1-2 hr"
      },
      {
        "label": "Recommended activities",
        "value": "Hiking, Walking"
      },
      {
        "label": "Parking options",
        "value": "Free parking lot, Free street parking"
      },
      {
        "label": "Restrooms",
        "value": "No"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Parking, Restrooms"
      }
    ],
    "tags": [
      "Stays",
      "Queenstown",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaf9537bb7c2902b1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaf9537bb7c2902b1",
    "maps_embed": "https://www.google.com/maps?q=Queenstown%20Hill%20Walking%20Track%209300/58%20Belfast%20Terrace%2C%20Queenstown%209300%2C%20New%20Zealand&output=embed",
    "lat": -45.0274174,
    "lng": 168.6667049,
    "seo_title": "Queenstown Hill Walking Track Review: Is It Worth A Visit?",
    "seo_description": "29th July. Weather was pretty good. Thought I would be colder but got hot and had to take jackets off on way up. There are 2 ways to go up. If you tur…",
    "image": ""
  },
  {
    "id": "autoline-motel-and-apartments",
    "name": "Autoline Motel and Apartments",
    "address": "2/4 Dublin Street, Queenstown 9300, New Zealand",
    "city": "Queenstown",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Apartments",
    "rating": 4,
    "date": "2025-08-02",
    "review": "I enjoyed our time here. Kitchen was decent (did have to ask for coffee plunger). Bathroom was spacious. Friendly staff. The downside was the lights outside at night on the balcony, they were bright and we had no control to turn them off.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Rooms",
        "value": "We had upstairs and it was pretty spacious. One small chair. Big bed and one single."
      },
      {
        "label": "Safety",
        "value": "Very safe"
      },
      {
        "label": "Walkability",
        "value": "15 or so minute walk into town"
      },
      {
        "label": "Hotel highlights",
        "value": "Great view, Quiet"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms, Safety, Walkability"
      }
    ],
    "tags": [
      "Stays",
      "Queenstown",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcd315dfa977ec7e0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcd315dfa977ec7e0",
    "maps_embed": "https://www.google.com/maps?q=Autoline%20Motel%20and%20Apartments%202/4%20Dublin%20Street%2C%20Queenstown%209300%2C%20New%20Zealand&output=embed",
    "lat": -45.0334826,
    "lng": 168.6687367,
    "seo_title": "Autoline Motel and Apartments Review: Is It Worth A Visit?",
    "seo_description": "I enjoyed our time here. Kitchen was decent (did have to ask for coffee plunger). Bathroom was spacious. Friendly staff. The downside was the lights o…",
    "image": ""
  },
  {
    "id": "pouakai-circuit-reflective-tarn",
    "name": "Pouakai Circuit Reflective Tarn",
    "address": "Taranaki Region 4391, New Zealand",
    "city": "Taranaki Region 4391",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 5,
    "date": "2025-06-26",
    "review": "Guys please go prepared. It gets freaking cold up there at this time of year. It’s hot walking up but once you’re up there and the clouds and wind come it’s freezing.\nGood amount of stairs. You’ll need a decent fitness level. Stairs can be muddy and slippery. Was super busy when I went - matariki weekend. Also was in the car park by 8:30am and it took us just over 3 hours. Including waiting at the top. Car park was overflowing when we got down.",
    "questions": [
      {
        "label": "Visited on",
        "value": "Public holiday"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Reservation recommended",
        "value": "No"
      }
    ],
    "tags": [
      "Gyms",
      "Taranaki Region 4391",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe47dbad4daa554cf",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe47dbad4daa554cf",
    "maps_embed": "https://www.google.com/maps?q=Pouakai%20Circuit%20Reflective%20Tarn%20Taranaki%20Region%204391%2C%20New%20Zealand&output=embed",
    "lat": -39.2339336,
    "lng": 174.0472344,
    "seo_title": "Pouakai Circuit Reflective Tarn Review: Is It Worth A Visit?",
    "seo_description": "Guys please go prepared. It gets freaking cold up there at this time of year. It’s hot walking up but once you’re up there and the clouds and wind com…",
    "image": ""
  },
  {
    "id": "chaos-cafe-crafted-coffee-shop-cafeteria-delights",
    "name": "Chaos Cafe - Crafted Coffee Shop & Cafeteria Delights",
    "address": "36 Brougham Street, New Plymouth Central, New Plymouth 4310, New Zealand",
    "city": "New Plymouth",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2025-06-26",
    "review": "Just got a takeaway coffee. Pricey coffee for the size. Asked for soy milk and it made the coffee taste sweet so not sure if it was a sweeten one. Overall coffee was good but not my preference.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Other"
      },
      {
        "label": "Price per person",
        "value": "$1–10"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      }
    ],
    "tags": [
      "Practical Finds",
      "New Plymouth",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5670498da51c541d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5670498da51c541d",
    "maps_embed": "https://www.google.com/maps?q=Chaos%20Cafe%20-%20Crafted%20Coffee%20Shop%20%26%20Cafeteria%20Delights%2036%20Brougham%20Street%2C%20New%20Plymouth%20Central%2C%20New%20Plymouth%204310%2C%20New%20Zealand&output=embed",
    "lat": -39.0585345,
    "lng": 174.0729899,
    "seo_title": "Chaos Cafe - Crafted Coffee Shop & Cafeteria Delights Review: Is It Worth A Visit?",
    "seo_description": "Just got a takeaway coffee. Pricey coffee for the size. Asked for soy milk and it made the coffee taste sweet so not sure if it was a sweeten one. Ove…",
    "image": ""
  },
  {
    "id": "kahakai-poke-bowl",
    "name": "Kahakai Poke Bowl",
    "address": "21 Liardet Street, New Plymouth Central, New Plymouth 4310, New Zealand",
    "city": "New Plymouth",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 5,
    "date": "2025-06-26",
    "review": "Got the tofu poke bowl. Good size portion. Busy spot when we went. So can be hard to get a table.",
    "questions": [
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$20–30"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Group size",
        "value": "1 person, 2 people, 3-4 people"
      },
      {
        "label": "Wait time",
        "value": "Up to 10 min"
      },
      {
        "label": "Vegetarian options",
        "value": "They had vegan aioli and didn’t give us kimchi"
      },
      {
        "label": "Dietary restrictions",
        "value": "Yes to vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "New Plymouth",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x95558cff9680af5d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x95558cff9680af5d",
    "maps_embed": "https://www.google.com/maps?q=Kahakai%20Poke%20Bowl%2021%20Liardet%20Street%2C%20New%20Plymouth%20Central%2C%20New%20Plymouth%204310%2C%20New%20Zealand&output=embed",
    "lat": -39.0563898,
    "lng": 174.0762377,
    "seo_title": "Kahakai Poke Bowl Review: Is It Worth A Visit?",
    "seo_description": "Got the tofu poke bowl. Good size portion. Busy spot when we went. So can be hard to get a table.",
    "image": ""
  },
  {
    "id": "three-sisters-and-the-elephant-rock",
    "name": "Three Sisters and the Elephant Rock",
    "address": "Clifton Road, Tongapōrutu 4378, New Zealand",
    "city": "Clifton Road",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 5,
    "date": "2025-06-26",
    "review": "This time of year it is very muddy. Go prepared. I wore hiking boots and they were great. Cool caves and a good day you can see Mt Taranaki in the backdrop.",
    "questions": [
      {
        "label": "Visited on",
        "value": "Weekend"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Reservation recommended",
        "value": "No"
      }
    ],
    "tags": [
      "Experiences",
      "Clifton Road",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x54cb79af437dbc5e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x54cb79af437dbc5e",
    "maps_embed": "https://www.google.com/maps?q=Three%20Sisters%20and%20the%20Elephant%20Rock%20Clifton%20Road%2C%20Tongap%C5%8Drutu%204378%2C%20New%20Zealand&output=embed",
    "lat": -38.8173717,
    "lng": 174.5912704,
    "seo_title": "Three Sisters and the Elephant Rock Review: Is It Worth A Visit?",
    "seo_description": "This time of year it is very muddy. Go prepared. I wore hiking boots and they were great. Cool caves and a good day you can see Mt Taranaki in the bac…",
    "image": ""
  },
  {
    "id": "skycity-theatre",
    "name": "SkyCity Theatre",
    "address": "Corner Hobson Street and, Wellesley Street West, Auckland 1010, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 1,
    "date": "2025-06-26",
    "review": "Sky city parking price is a joke. We stayed just over 3 hours and were charged $40. There was a delay as the event was longer than we anticipated and we had to wait for the lifts. As well as only one pay machine working on level 4.",
    "questions": [],
    "tags": [
      "Stays",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x75ab990be607c0ec",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x75ab990be607c0ec",
    "maps_embed": "https://www.google.com/maps?q=SkyCity%20Theatre%20Corner%20Hobson%20Street%20and%2C%20Wellesley%20Street%20West%2C%20Auckland%201010%2C%20New%20Zealand&output=embed",
    "lat": -36.8496403,
    "lng": 174.7611791,
    "seo_title": "SkyCity Theatre Review: Is It Worth A Visit?",
    "seo_description": "Sky city parking price is a joke. We stayed just over 3 hours and were charged $40. There was a delay as the event was longer than we anticipated and …",
    "image": ""
  },
  {
    "id": "brougham-heights-motel-and-apartments",
    "name": "Brougham Heights Motel and Apartments",
    "address": "54 Brougham Street, New Plymouth Central, New Plymouth 4310, New Zealand",
    "city": "New Plymouth",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Apartments",
    "rating": 4,
    "date": "2025-06-26",
    "review": "Giving 4 stars only because the road traffic is quite bad. Earplugs help. The spa bath is great! The lazy boys add a nice touch. Overall the place was pretty roomy",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Location",
        "value": "5/5"
      },
      {
        "label": "Rooms",
        "value": "Decent size room"
      },
      {
        "label": "Walkability",
        "value": "Easy walk into town and the beach front."
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms, Walkability"
      }
    ],
    "tags": [
      "Stays",
      "New Plymouth",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcde16a18dc54f98d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcde16a18dc54f98d",
    "maps_embed": "https://www.google.com/maps?q=Brougham%20Heights%20Motel%20and%20Apartments%2054%20Brougham%20Street%2C%20New%20Plymouth%20Central%2C%20New%20Plymouth%204310%2C%20New%20Zealand&output=embed",
    "lat": -39.059375,
    "lng": 174.0734351,
    "seo_title": "Brougham Heights Motel and Apartments Review: Is It Worth A Visit?",
    "seo_description": "Giving 4 stars only because the road traffic is quite bad. Earplugs help. The spa bath is great! The lazy boys add a nice touch. Overall the place was…",
    "image": ""
  },
  {
    "id": "wairakei-terraces-thermal-health-spa",
    "name": "Wairakei Terraces & Thermal Health Spa",
    "address": "671 Wairakei Drive, Wairakei, Taupō 3384, New Zealand",
    "city": "Taupō",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2025-05-18",
    "review": "Went around 2:30 on a Saturday and wasn’t too busy. People starting coming in a lot around 4:30/5.\nSuch a good spot. A must do if in the area!",
    "questions": [
      {
        "label": "Visited on",
        "value": "Weekday"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Reservation recommended",
        "value": "Not sure"
      }
    ],
    "tags": [
      "Wellness",
      "Taupō",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x99471707fd9bd2bb",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x99471707fd9bd2bb",
    "maps_embed": "https://www.google.com/maps?q=Wairakei%20Terraces%20%26%20Thermal%20Health%20Spa%20671%20Wairakei%20Drive%2C%20Wairakei%2C%20Taup%C5%8D%203384%2C%20New%20Zealand&output=embed",
    "lat": -38.6251017,
    "lng": 176.0894233,
    "seo_title": "Wairakei Terraces & Thermal Health Spa Review: Is It Worth A Visit?",
    "seo_description": "Went around 2:30 on a Saturday and wasn’t too busy. People starting coming in a lot around 4:30/5. Such a good spot. A must do if in the area!",
    "image": ""
  },
  {
    "id": "lake-taupo-motor-inn",
    "name": "Lake Taupo Motor Inn",
    "address": "33 Kaimanawa Street, Taupō 3330, New Zealand",
    "city": "Taupō",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 3,
    "date": "2025-05-18",
    "review": "Unfortunately If you want a goodnight sleep don’t choose the rooms with the spa bath. We had a neighbour filling theirs up at 11:30 and then put the jets on even though it says not to after 10. Also can hear through the walls… very awkward.\nSpa bath was the reason we choose this room and it was really good !!\nThe view was nice but condensation in the morning makes it hard to see.\nGood kitchenette. Staff were friendly. Also if you stay in these rooms, shut the blind in the bathroom at night. You can see right through with the lights on.",
    "questions": [
      {
        "label": "Trip type",
        "value": "Vacation"
      },
      {
        "label": "Travel group",
        "value": "Couple"
      },
      {
        "label": "Rooms",
        "value": "3/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Location",
        "value": "4/5"
      },
      {
        "label": "Rooms",
        "value": "Not sound proof. Shower a bit old but works fine. Spa bath is the best thing about the room"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Rooms"
      }
    ],
    "tags": [
      "Stays",
      "Taupō",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x19d518cc402bc827",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x19d518cc402bc827",
    "maps_embed": "https://www.google.com/maps?q=Lake%20Taupo%20Motor%20Inn%2033%20Kaimanawa%20Street%2C%20Taup%C5%8D%203330%2C%20New%20Zealand&output=embed",
    "lat": -38.6896949,
    "lng": 176.0772931,
    "seo_title": "Lake Taupo Motor Inn Review: Is It Worth A Visit?",
    "seo_description": "Unfortunately If you want a goodnight sleep don’t choose the rooms with the spa bath. We had a neighbour filling theirs up at 11:30 and then put the j…",
    "image": ""
  },
  {
    "id": "thai-food-huntly-restaurant",
    "name": "Thai Food Huntly Restaurant",
    "address": "67 Main Street, Waikato, Huntly 3700, New Zealand",
    "city": "Huntly",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2025-05-18",
    "review": "Lots of yummy options. Cooked by actual Thai people. The little old lady is the cutest. The food was quick and tasted great.\nGood prices.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$10–20"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Vegetarian options",
        "value": "Lots of options"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Huntly",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc247b28b9e5d4010",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc247b28b9e5d4010",
    "maps_embed": "https://www.google.com/maps?q=Thai%20Food%20Huntly%20Restaurant%2067%20Main%20Street%2C%20Waikato%2C%20Huntly%203700%2C%20New%20Zealand&output=embed",
    "lat": -37.557652,
    "lng": 175.1588739,
    "seo_title": "Thai Food Huntly Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Lots of yummy options. Cooked by actual Thai people. The little old lady is the cutest. The food was quick and tasted great. Good prices.",
    "image": ""
  },
  {
    "id": "thai-delight-restaurant-taupo",
    "name": "Thai Delight Restaurant Taupo",
    "address": "19 Tamamutu Street, Taupō 3330, New Zealand",
    "city": "Taupō",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2025-05-18",
    "review": "Would give 5 but the reason for 4 is we ordered a vegetarian meal and asked if it comes with tofu. We were told they can add for no extra price as all the other meals have it. But when we left we realised they charged extra for it. So felt like a very expensive meal.\nOther than that. The food was good and tasted authentic",
    "questions": [
      {
        "label": "Price per person",
        "value": "$30–40"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Noise level",
        "value": "Moderate noise"
      },
      {
        "label": "Wait time",
        "value": "No wait"
      },
      {
        "label": "Seating type",
        "value": "Indoor dining area"
      },
      {
        "label": "Vegetarian options",
        "value": "Yes"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options, Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Taupō",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa2594ee3fd34caee",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa2594ee3fd34caee",
    "maps_embed": "https://www.google.com/maps?q=Thai%20Delight%20Restaurant%20Taupo%2019%20Tamamutu%20Street%2C%20Taup%C5%8D%203330%2C%20New%20Zealand&output=embed",
    "lat": -38.6860342,
    "lng": 176.0712005,
    "seo_title": "Thai Delight Restaurant Taupo Review: Is It Worth A Visit?",
    "seo_description": "Would give 5 but the reason for 4 is we ordered a vegetarian meal and asked if it comes with tofu. We were told they can add for no extra price as all…",
    "image": ""
  },
  {
    "id": "jin-jin",
    "name": "Jin Jin",
    "address": "44 Matakana Valley Road, Matakana 0985, New Zealand",
    "city": "Matakana",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2025-02-09",
    "review": "Really beautiful place with nice staff who are attentive. Has a few option for vegan food. Good potion size. I think the bao buns were a little dry not sure if it’s because we waited a bit until others got their food ? But the rest of the food tasted  fresh and full of flavour.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$30–40"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Recommended dishes",
        "value": "Vegan"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options available"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Matakana",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x920af30705e47f10",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x920af30705e47f10",
    "maps_embed": "https://www.google.com/maps?q=Jin%20Jin%2044%20Matakana%20Valley%20Road%2C%20Matakana%200985%2C%20New%20Zealand&output=embed",
    "lat": -36.3507275,
    "lng": 174.7159173,
    "seo_title": "Jin Jin Review: Is It Worth A Visit?",
    "seo_description": "Really beautiful place with nice staff who are attentive. Has a few option for vegan food. Good potion size. I think the bao buns were a little dry no…",
    "image": ""
  },
  {
    "id": "beanee-eatery",
    "name": "BEANEE Eatery",
    "address": "614 Remuera Road, Remuera, Auckland 1050, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2025-01-16",
    "review": "Has a couple of vegan options. I ordered tofu scramble. Was pretty good. Giving a 4 because I like when I order something it comes already made not me having to assemble it. I also don’t like having to go up to the counter and order/prepay because it takes away from conversations with friends.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$20–30"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "3/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Recommended dishes",
        "value": "Vegan"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan options"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x64a6aaf0a4d4c99a",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x64a6aaf0a4d4c99a",
    "maps_embed": "https://www.google.com/maps?q=BEANEE%20Eatery%20614%20Remuera%20Road%2C%20Remuera%2C%20Auckland%201050%2C%20New%20Zealand&output=embed",
    "lat": -36.8801954,
    "lng": 174.8120503,
    "seo_title": "BEANEE Eatery Review: Is It Worth A Visit?",
    "seo_description": "Has a couple of vegan options. I ordered tofu scramble. Was pretty good. Giving a 4 because I like when I order something it comes already made not me…",
    "image": ""
  },
  {
    "id": "meta-headquarters",
    "name": "Meta Headquarters",
    "address": "1 Hacker Wy, Menlo Park, CA 94025, United States",
    "city": "Menlo Park",
    "country": "",
    "country_code": "",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 1,
    "date": "2024-12-27",
    "review": "Facebook disabled my account because i was sending photos to my sister who is 17 photos of when she was a baby and one was in the shower can’t see nothing either. Now they saying something like child sexual exploitation. It’s so disgusting. She’s my dam sister. And you guys should know that with all the info you have about me. I’ve been waiting since September 18th for my account to be given back. Sad how you treat your long standing customers.",
    "questions": [],
    "tags": [
      "Experiences",
      "Menlo Park",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x64979e438bf4e3a5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x64979e438bf4e3a5",
    "maps_embed": "https://www.google.com/maps?q=Meta%20Headquarters%201%20Hacker%20Wy%2C%20Menlo%20Park%2C%20CA%2094025%2C%20United%20States&output=embed",
    "lat": 37.485073,
    "lng": -122.1482824,
    "seo_title": "Meta Headquarters Review: Is It Worth A Visit?",
    "seo_description": "Facebook disabled my account because i was sending photos to my sister who is 17 photos of when she was a baby and one was in the shower can’t see not…",
    "image": ""
  },
  {
    "id": "thai-shack",
    "name": "Thai Shack",
    "address": "7/2 Dominion Road, Tuakau 2121, New Zealand",
    "city": "7/2 Dominion Road",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2024-12-22",
    "review": "They do vegan options. So instead of the meat they use tofu. You just need to ask as it’s not on the menu. So pretty much all the meals can be vegan. Good size portions.",
    "questions": [
      {
        "label": "Order type",
        "value": "Take out"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$40–50"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Dietary restrictions",
        "value": "Vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Dietary restrictions"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "7/2 Dominion Road",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1bd1785daef1dde0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1bd1785daef1dde0",
    "maps_embed": "https://www.google.com/maps?q=Thai%20Shack%207/2%20Dominion%20Road%2C%20Tuakau%202121%2C%20New%20Zealand&output=embed",
    "lat": -37.2569418,
    "lng": 174.9482387,
    "seo_title": "Thai Shack Review: Is It Worth A Visit?",
    "seo_description": "They do vegan options. So instead of the meat they use tofu. You just need to ask as it’s not on the menu. So pretty much all the meals can be vegan. …",
    "image": ""
  },
  {
    "id": "a1-first-aid",
    "name": "A1 First Aid",
    "address": "9 Waipareira Avenue, Henderson, Auckland 0610, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 5,
    "date": "2024-10-29",
    "review": "I have to admit, I was dreading my first aid course at first. However, I was pleasantly surprised to find that I really enjoyed it! Kat made the experience incredibly engaging, which helped me stay focused and absorb the information much better than I usually do—I tend to zone out easily. I had a fantastic day and didn’t even find myself counting down the time. Thanks again, Kat, for sharing your knowledge and making first aid fun for the first time in my life! I hope this review helps you get that well-deserved pay rise!",
    "questions": [],
    "tags": [
      "Experiences",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1bf7538187fb9aa2",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1bf7538187fb9aa2",
    "maps_embed": "https://www.google.com/maps?q=A1%20First%20Aid%209%20Waipareira%20Avenue%2C%20Henderson%2C%20Auckland%200610%2C%20New%20Zealand&output=embed",
    "lat": -36.8637469,
    "lng": 174.6327822,
    "seo_title": "A1 First Aid Review: Is It Worth A Visit?",
    "seo_description": "I have to admit, I was dreading my first aid course at first. However, I was pleasantly surprised to find that I really enjoyed it! Kat made the exper…",
    "image": ""
  },
  {
    "id": "centennial-park",
    "name": "Centennial Park",
    "address": "Springfield, Rotorua 3015, New Zealand",
    "city": "Rotorua",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 5,
    "date": "2024-09-20",
    "review": "Perfect time to see the cherry blossoms ! Lovely spot.",
    "questions": [],
    "tags": [
      "Experiences",
      "Rotorua",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb03c12bbd1bacaef",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb03c12bbd1bacaef",
    "maps_embed": "https://www.google.com/maps?q=Centennial%20Park%20Springfield%2C%20Rotorua%203015%2C%20New%20Zealand&output=embed",
    "lat": -38.1689307,
    "lng": 176.2430807,
    "seo_title": "Centennial Park Review: Is It Worth A Visit?",
    "seo_description": "Perfect time to see the cherry blossoms ! Lovely spot.",
    "image": ""
  },
  {
    "id": "bailwalg-pure-vegetarian-restaurant",
    "name": "BailwalG pure vegetarian restaurant",
    "address": "1229 Tutanekai Street, Rotorua 3010, New Zealand",
    "city": "Rotorua",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 4,
    "date": "2024-09-20",
    "review": "So many options !\nI asked for no spice. But it was very spicy for me so be warned. Good portions and nice staff",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$30–40"
      },
      {
        "label": "Vegetarian options",
        "value": "Everything is vegetarian. Vegan options too. They ask if you are vegan which is nice"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Rotorua",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x288ee9ac001a8761",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x288ee9ac001a8761",
    "maps_embed": "https://www.google.com/maps?q=BailwalG%20pure%20vegetarian%20restaurant%201229%20Tutanekai%20Street%2C%20Rotorua%203010%2C%20New%20Zealand&output=embed",
    "lat": -38.1372339,
    "lng": 176.2513182,
    "seo_title": "BailwalG pure vegetarian restaurant Review: Is It Worth A Visit?",
    "seo_description": "So many options ! I asked for no spice. But it was very spicy for me so be warned. Good portions and nice staff",
    "image": ""
  },
  {
    "id": "hell-s-gate-geothermal-reserve-and-mud-spa",
    "name": "Hell's Gate Geothermal Reserve and Mud Spa",
    "address": "351 State Highway 30, Tikitere, Rotorua 3010, New Zealand",
    "city": "Rotorua",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2024-09-20",
    "review": "Lovely staff all very welcoming !\nSuch an awesome experience. A must if you are in Rotorua ! ♥️",
    "questions": [],
    "tags": [
      "Wellness",
      "Rotorua",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xadcfa9fc1a18a20d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xadcfa9fc1a18a20d",
    "maps_embed": "https://www.google.com/maps?q=Hell%27s%20Gate%20Geothermal%20Reserve%20and%20Mud%20Spa%20351%20State%20Highway%2030%2C%20Tikitere%2C%20Rotorua%203010%2C%20New%20Zealand&output=embed",
    "lat": -38.0648369,
    "lng": 176.3608057,
    "seo_title": "Hell's Gate Geothermal Reserve and Mud Spa Review: Is It Worth A Visit?",
    "seo_description": "Lovely staff all very welcoming ! Such an awesome experience. A must if you are in Rotorua ! ♥️",
    "image": ""
  },
  {
    "id": "saigon-60s-vietnamese-cuisine",
    "name": "Saigon '60s Vietnamese Cuisine",
    "address": "1205 Fenton Street, Rotorua 3010, New Zealand",
    "city": "Rotorua",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2024-09-20",
    "review": "I liked they had vegan options. Which tasted really fresh. The deep fried springs rolls were a bit overpriced for the size but tasted good. We didn’t eat everything so asked for a takeaway container which they charged $1 for a cardboard box. No where else I’ve been has charged. Didn’t find staff to be too friendly. I lived in Vietnam and I know their culture is so welcoming. Still would recommend.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$50–60"
      },
      {
        "label": "Food",
        "value": "4/5"
      },
      {
        "label": "Service",
        "value": "3/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      },
      {
        "label": "Vegetarian options",
        "value": "Lots of tofu dishes"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Rotorua",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe73f33b002477bb6",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe73f33b002477bb6",
    "maps_embed": "https://www.google.com/maps?q=Saigon%20%2760s%20Vietnamese%20Cuisine%201205%20Fenton%20Street%2C%20Rotorua%203010%2C%20New%20Zealand&output=embed",
    "lat": -38.1364022,
    "lng": 176.2535032,
    "seo_title": "Saigon '60s Vietnamese Cuisine Review: Is It Worth A Visit?",
    "seo_description": "I liked they had vegan options. Which tasted really fresh. The deep fried springs rolls were a bit overpriced for the size but tasted good. We didn’t …",
    "image": ""
  },
  {
    "id": "burger-king-henderson",
    "name": "Burger King Henderson",
    "address": "155 Lincoln Road, Henderson, Auckland 0610, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 1,
    "date": "2024-05-04",
    "review": "Took 10 minutes to get a burnt vegan burger. Tried to tell me it’s meant to be like that. Come on guys !",
    "questions": [
      {
        "label": "Food",
        "value": "1/5"
      },
      {
        "label": "Service",
        "value": "1/5"
      },
      {
        "label": "Atmosphere",
        "value": "1/5"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xee6cd07844bd8f67",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xee6cd07844bd8f67",
    "maps_embed": "https://www.google.com/maps?q=Burger%20King%20Henderson%20155%20Lincoln%20Road%2C%20Henderson%2C%20Auckland%200610%2C%20New%20Zealand&output=embed",
    "lat": -36.8630816,
    "lng": 174.6296841,
    "seo_title": "Burger King Henderson Review: Is It Worth A Visit?",
    "seo_description": "Took 10 minutes to get a burnt vegan burger. Tried to tell me it’s meant to be like that. Come on guys !",
    "image": ""
  },
  {
    "id": "one-nz-st-lukes",
    "name": "One NZ St Lukes",
    "address": "Shop 610/80 Saint Lukes Road, Mount Albert, Auckland 1025, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 1,
    "date": "2023-11-07",
    "review": "The guy helping me had no idea what he was doing. He couldn’t even eject my sim. Not sure if it was his first day or not but didn’t say. I wanted to swap to one from spark. Not worth it. I’ve now spent 30 mins trying to set up a plan because they don’t do it in the shop",
    "questions": [],
    "tags": [
      "Wellness",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4827437826ed371",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4827437826ed371",
    "maps_embed": "https://www.google.com/maps?q=One%20NZ%20St%20Lukes%20Shop%20610/80%20Saint%20Lukes%20Road%2C%20Mount%20Albert%2C%20Auckland%201025%2C%20New%20Zealand&output=embed",
    "lat": -36.8827071,
    "lng": 174.733162,
    "seo_title": "One NZ St Lukes Review: Is It Worth A Visit?",
    "seo_description": "The guy helping me had no idea what he was doing. He couldn’t even eject my sim. Not sure if it was his first day or not but didn’t say. I wanted to s…",
    "image": ""
  },
  {
    "id": "ethos-vegetarian-vegan-restaurant",
    "name": "Ethos Vegetarian & Vegan Restaurant",
    "address": "85/2 Thanon Tanao, Wat Bowon Niwet, Phra Nakhon, Bangkok 10200, Thailand",
    "city": "Bangkok",
    "country": "Thailand",
    "country_code": "TH",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 2,
    "date": "2023-09-04",
    "review": "Food was not great especially for the price you pay. Staff weren’t that friendly. Pretty disappointed. Only nice thing was how the restaurant looked",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "฿200–300"
      },
      {
        "label": "Food",
        "value": "2/5"
      },
      {
        "label": "Service",
        "value": "2/5"
      },
      {
        "label": "Atmosphere",
        "value": "3/5"
      }
    ],
    "tags": [
      "Practical Finds",
      "Bangkok",
      "Thailand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5b248f9b39612626",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5b248f9b39612626",
    "maps_embed": "https://www.google.com/maps?q=Ethos%20Vegetarian%20%26%20Vegan%20Restaurant%2085/2%20Thanon%20Tanao%2C%20Wat%20Bowon%20Niwet%2C%20Phra%20Nakhon%2C%20Bangkok%2010200%2C%20Thailand&output=embed",
    "lat": 13.7585887,
    "lng": 100.4994116,
    "seo_title": "Ethos Vegetarian & Vegan Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Food was not great especially for the price you pay. Staff weren’t that friendly. Pretty disappointed. Only nice thing was how the restaurant looked",
    "image": ""
  },
  {
    "id": "golden-fingers-massage",
    "name": "Golden Fingers Massage",
    "address": "10, 114 Soi Ta-iad, Chalong, Amphoe Mueang Phuket, Phuket 83000, Thailand",
    "city": "Phuket",
    "country": "Thailand",
    "country_code": "TH",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2023-07-18",
    "review": "Had an oil massage for 350 baht. Really good pressure.",
    "questions": [],
    "tags": [
      "Wellness",
      "Phuket",
      "Thailand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x882645a088b3b530",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x882645a088b3b530",
    "maps_embed": "https://www.google.com/maps?q=Golden%20Fingers%20Massage%2010%2C%20114%20Soi%20Ta-iad%2C%20Chalong%2C%20Amphoe%20Mueang%20Phuket%2C%20Phuket%2083000%2C%20Thailand&output=embed",
    "lat": 7.8532473,
    "lng": 98.3458172,
    "seo_title": "Golden Fingers Massage Review: Is It Worth A Visit?",
    "seo_description": "Had an oil massage for 350 baht. Really good pressure.",
    "image": ""
  },
  {
    "id": "talay-the-little-spoon",
    "name": "TALAY The Little Spoon",
    "address": "The Little Spoon, 10/124 TALAY, Soi Ta-iad, Chalong, Mueang Phuket District, Phuket 83130, Thailand",
    "city": "Phuket",
    "country": "Thailand",
    "country_code": "TH",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2023-07-18",
    "review": "Really good value for what you get. I couldn’t finish eating the medium size it was a lot. 250 baht. Smaller size is 200. The great thing is they are all the same price no matter what you choose. Just changes price for the size",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "฿200–300"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Vegetarian options",
        "value": "All are vegan"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Phuket",
      "Thailand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc27e1203b1160ed6",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc27e1203b1160ed6",
    "maps_embed": "https://www.google.com/maps?q=TALAY%20The%20Little%20Spoon%20The%20Little%20Spoon%2C%2010/124%20TALAY%2C%20Soi%20Ta-iad%2C%20Chalong%2C%20Mueang%20Phuket%20District%2C%20Phuket%2083130%2C%20Thailand&output=embed",
    "lat": 7.8540278,
    "lng": 98.3448652,
    "seo_title": "TALAY The Little Spoon Review: Is It Worth A Visit?",
    "seo_description": "Really good value for what you get. I couldn’t finish eating the medium size it was a lot. 250 baht. Smaller size is 200. The great thing is they are …",
    "image": ""
  },
  {
    "id": "eddy-lebanese-cuisine",
    "name": "Eddy Lebanese cuisine",
    "address": "204 Dalhousie St, Ottawa, ON K1N 7C8, Canada",
    "city": "Ottawa",
    "country": "Canada",
    "country_code": "CA",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2023-07-18",
    "review": "Vegan options. Tasted great. Really nice guy",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$1–10"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "4/5"
      },
      {
        "label": "Vegetarian options",
        "value": "Some small vegan pizza bread for reasonable price"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Ottawa",
      "Canada",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x86f869e0d7db05e6",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x86f869e0d7db05e6",
    "maps_embed": "https://www.google.com/maps?q=Eddy%20Lebanese%20cuisine%20204%20Dalhousie%20St%2C%20Ottawa%2C%20ON%20K1N%207C8%2C%20Canada&output=embed",
    "lat": 45.4319044,
    "lng": -75.6939398,
    "seo_title": "Eddy Lebanese cuisine Review: Is It Worth A Visit?",
    "seo_description": "Vegan options. Tasted great. Really nice guy",
    "image": ""
  },
  {
    "id": "restaurante-skr-sakura-ramen-bar",
    "name": "Restaurante SKR -Sakura Ramen Bar-",
    "address": "Cra 10 #96-55, Chapinero, Bogotá, Cundinamarca, Colombia",
    "city": "Bogotá",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2023-06-22",
    "review": "I had the vegan ramen. It tasted great. Sadly, it cost extra for tofu and was the same price as the ramen with meat. This was quite an expensive meal hence why I’m giving only 4 stars. I asked for table water and didn’t even get that.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$30,000–40,000"
      },
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "4/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      },
      {
        "label": "Vegetarian options",
        "value": "One vegan ramen"
      },
      {
        "label": "Can you share more about these topics?",
        "value": "Vegetarian options"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Bogotá",
      "Colombia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7339fd1aa3cf93f7",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7339fd1aa3cf93f7",
    "maps_embed": "https://www.google.com/maps?q=Restaurante%20SKR%20-Sakura%20Ramen%20Bar-%20Cra%2010%20%2396-55%2C%20Chapinero%2C%20Bogot%C3%A1%2C%20Cundinamarca%2C%20Colombia&output=embed",
    "lat": 4.6794137,
    "lng": -74.0441693,
    "seo_title": "Restaurante SKR -Sakura Ramen Bar- Review: Is It Worth A Visit?",
    "seo_description": "I had the vegan ramen. It tasted great. Sadly, it cost extra for tofu and was the same price as the ramen with meat. This was quite an expensive meal …",
    "image": ""
  },
  {
    "id": "la-jungla",
    "name": "La Jungla",
    "address": "Cl 35 #27 - 94, Mejoras Públicas, Bucaramanga, Santander, Colombia",
    "city": "Bucaramanga",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 5,
    "date": "2023-06-22",
    "review": "Great vegan spot with a great menu of the day for only 15,000 pesos. Came here nearly everyday of our stay. Quick to come out and nice friendly staff. Also there cakes are delicious and a must try.",
    "questions": [
      {
        "label": "Food",
        "value": "5/5"
      },
      {
        "label": "Service",
        "value": "5/5"
      },
      {
        "label": "Atmosphere",
        "value": "5/5"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Bucaramanga",
      "Colombia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa6e3b825435ebfa4",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa6e3b825435ebfa4",
    "maps_embed": "https://www.google.com/maps?q=La%20Jungla%20Cl%2035%20%2327%20-%2094%2C%20Mejoras%20P%C3%BAblicas%2C%20Bucaramanga%2C%20Santander%2C%20Colombia&output=embed",
    "lat": 7.1225691,
    "lng": -73.1158286,
    "seo_title": "La Jungla Review: Is It Worth A Visit?",
    "seo_description": "Great vegan spot with a great menu of the day for only 15,000 pesos. Came here nearly everyday of our stay. Quick to come out and nice friendly staff.…",
    "image": ""
  },
  {
    "id": "charcuter-a-estilo-gourmet",
    "name": "Charcutería Estilo Gourmet",
    "address": "Cl. 6 #10-98, Barichara, Santander, Colombia",
    "city": "Barichara",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-06-09",
    "review": "Cute spot with some good vegan options.\nOrdered the pizza which was very wholesome. It was a bit soft so couldn’t eat with hands. And it seemed to have different ingredients than what was written on the menu but had lots of flavour. I wasn’t a fan of the vegan cheese and would have preferred the tofu.\nOverall lovely vibe and nice staff.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$10,000–20,000"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Barichara",
      "Colombia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9b2845e265e26297",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9b2845e265e26297",
    "maps_embed": "https://www.google.com/maps?q=Charcuter%C3%ADa%20Estilo%20Gourmet%20Cl.%206%20%2310-98%2C%20Barichara%2C%20Santander%2C%20Colombia&output=embed",
    "lat": 6.6394557,
    "lng": -73.2231835,
    "seo_title": "Charcutería Estilo Gourmet Review: Is It Worth A Visit?",
    "seo_description": "Cute spot with some good vegan options. Ordered the pizza which was very wholesome. It was a bit soft so couldn’t eat with hands. And it seemed to hav…",
    "image": ""
  },
  {
    "id": "transportation-terminal-san-gil",
    "name": "Transportation Terminal San Gil",
    "address": "vía San, Avenida tander, Socorro Santander, San Gil, Santander, Colombia",
    "city": "San Gil",
    "country": "Colombia",
    "country_code": "",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 1,
    "date": "2023-06-09",
    "review": "Do not book with omega bus.\nThey lied on their website saying 12pm. When we keep asking the lady where the bus is she says wait a little more. When I finally go to her after 40 mins she tells me it’s coming at 1 and the website is wrong. I ask for my money back so I can take another bus but she told me they aren’t responsible for that",
    "questions": [],
    "tags": [
      "Wellness",
      "San Gil",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9eba75095943211",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9eba75095943211",
    "maps_embed": "https://www.google.com/maps?q=Transportation%20Terminal%20San%20Gil%20v%C3%ADa%20San%2C%20Avenida%20tander%2C%20Socorro%20Santander%2C%20San%20Gil%2C%20Santander%2C%20Colombia&output=embed",
    "lat": 6.5543997,
    "lng": -73.1489779,
    "seo_title": "Transportation Terminal San Gil Review: Is It Worth A Visit?",
    "seo_description": "Do not book with omega bus. They lied on their website saying 12pm. When we keep asking the lady where the bus is she says wait a little more. When I …",
    "image": ""
  },
  {
    "id": "barracuda-dive-center",
    "name": "Barracuda Dive Center",
    "address": "Cl. 14 #1b-12, Taganga, Santa Marta, Magdalena, Colombia",
    "city": "Santa Marta",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Beaches & Nature",
    "subcategory": "Nature & Attractions",
    "rating": 2,
    "date": "2023-06-03",
    "review": "Not very impressed with the organisation. Did a dive and they made us wear our hot wetsuit while we waited for an hour for everyone to get ready. One lady was doing all the work while the owner was fixing something. When it came to diving my regulator was disgusting, filled with orange gunk. The dive instructor tried cleaning it for me so gross. Overall we weren’t even told the dive spots or what we should expect to see. I’ve dove in 8 different countries and this is the worst experience I ever had.\nPs. Did a snorkel trip with another company the next day and saw more than I did on my dive",
    "questions": [],
    "tags": [
      "Beaches & Nature",
      "Santa Marta",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x597492da29b9671e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x597492da29b9671e",
    "maps_embed": "https://www.google.com/maps?q=Barracuda%20Dive%20Center%20Cl.%2014%20%231b-12%2C%20Taganga%2C%20Santa%20Marta%2C%20Magdalena%2C%20Colombia&output=embed",
    "lat": 11.2673693,
    "lng": -74.1910302,
    "seo_title": "Barracuda Dive Center Review: Is It Worth A Visit?",
    "seo_description": "Not very impressed with the organisation. Did a dive and they made us wear our hot wetsuit while we waited for an hour for everyone to get ready. One …",
    "image": ""
  },
  {
    "id": "smash-avocaderia-manila",
    "name": "Smash Avocaderia Manila",
    "address": "Cl. 14 #43d - 79, El Poblado, Medellín, El Poblado, Medellín, Antioquia, Colombia",
    "city": "Medellín",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2023-06-02",
    "review": "Yummy vegan pancakes. Layered with bananas and strawberries. Nice cute place to have brunch and a coffee. This place offers Indoor and outdoor seating. Cute vibe overall and a few options for vegans",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Medellín",
      "Colombia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x86864c2a094bc39e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x86864c2a094bc39e",
    "maps_embed": "https://www.google.com/maps?q=Smash%20Avocaderia%20Manila%20Cl.%2014%20%2343d%20-%2079%2C%20El%20Poblado%2C%20Medell%C3%ADn%2C%20El%20Poblado%2C%20Medell%C3%ADn%2C%20Antioquia%2C%20Colombia&output=embed",
    "lat": 6.214745,
    "lng": -75.5719885,
    "seo_title": "Smash Avocaderia Manila Review: Is It Worth A Visit?",
    "seo_description": "Yummy vegan pancakes. Layered with bananas and strawberries. Nice cute place to have brunch and a coffee. This place offers Indoor and outdoor seating…",
    "image": ""
  },
  {
    "id": "gokela-centro",
    "name": "Gokela Centro",
    "address": "Cra. 9 #8-70, San Diego, Cartagena de Indias, Bolívar, Colombia",
    "city": "Cartagena",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 2,
    "date": "2023-06-02",
    "review": "Small size and over priced.\nPretty generic food. But managed to get a vegan wrap. Was still hungry after. Tables needed to be cleaned also",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Cartagena",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6eaa305241dc9c80",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6eaa305241dc9c80",
    "maps_embed": "https://www.google.com/maps?q=Gokela%20Centro%20Cra.%209%20%238-70%2C%20San%20Diego%2C%20Cartagena%20de%20Indias%2C%20Bol%C3%ADvar%2C%20Colombia&output=embed",
    "lat": 10.4267145,
    "lng": -75.5473873,
    "seo_title": "Gokela Centro Review: Is It Worth A Visit?",
    "seo_description": "Small size and over priced. Pretty generic food. But managed to get a vegan wrap. Was still hungry after. Tables needed to be cleaned also",
    "image": ""
  },
  {
    "id": "la-brioche-centro-hist-rico",
    "name": "LA BRIOCHE Centro Histórico",
    "address": "Cl. 36 #6106, El Centro, Cartagena de Indias, Bolívar, Colombia",
    "city": "Cartagena",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2023-06-02",
    "review": "Bought some pastries and coffee. Coffee was decent as well as the food we ate. Good spot to chill and nice staff",
    "questions": [
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$10,000–20,000"
      },
      {
        "label": "Recommended dishes",
        "value": "Pastries"
      }
    ],
    "tags": [
      "Food & Drink",
      "Cartagena",
      "Colombia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x65c8d2414ed5dbfa",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x65c8d2414ed5dbfa",
    "maps_embed": "https://www.google.com/maps?q=LA%20BRIOCHE%20Centro%20Hist%C3%B3rico%20Cl.%2036%20%236106%2C%20El%20Centro%2C%20Cartagena%20de%20Indias%2C%20Bol%C3%ADvar%2C%20Colombia&output=embed",
    "lat": 10.4251858,
    "lng": -75.5494359,
    "seo_title": "LA BRIOCHE Centro Histórico Review: Is It Worth A Visit?",
    "seo_description": "Bought some pastries and coffee. Coffee was decent as well as the food we ate. Good spot to chill and nice staff",
    "image": ""
  },
  {
    "id": "fit-choices",
    "name": "Fit Choices",
    "address": "Cra. 3 # 7 -160, Cartagena de Indias, Bolívar, Colombia",
    "city": "Cartagena",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-06-02",
    "review": "Options for vegans. Was happy with my choice and the drink was great. Downside was we had to sit up stairs and the aircon took awhile to work. Food did take some time to come and was a pricey. But overall tasted good.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Cartagena",
      "Colombia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x10eb40d04bb3adb5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x10eb40d04bb3adb5",
    "maps_embed": "https://www.google.com/maps?q=Fit%20Choices%20Cra.%203%20%23%207%20-160%2C%20Cartagena%20de%20Indias%2C%20Bol%C3%ADvar%2C%20Colombia&output=embed",
    "lat": 10.4027365,
    "lng": -75.5542441,
    "seo_title": "Fit Choices Review: Is It Worth A Visit?",
    "seo_description": "Options for vegans. Was happy with my choice and the drink was great. Downside was we had to sit up stairs and the aircon took awhile to work. Food di…",
    "image": ""
  },
  {
    "id": "ahito",
    "name": "Ahito",
    "address": "Cl Larga #10-39, Getsemaní, Cartagena de Indias, Bolívar, Colombia",
    "city": "Cartagena",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Practical Finds",
    "subcategory": "ATM",
    "rating": 4,
    "date": "2023-06-02",
    "review": "I had the açai bowl with assorted fruit. Tasted good and came quick enough. Nice atmosphere with cool tables. Only 4 stars as it was little expensive.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$20,000–30,000"
      },
      {
        "label": "Recommended dishes",
        "value": "Acaibowl"
      }
    ],
    "tags": [
      "Practical Finds",
      "Cartagena",
      "Colombia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfdb7b7636cc5b8b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfdb7b7636cc5b8b",
    "maps_embed": "https://www.google.com/maps?q=Ahito%20Cl%20Larga%20%2310-39%2C%20Getseman%C3%AD%2C%20Cartagena%20de%20Indias%2C%20Bol%C3%ADvar%2C%20Colombia&output=embed",
    "lat": 10.4190748,
    "lng": -75.5464229,
    "seo_title": "Ahito Review: Is It Worth A Visit?",
    "seo_description": "I had the açai bowl with assorted fruit. Tasted good and came quick enough. Nice atmosphere with cool tables. Only 4 stars as it was little expensive.",
    "image": ""
  },
  {
    "id": "el-punto-marino",
    "name": "El Punto Marino",
    "address": "Carrera 1 calle 11 esquina Carrera 1 #11-01, Santa Marta, Magdalena, Colombia",
    "city": "Santa Marta",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 1,
    "date": "2023-06-02",
    "review": "CHECK YOUR BILLS.\nThey write a different number for the bill total then what it actually equals. When we paid I wondered why it was so expensive and ask to see the receipt. She had to go write one. But the number at the bottom was not right. I added it up and showed her it was incorrect. She then continued to pretend to add it up wrong. The bill should have only been 55.65 with the 5% surcharge. But she made us pay 63. I couldn’t be bothered arguing because I didn’t want to create drama. Just do your own math. Ordered an orange juice thinking it would be fresh. It was from a bottle. Was able to make a vegan meal with the side dishes and vegetarian meal. Good view but still get harassed by people trying to sell stuff.",
    "questions": [
      {
        "label": "Price per person",
        "value": "$20,000–30,000"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Santa Marta",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc81462abe6413406",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc81462abe6413406",
    "maps_embed": "https://www.google.com/maps?q=El%20Punto%20Marino%20Carrera%201%20calle%2011%20esquina%20Carrera%201%20%2311-01%2C%20Santa%20Marta%2C%20Magdalena%2C%20Colombia&output=embed",
    "lat": 11.2021069,
    "lng": -74.2275995,
    "seo_title": "El Punto Marino Review: Is It Worth A Visit?",
    "seo_description": "CHECK YOUR BILLS. They write a different number for the bill total then what it actually equals. When we paid I wondered why it was so expensive and a…",
    "image": ""
  },
  {
    "id": "cafe-del-mar-taganga",
    "name": "Cafe del mar Taganga",
    "address": "Cra. 1 #16-09, Taganga, Santa Marta, Magdalena, Colombia",
    "city": "Santa Marta",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 4,
    "date": "2023-06-02",
    "review": "Menú del día for vegans. Simple but wholesome meals for 20 pesos. The music is quite loud there so if you’re looking for a nice spot to chill and talk then maybe this isn’t the one. But the guy who makes the meal is super friendly and is very accommodating",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$10,000–20,000"
      }
    ],
    "tags": [
      "Vegan options",
      "Practical Finds",
      "Santa Marta",
      "Colombia",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5bdd78809e5aa934",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5bdd78809e5aa934",
    "maps_embed": "https://www.google.com/maps?q=Cafe%20del%20mar%20Taganga%20Cra.%201%20%2316-09%2C%20Taganga%2C%20Santa%20Marta%2C%20Magdalena%2C%20Colombia&output=embed",
    "lat": 11.2667373,
    "lng": -74.1911224,
    "seo_title": "Cafe del mar Taganga Review: Is It Worth A Visit?",
    "seo_description": "Menú del día for vegans. Simple but wholesome meals for 20 pesos. The music is quite loud there so if you’re looking for a nice spot to chill and talk…",
    "image": ""
  },
  {
    "id": "albahaca",
    "name": "Albahaca",
    "address": "Cra 34 #54 - 113, Cabecera del llano, Bucaramanga, Santander, Colombia",
    "city": "Bucaramanga",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Beaches & Nature",
    "subcategory": "Hikes",
    "rating": 5,
    "date": "2023-06-02",
    "review": "Great portion sizes. Paid 22 pesos for this large plate. Was very impressed with all of the wonderful flavours and the amount of different vegetables. Great place for vegans many choices on the menu.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$20,000–30,000"
      }
    ],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "Bucaramanga",
      "Colombia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe85f4ffce88bb712",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe85f4ffce88bb712",
    "maps_embed": "https://www.google.com/maps?q=Albahaca%20Cra%2034%20%2354%20-%20113%2C%20Cabecera%20del%20llano%2C%20Bucaramanga%2C%20Santander%2C%20Colombia&output=embed",
    "lat": 7.1101521,
    "lng": -73.1091887,
    "seo_title": "Albahaca Review: Is It Worth A Visit?",
    "seo_description": "Great portion sizes. Paid 22 pesos for this large plate. Was very impressed with all of the wonderful flavours and the amount of different vegetables.…",
    "image": ""
  },
  {
    "id": "ikaro-cafe",
    "name": "Ikaro Cafe",
    "address": "Cl. 19 #3-60, Comuna 2, Santa Marta, Magdalena, Colombia",
    "city": "Santa Marta",
    "country": "Colombia",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2023-05-23",
    "review": "Really nice vibe with places to even lay down. Good choice of vegan options that left me feeling full. Only thing was they made my coffee super milky but when I ask for stronger they did.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Santa Marta",
      "Colombia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x85f30525bf059bcc",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x85f30525bf059bcc",
    "maps_embed": "https://www.google.com/maps?q=Ikaro%20Cafe%20Cl.%2019%20%233-60%2C%20Comuna%202%2C%20Santa%20Marta%2C%20Magdalena%2C%20Colombia&output=embed",
    "lat": 11.2422558,
    "lng": -74.2123753,
    "seo_title": "Ikaro Cafe Review: Is It Worth A Visit?",
    "seo_description": "Really nice vibe with places to even lay down. Good choice of vegan options that left me feeling full. Only thing was they made my coffee super milky …",
    "image": ""
  },
  {
    "id": "saludpan",
    "name": "Saludpan",
    "address": "Cq. 4 #7084, Laureles - Estadio, Medellín, Laureles, Medellín, Antioquia, Colombia",
    "city": "Medellín",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 2,
    "date": "2023-05-16",
    "review": "Ordered the meal of the day - raw as I’m vegan. The soup did not taste good and was cold with a weird texture. The lunch was better but just vegetables. The desert was too sweet and did taste like it had butter in it. Both my partner and I felt sick after",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$10,000–20,000"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Medellín",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa373bfec2dce8dbe",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa373bfec2dce8dbe",
    "maps_embed": "https://www.google.com/maps?q=Saludpan%20Cq.%204%20%237084%2C%20Laureles%20-%20Estadio%2C%20Medell%C3%ADn%2C%20Laureles%2C%20Medell%C3%ADn%2C%20Antioquia%2C%20Colombia&output=embed",
    "lat": 6.2465715,
    "lng": -75.5900982,
    "seo_title": "Saludpan Review: Is It Worth A Visit?",
    "seo_description": "Ordered the meal of the day - raw as I’m vegan. The soup did not taste good and was cold with a weird texture. The lunch was better but just vegetable…",
    "image": ""
  },
  {
    "id": "vegarden-el-jard-n-de-las-delicias",
    "name": "Vegarden El Jardín de las Delicias",
    "address": "Cl. 32B #81-41, Medellín, Belén, Medellín, Antioquia, Colombia",
    "city": "Medellín",
    "country": "Colombia",
    "country_code": "CO",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 2,
    "date": "2023-05-12",
    "review": "Below average pizza. Ordered on rappi took over 1 hour and when we finally got it the pizza was cold. The pizza it self was very thin. There was a lot of sauces so you couldn’t even pick up one piece without it breaking. Sadly I wouldn’t recommend this place",
    "questions": [
      {
        "label": "Order type",
        "value": "Delivery"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$20,000–30,000"
      }
    ],
    "tags": [
      "Food & Drink",
      "Medellín",
      "Colombia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc71ccb1b8dc4b925",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc71ccb1b8dc4b925",
    "maps_embed": "https://www.google.com/maps?q=Vegarden%20El%20Jard%C3%ADn%20de%20las%20Delicias%20Cl.%2032B%20%2381-41%2C%20Medell%C3%ADn%2C%20Bel%C3%A9n%2C%20Medell%C3%ADn%2C%20Antioquia%2C%20Colombia&output=embed",
    "lat": 6.235239,
    "lng": -75.602651,
    "seo_title": "Vegarden El Jardín de las Delicias Review: Is It Worth A Visit?",
    "seo_description": "Below average pizza. Ordered on rappi took over 1 hour and when we finally got it the pizza was cold. The pizza it self was very thin. There was a lot…",
    "image": ""
  },
  {
    "id": "vegan-beer",
    "name": "Vegan & Beer",
    "address": "Av. Miguel Ángel de Quevedo 966, Parque San Andrés, Coyoacán, 04030 Ciudad de México, CDMX, Mexico",
    "city": "04030 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-03-14",
    "review": "Cute vegan spot upstairs. Lots of options. I had the pasta which they cooked from scratch. My bf had the burger which tasted great.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "04030 Ciudad de México",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xf38cfa816b3b10c5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xf38cfa816b3b10c5",
    "maps_embed": "https://www.google.com/maps?q=Vegan%20%26%20Beer%20Av.%20Miguel%20%C3%81ngel%20de%20Quevedo%20966%2C%20Parque%20San%20Andr%C3%A9s%2C%20Coyoac%C3%A1n%2C%2004030%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.343554,
    "lng": -99.1529379,
    "seo_title": "Vegan & Beer Review: Is It Worth A Visit?",
    "seo_description": "Cute vegan spot upstairs. Lots of options. I had the pasta which they cooked from scratch. My bf had the burger which tasted great.",
    "image": ""
  },
  {
    "id": "soe-vegano",
    "name": "Soe Vegano",
    "address": "C. Atlixco 147, Colonia Condesa, Cuauhtémoc, 06170 Ciudad de México, CDMX, Mexico",
    "city": "06170 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-03-14",
    "review": "Tasty vegan soup for a great price. Nice friendly guy who worked there",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "06170 Ciudad de México",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xf25a824be0dd4fc0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xf25a824be0dd4fc0",
    "maps_embed": "https://www.google.com/maps?q=Soe%20Vegano%20C.%20Atlixco%20147%2C%20Colonia%20Condesa%2C%20Cuauht%C3%A9moc%2C%2006170%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.4098599,
    "lng": -99.1762993,
    "seo_title": "Soe Vegano Review: Is It Worth A Visit?",
    "seo_description": "Tasty vegan soup for a great price. Nice friendly guy who worked there",
    "image": ""
  },
  {
    "id": "bot-nica-granel",
    "name": "Botánica Granel",
    "address": "Fernando Montes de Oca 69, Colonia Condesa, Cuauhtémoc, 06700 Ciudad de México, CDMX, Mexico",
    "city": "06700 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 4,
    "date": "2023-03-14",
    "review": "Very clean and organised. Great for organic products",
    "questions": [],
    "tags": [
      "Experiences",
      "06700 Ciudad de México",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x415c5b4a9eae571e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x415c5b4a9eae571e",
    "maps_embed": "https://www.google.com/maps?q=Bot%C3%A1nica%20Granel%20Fernando%20Montes%20de%20Oca%2069%2C%20Colonia%20Condesa%2C%20Cuauht%C3%A9moc%2C%2006700%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.4136686,
    "lng": -99.1758105,
    "seo_title": "Botánica Granel Review: Is It Worth A Visit?",
    "seo_description": "Very clean and organised. Great for organic products",
    "image": ""
  },
  {
    "id": "vendaval-cooperativa-panadera-canto-caf-espacio",
    "name": "Vendaval Cooperativa Panadera / CANTO Café Espacio",
    "address": "C. Guillermo Prieto 46, San Rafael, Cuauhtémoc, 06470 Ciudad de México, CDMX, Mexico",
    "city": "06470 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 4,
    "date": "2023-03-14",
    "review": "Burgers are great and super cheap. I had the breakfast but it wasn’t as good. Came here 3 times ☺️",
    "questions": [],
    "tags": [
      "Wellness",
      "06470 Ciudad de México",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x74a5ce78f9b550aa",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x74a5ce78f9b550aa",
    "maps_embed": "https://www.google.com/maps?q=Vendaval%20Cooperativa%20Panadera%20/%20CANTO%20Caf%C3%A9%20Espacio%20C.%20Guillermo%20Prieto%2046%2C%20San%20Rafael%2C%20Cuauht%C3%A9moc%2C%2006470%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.43735,
    "lng": -99.1625044,
    "seo_title": "Vendaval Cooperativa Panadera / CANTO Café Espacio Review: Is It Worth A Visit?",
    "seo_description": "Burgers are great and super cheap. I had the breakfast but it wasn’t as good. Came here 3 times ☺️",
    "image": ""
  },
  {
    "id": "boutique-y-bazar-reto-a-la-esperanza",
    "name": "BOUTIQUE Y BAZAR RETO A LA ESPERANZA",
    "address": "Centenario 23, Del Carmen, Coyoacán, 04100 Ciudad de México, CDMX, Mexico",
    "city": "04100 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 4,
    "date": "2023-03-14",
    "review": "Lots of stock. I bought a pair of jeans for just 100 pesos. There is no changing room so have to do it out in the open",
    "questions": [],
    "tags": [
      "Stays",
      "04100 Ciudad de México",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8fa0946826760a1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8fa0946826760a1",
    "maps_embed": "https://www.google.com/maps?q=BOUTIQUE%20Y%20BAZAR%20RETO%20A%20LA%20ESPERANZA%20Centenario%2023%2C%20Del%20Carmen%2C%20Coyoac%C3%A1n%2C%2004100%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.3508567,
    "lng": -99.1637963,
    "seo_title": "BOUTIQUE Y BAZAR RETO A LA ESPERANZA Review: Is It Worth A Visit?",
    "seo_description": "Lots of stock. I bought a pair of jeans for just 100 pesos. There is no changing room so have to do it out in the open",
    "image": ""
  },
  {
    "id": "vege-taco",
    "name": "Vege Taco",
    "address": "Felipe Carrillo Puerto 65, Coyoacán, 04000 Ciudad de México, CDMX, Mexico",
    "city": "04000 Ciudad de México",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-03-14",
    "review": "Lots of vegan options for great price.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "04000 Ciudad de México",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5f8b771b867fbcde",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5f8b771b867fbcde",
    "maps_embed": "https://www.google.com/maps?q=Vege%20Taco%20Felipe%20Carrillo%20Puerto%2065%2C%20Coyoac%C3%A1n%2C%2004000%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX%2C%20Mexico&output=embed",
    "lat": 19.3461002,
    "lng": -99.1639628,
    "seo_title": "Vege Taco Review: Is It Worth A Visit?",
    "seo_description": "Lots of vegan options for great price.",
    "image": ""
  },
  {
    "id": "el-rinc-n-de-tacotl-n",
    "name": "El Rincón de Tacotlán",
    "address": "Av 9 Pte 1729, Barrio de Santiago, 72410 Heroica Puebla de Zaragoza, Pue., Mexico",
    "city": "72410 Heroica Puebla de Zaragoza",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-03-14",
    "review": "Yummy local vegan Mexican food.\nAlso had vegan cheese! So good",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "72410 Heroica Puebla de Zaragoza",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2575f0b3cf7e95fd",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2575f0b3cf7e95fd",
    "maps_embed": "https://www.google.com/maps?q=El%20Rinc%C3%B3n%20de%20Tacotl%C3%A1n%20Av%209%20Pte%201729%2C%20Barrio%20de%20Santiago%2C%2072410%20Heroica%20Puebla%20de%20Zaragoza%2C%20Pue.%2C%20Mexico&output=embed",
    "lat": 19.0479129,
    "lng": -98.213556,
    "seo_title": "El Rincón de Tacotlán Review: Is It Worth A Visit?",
    "seo_description": "Yummy local vegan Mexican food. Also had vegan cheese! So good",
    "image": ""
  },
  {
    "id": "luz-del-sol",
    "name": "Luz del Sol",
    "address": "Calle Principal s/n, entre El Museo de la Tortuga y Hridaya Yoga, 70949 Mazunte, Oax., Mexico",
    "city": "70949 Mazunte",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2023-03-02",
    "review": "Lots of vegan options. Delicious fresh food with a nice big space to sit and chill. There smoothies are super thick was almost like an ice cream. So good. Defiantly come here if you are ever in mazunte",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Vegan options",
      "Wellness",
      "70949 Mazunte",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x44580ef6ca841ef3",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x44580ef6ca841ef3",
    "maps_embed": "https://www.google.com/maps?q=Luz%20del%20Sol%20Calle%20Principal%20s/n%2C%20entre%20El%20Museo%20de%20la%20Tortuga%20y%20Hridaya%20Yoga%2C%2070949%20Mazunte%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 15.6665268,
    "lng": -96.5499299,
    "seo_title": "Luz del Sol Review: Is It Worth A Visit?",
    "seo_description": "Lots of vegan options. Delicious fresh food with a nice big space to sit and chill. There smoothies are super thick was almost like an ice cream. So g…",
    "image": ""
  },
  {
    "id": "untitled-place",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 2,
    "date": "2023-01-29",
    "review": "Not well maintained. Looked like it hadn’t been cleaned in awhile. Dirty kitchen floors. Cigarette ash everywhere. Fan felt like it was going to spin off. The place could be nice if it was deep cleaned. But it’s very far away from everything. Didn’t get a chance to chat to anyone else as we left after the first night. You can find places much better for the price they want to charge.",
    "questions": [],
    "tags": [
      "Experiences",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x204e829147d100b0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x204e829147d100b0",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "Not well maintained. Looked like it hadn’t been cleaned in awhile. Dirty kitchen floors. Cigarette ash everywhere. Fan felt like it was going to spin …",
    "image": ""
  },
  {
    "id": "la-flor-de-zicatela",
    "name": "La Flor De Zicatela",
    "address": "Av. las Brisas, Sta Maria, 70934 Brisas de Zicatela, Oax., Mexico",
    "city": "70934 Brisas de Zicatela",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-01-29",
    "review": "This place is family run and they do a great job. Their juices are the best I’ve had in central and South America. 55 for a huge cup that taste great. Vegan options. I keep going back because it’s quality for the price",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "70934 Brisas de Zicatela",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd92731a249cf75f6",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd92731a249cf75f6",
    "maps_embed": "https://www.google.com/maps?q=La%20Flor%20De%20Zicatela%20Av.%20las%20Brisas%2C%20Sta%20Maria%2C%2070934%20Brisas%20de%20Zicatela%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 15.8512809,
    "lng": -97.0532292,
    "seo_title": "La Flor De Zicatela Review: Is It Worth A Visit?",
    "seo_description": "This place is family run and they do a great job. Their juices are the best I’ve had in central and South America. 55 for a huge cup that taste great.…",
    "image": ""
  },
  {
    "id": "red-indian-chilli-indian-restaurant-comida-hindu",
    "name": "Red Indian Chilli - Indian Restaurant (Comida Hindu)",
    "address": "Colonia, Vicente Guerrero N° 105 Plaza Comercial Guerrero Plants Baja Centro, 68000 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-01-18",
    "review": "Great authentic Indian cuisine. Lots of vegan options and friendly staff.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Oaxaca",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x402cd03ea410b7d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x402cd03ea410b7d",
    "maps_embed": "https://www.google.com/maps?q=Red%20Indian%20Chilli%20-%20Indian%20Restaurant%20%28Comida%20Hindu%29%20Colonia%2C%20Vicente%20Guerrero%20N%C2%B0%20105%20Plaza%20Comercial%20Guerrero%20Plants%20Baja%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0600264,
    "lng": -96.7245776,
    "seo_title": "Red Indian Chilli - Indian Restaurant (Comida Hindu) Review: Is It Worth A Visit?",
    "seo_description": "Great authentic Indian cuisine. Lots of vegan options and friendly staff.",
    "image": ""
  },
  {
    "id": "untitled-place-2",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 3,
    "date": "2023-01-16",
    "review": "Their menu changes daily and is written up on a blackboard. They didn’t write the prices or a description of the meals. They also only had 2 of the options available as they ran out of bread. I felt the food was a bit over priced for what it was.\nThe toilet is compost so be aware.\nNice to have cats however they do climb on the tables so some of the hair might be in your food.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Food & Drink",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec3a3cf83109a767",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xec3a3cf83109a767",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "Their menu changes daily and is written up on a blackboard. They didn’t write the prices or a description of the meals. They also only had 2 of the op…",
    "image": ""
  },
  {
    "id": "taj-mahal-indian-cuisine",
    "name": "Taj Mahal Indian Cuisine",
    "address": "C. de Manuel Fernández Fiallo 314, OAX_RE_BENITO JUAREZ, Centro, 68000 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-01-15",
    "review": "Delicious vegan curry. It is a bit expensive for the portion you get. The ginger lemon tea is huge",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$200–300"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Oaxaca",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x57db05a7d25c88fc",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x57db05a7d25c88fc",
    "maps_embed": "https://www.google.com/maps?q=Taj%20Mahal%20Indian%20Cuisine%20C.%20de%20Manuel%20Fern%C3%A1ndez%20Fiallo%20314%2C%20OAX_RE_BENITO%20JUAREZ%2C%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0589661,
    "lng": -96.7233073,
    "seo_title": "Taj Mahal Indian Cuisine Review: Is It Worth A Visit?",
    "seo_description": "Delicious vegan curry. It is a bit expensive for the portion you get. The ginger lemon tea is huge",
    "image": ""
  },
  {
    "id": "caf-br-jula-alcal-caf-de-especialidad-de-oaxaca-m-xico",
    "name": "Café Brújula Alcalá | Café de Especialidad de Oaxaca, México",
    "address": "C. Macedonio Alcalá 104, RUTA INDEPENDENCIA, Centro, 68000 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 3,
    "date": "2023-01-15",
    "review": "Came here for a coffee and some work on the laptop. Sadly wifi isn’t great and coffee was ok. Too pricey for what it is",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Oaxaca",
      "Mexico",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xca949572281fc9b2",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xca949572281fc9b2",
    "maps_embed": "https://www.google.com/maps?q=Caf%C3%A9%20Br%C3%BAjula%20Alcal%C3%A1%20%7C%20Caf%C3%A9%20de%20Especialidad%20de%20Oaxaca%2C%20M%C3%A9xico%20C.%20Macedonio%20Alcal%C3%A1%20104%2C%20RUTA%20INDEPENDENCIA%2C%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0625852,
    "lng": -96.7243671,
    "seo_title": "Café Brújula Alcalá | Café de Especialidad de Oaxaca, México Review: Is It Worth A Visit?",
    "seo_description": "Came here for a coffee and some work on the laptop. Sadly wifi isn’t great and coffee was ok. Too pricey for what it is",
    "image": ""
  },
  {
    "id": "hierba-dulce",
    "name": "Hierba Dulce",
    "address": "Cda. de Agustín Melgar 103, Vicente Suarez, 68033 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2023-01-15",
    "review": "Yummy cheap vegan food.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Oaxaca",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dd68bcc6898967e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dd68bcc6898967e",
    "maps_embed": "https://www.google.com/maps?q=Hierba%20Dulce%20Cda.%20de%20Agust%C3%ADn%20Melgar%20103%2C%20Vicente%20Suarez%2C%2068033%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0721175,
    "lng": -96.7403812,
    "seo_title": "Hierba Dulce Review: Is It Worth A Visit?",
    "seo_description": "Yummy cheap vegan food.",
    "image": ""
  },
  {
    "id": "untitled-place-3",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-01-15",
    "review": "Awesome place. Comes with complimentary basket of bread. I had the vegan curry which was really great and was a reasonable price for 100.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa8e24717cf826956",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa8e24717cf826956",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "Awesome place. Comes with complimentary basket of bread. I had the vegan curry which was really great and was a reasonable price for 100.",
    "image": ""
  },
  {
    "id": "etnofood",
    "name": "Etnofood",
    "address": "Xicoténcatl 609, Centro, 68000 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2023-01-15",
    "review": "Nice vegan options. Both my partner and I ordered the same sandwich tasted great. one was sandwich was smaller than the other would be great if they were the same size.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Oaxaca",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1e264288665b89a4",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1e264288665b89a4",
    "maps_embed": "https://www.google.com/maps?q=Etnofood%20Xicot%C3%A9ncatl%20609%2C%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0561762,
    "lng": -96.721619,
    "seo_title": "Etnofood Review: Is It Worth A Visit?",
    "seo_description": "Nice vegan options. Both my partner and I ordered the same sandwich tasted great. one was sandwich was smaller than the other would be great if they w…",
    "image": ""
  },
  {
    "id": "cancer-lavander-a",
    "name": "Cancer Lavandería",
    "address": "C. De Manuel Doblado 517, Zona Feb 10 2015, Centro, 68000 Oaxaca de Juárez, Oax., Mexico",
    "city": "Oaxaca",
    "country": "Mexico",
    "country_code": "",
    "category": "Practical Finds",
    "subcategory": "Laundry",
    "rating": 5,
    "date": "2023-01-15",
    "review": "Same day service with great prices. Clothes Smelled cleaned and was all folded. No clothes missing. Lovely lady.",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Oaxaca",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3889b06fdd4777e3",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x3889b06fdd4777e3",
    "maps_embed": "https://www.google.com/maps?q=Cancer%20Lavander%C3%ADa%20C.%20De%20Manuel%20Doblado%20517%2C%20Zona%20Feb%2010%202015%2C%20Centro%2C%2068000%20Oaxaca%20de%20Ju%C3%A1rez%2C%20Oax.%2C%20Mexico&output=embed",
    "lat": 17.0564808,
    "lng": -96.7208227,
    "seo_title": "Cancer Lavandería Review: Is It Worth A Visit?",
    "seo_description": "Same day service with great prices. Clothes Smelled cleaned and was all folded. No clothes missing. Lovely lady.",
    "image": ""
  },
  {
    "id": "antojito-con-amor",
    "name": "Antojito con Amor",
    "address": "Calle Pehaltun, Manzan 5, Lote 1, 77533 Cancún, Q.R., Mexico",
    "city": "77533 Cancún",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 2,
    "date": "2023-01-03",
    "review": "Apparently Tuesday is only take out. That’s ok. But we waited 50 minutes !! Nearly one hour without being told anything. There was only one other family so I’m unsure why it took so long. The menu had a lot of options. Overall I was disappointed with the food. It wasn’t fulling for the price we paid. $450P in total.",
    "questions": [
      {
        "label": "Order type",
        "value": "Take out"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$200–300"
      }
    ],
    "tags": [
      "Food & Drink",
      "77533 Cancún",
      "Mexico",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x44ba906ccfa1b1fb",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x44ba906ccfa1b1fb",
    "maps_embed": "https://www.google.com/maps?q=Antojito%20con%20Amor%20Calle%20Pehaltun%2C%20Manzan%205%2C%20Lote%201%2C%2077533%20Canc%C3%BAn%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 21.1342505,
    "lng": -86.8441647,
    "seo_title": "Antojito con Amor Review: Is It Worth A Visit?",
    "seo_description": "Apparently Tuesday is only take out. That’s ok. But we waited 50 minutes !! Nearly one hour without being told anything. There was only one other fami…",
    "image": ""
  },
  {
    "id": "jumu",
    "name": "JUMU",
    "address": "5 Av Sur, La Veleta, 77780 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 5,
    "date": "2022-12-28",
    "review": "Great fresh food at a reasonable price. Friendly staff",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Food & Drink",
      "Tulum",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x54a7700b95354dd8",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x54a7700b95354dd8",
    "maps_embed": "https://www.google.com/maps?q=JUMU%205%20Av%20Sur%2C%20La%20Veleta%2C%2077780%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.2048389,
    "lng": -87.4794299,
    "seo_title": "JUMU Review: Is It Worth A Visit?",
    "seo_description": "Great fresh food at a reasonable price. Friendly staff",
    "image": ""
  },
  {
    "id": "villas-alakin",
    "name": "Villas Alakin",
    "address": "Itzamna, Aldea Zama, 77760 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 2,
    "date": "2022-12-28",
    "review": "Stayed here through booking.com. The room was very small and didn’t have a door for the toilet and shower. The pillows were small and lumpy. Loads of mosquitoes so couldn’t keep door open. Only good thing was the location and the pool.",
    "questions": [],
    "tags": [
      "Stays",
      "Tulum",
      "Mexico",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa0861b6c1a86c1e1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa0861b6c1a86c1e1",
    "maps_embed": "https://www.google.com/maps?q=Villas%20Alakin%20Itzamna%2C%20Aldea%20Zama%2C%2077760%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.1958015,
    "lng": -87.4629306,
    "seo_title": "Villas Alakin Review: Is It Worth A Visit?",
    "seo_description": "Stayed here through booking.com. The room was very small and didn’t have a door for the toilet and shower. The pillows were small and lumpy. Loads of …",
    "image": ""
  },
  {
    "id": "la-hoja-verde",
    "name": "La Hoja Verde",
    "address": "Beta Sur S/N, Tulum Centro, 77780 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2022-12-23",
    "review": "Ordered the stir fry wok tasted good.\nMy partner had the curry which tasted a bit bland and was pretty watery and hardly any tofu. We also ordered a pizza to have on the side which was nice and crunchy. But without that we would have still been hungry. Overall it was ok not the best place I’ve been too. Kind of pricey.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$400–500"
      }
    ],
    "tags": [
      "Food & Drink",
      "Tulum",
      "Mexico",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x852d7d34c222ded",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x852d7d34c222ded",
    "maps_embed": "https://www.google.com/maps?q=La%20Hoja%20Verde%20Beta%20Sur%20S/N%2C%20Tulum%20Centro%2C%2077780%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.2112666,
    "lng": -87.4617522,
    "seo_title": "La Hoja Verde Review: Is It Worth A Visit?",
    "seo_description": "Ordered the stir fry wok tasted good. My partner had the curry which tasted a bit bland and was pretty watery and hardly any tofu. We also ordered a p…",
    "image": ""
  },
  {
    "id": "seremonia-origen",
    "name": "Seremonia Origen",
    "address": "Av. Chechén Manzana 119 Lote 001, La Veleta, 77760 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 4,
    "date": "2022-12-23",
    "review": "Location is in between the beach and the main downtown area. Really enjoyed the industrial look of the room. Very spacious and clean. Great coffee machine and huge fridge. Only downside was the construction happening next door and hot water didn’t last long in the shower.",
    "questions": [],
    "tags": [
      "Stays",
      "Tulum",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5ea4f76c881f340c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5ea4f76c881f340c",
    "maps_embed": "https://www.google.com/maps?q=Seremonia%20Origen%20Av.%20Chech%C3%A9n%20Manzana%20119%20Lote%20001%2C%20La%20Veleta%2C%2077760%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.1922148,
    "lng": -87.4673805,
    "seo_title": "Seremonia Origen Review: Is It Worth A Visit?",
    "seo_description": "Location is in between the beach and the main downtown area. Really enjoyed the industrial look of the room. Very spacious and clean. Great coffee mac…",
    "image": ""
  },
  {
    "id": "jonny-como-pizza",
    "name": "Jonny Como Pizza",
    "address": "Av.35 #18, casi esquina de Calle 38, 77720 Playa del Carmen, Q.R., Mexico",
    "city": "77720 Playa del Carmen",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2022-12-23",
    "review": "Great place with vegan options.\nThey have the best cookies here !!",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "77720 Playa del Carmen",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x65278886fbe11386",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x65278886fbe11386",
    "maps_embed": "https://www.google.com/maps?q=Jonny%20Como%20Pizza%20Av.35%20%2318%2C%20casi%20esquina%20de%20Calle%2038%2C%2077720%20Playa%20del%20Carmen%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.6386276,
    "lng": -87.0716885,
    "seo_title": "Jonny Como Pizza Review: Is It Worth A Visit?",
    "seo_description": "Great place with vegan options. They have the best cookies here !!",
    "image": ""
  },
  {
    "id": "pasha-tulum-pueblo",
    "name": "Pasha Tulum Pueblo",
    "address": "Av. Coba 22, centro, 77780 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-12-23",
    "review": "Such a cool ambiance here.\nWe had the vegan platter which was amazing and filling for two adults.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Tulum",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbb106f6808ac2071",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xbb106f6808ac2071",
    "maps_embed": "https://www.google.com/maps?q=Pasha%20Tulum%20Pueblo%20Av.%20Coba%2022%2C%20centro%2C%2077780%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.2087815,
    "lng": -87.4511901,
    "seo_title": "Pasha Tulum Pueblo Review: Is It Worth A Visit?",
    "seo_description": "Such a cool ambiance here. We had the vegan platter which was amazing and filling for two adults.",
    "image": ""
  },
  {
    "id": "falafel-nessya",
    "name": "Falafel Nessya",
    "address": "Calle 6 Nte y 15, entre 10 Avenida Sur, Centro, 77710 Playa del Carmen, Q.R., Mexico",
    "city": "77710 Playa del Carmen",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 5,
    "date": "2022-12-22",
    "review": "Best falafel place. They are quick at bringing out the food even when super busy. Great prices",
    "questions": [],
    "tags": [
      "Practical Finds",
      "77710 Playa del Carmen",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6d5e469ccd02d14b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6d5e469ccd02d14b",
    "maps_embed": "https://www.google.com/maps?q=Falafel%20Nessya%20Calle%206%20Nte%20y%2015%2C%20entre%2010%20Avenida%20Sur%2C%20Centro%2C%2077710%20Playa%20del%20Carmen%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.6258725,
    "lng": -87.0748572,
    "seo_title": "Falafel Nessya Review: Is It Worth A Visit?",
    "seo_description": "Best falafel place. They are quick at bringing out the food even when super busy. Great prices",
    "image": ""
  },
  {
    "id": "cafe-na-tulum",
    "name": "Cafeína Tulum",
    "address": "Av. Tulum entre centauro Sur y avenida satélite sur, Tulum Centro, 77760 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 3,
    "date": "2022-12-22",
    "review": "I had the peanut and banana bagel. Bagel was not really cooked and it was missing cinnamon or something. So added my friends jam and it tasted way better. Good coffee",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Food & Drink",
      "Tulum",
      "Mexico",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe827a0808a0f4c2e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe827a0808a0f4c2e",
    "maps_embed": "https://www.google.com/maps?q=Cafe%C3%ADna%20Tulum%20Av.%20Tulum%20entre%20centauro%20Sur%20y%20avenida%20sat%C3%A9lite%20sur%2C%20Tulum%20Centro%2C%2077760%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.2121175,
    "lng": -87.459133,
    "seo_title": "Cafeína Tulum Review: Is It Worth A Visit?",
    "seo_description": "I had the peanut and banana bagel. Bagel was not really cooked and it was missing cinnamon or something. So added my friends jam and it tasted way bet…",
    "image": ""
  },
  {
    "id": "kanan-tulum",
    "name": "Kanan Tulum",
    "address": "Carretera Tulum Boca Paila Km 7.5 Mza 020 reg 009, 77780 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 5,
    "date": "2022-12-22",
    "review": "Came for a bday cocktail. Such a cool spot to sit outside and watch the stars. Lovely staff who are attentive. Really good cocktails",
    "questions": [],
    "tags": [
      "Experiences",
      "Tulum",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x869258734505ac8b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x869258734505ac8b",
    "maps_embed": "https://www.google.com/maps?q=Kanan%20Tulum%20Carretera%20Tulum%20Boca%20Paila%20Km%207.5%20Mza%20020%20reg%20009%2C%2077780%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.1506698,
    "lng": -87.4582348,
    "seo_title": "Kanan Tulum Review: Is It Worth A Visit?",
    "seo_description": "Came for a bday cocktail. Such a cool spot to sit outside and watch the stars. Lovely staff who are attentive. Really good cocktails",
    "image": ""
  },
  {
    "id": "fit-a-licious",
    "name": "Fit-a-licious",
    "address": "Andador Paseo Zama MZ 26 LT 166, Aldea Zama, 77760 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2022-12-21",
    "review": "Great menu options. Defiantly recommend the cold brew coffee. Best I’ve had in Mexico yet! Lovely staff.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Brunch"
      },
      {
        "label": "Price per person",
        "value": "$500–600"
      }
    ],
    "tags": [
      "Food & Drink",
      "Tulum",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2d1533c4fc4f27fa",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2d1533c4fc4f27fa",
    "maps_embed": "https://www.google.com/maps?q=Fit-a-licious%20Andador%20Paseo%20Zama%20MZ%2026%20LT%20166%2C%20Aldea%20Zama%2C%2077760%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.1995301,
    "lng": -87.4625045,
    "seo_title": "Fit-a-licious Review: Is It Worth A Visit?",
    "seo_description": "Great menu options. Defiantly recommend the cold brew coffee. Best I’ve had in Mexico yet! Lovely staff.",
    "image": ""
  },
  {
    "id": "the-restaurant-at-sanar-beach-hotel-formerly-known-as-real-coconut-tulum-beach",
    "name": "The Restaurant at Sanará Beach Hotel, formerly known as “Real Coconut”.- Tulum Beach",
    "address": "Km 8.2, 77780 Tulum, Q.R., Mexico",
    "city": "Tulum",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Beaches & Nature",
    "subcategory": "Beaches",
    "rating": 3,
    "date": "2022-12-21",
    "review": "Beautiful place. But overpriced. Paid 375 for a the bbq pizza and it had the thinnest layer of sauce. Couldn’t even taste it. 5/10 for the pizza. That we waited for half an hour. Looks better than it tasted. Nice to be close to the beach though.",
    "questions": [],
    "tags": [
      "Beaches & Nature",
      "Tulum",
      "Mexico",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x85ee0c81afa6d760",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x85ee0c81afa6d760",
    "maps_embed": "https://www.google.com/maps?q=The%20Restaurant%20at%20Sanar%C3%A1%20Beach%20Hotel%2C%20formerly%20known%20as%20%E2%80%9CReal%20Coconut%E2%80%9D.-%20Tulum%20Beach%20Km%208.2%2C%2077780%20Tulum%2C%20Q.R.%2C%20Mexico&output=embed",
    "lat": 20.1459899,
    "lng": -87.4593516,
    "seo_title": "The Restaurant at Sanará Beach Hotel, formerly known as “Real Coconut”.- Tulum Beach Review: Is It Worth A Visit?",
    "seo_description": "Beautiful place. But overpriced. Paid 375 for a the bbq pizza and it had the thinnest layer of sauce. Couldn’t even taste it. 5/10 for the pizza. That…",
    "image": ""
  },
  {
    "id": "bin-foods",
    "name": "BINÍ Foods",
    "address": "C. Guadalupe Victoria 30b, Barrio de la Merced, 29240 San Cristóbal de las Casas, Chis., Mexico",
    "city": "29240 San Cristóbal de las Casas",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2022-12-02",
    "review": "Cute spot with vegan friendly dishes. Ordered the pancakes for 45. Tasted good But were a little undercooked. Also added the peanut butter for an extra 15 which made it more filling.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Breakfast"
      },
      {
        "label": "Price per person",
        "value": "$1–100"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "29240 San Cristóbal de las Casas",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30b2bc710196e237",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x30b2bc710196e237",
    "maps_embed": "https://www.google.com/maps?q=BIN%C3%8D%20Foods%20C.%20Guadalupe%20Victoria%2030b%2C%20Barrio%20de%20la%20Merced%2C%2029240%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Chis.%2C%20Mexico&output=embed",
    "lat": 16.7371132,
    "lng": -92.640714,
    "seo_title": "BINÍ Foods Review: Is It Worth A Visit?",
    "seo_description": "Cute spot with vegan friendly dishes. Ordered the pancakes for 45. Tasted good But were a little undercooked. Also added the peanut butter for an extr…",
    "image": ""
  },
  {
    "id": "loving-hut",
    "name": "Loving Hut",
    "address": "Mexico, Chiapas, San Cristóbal de las Casas, Barrio de Mexicanos, Av 20 de Noviembre",
    "city": "San Cristóbal de las Casas",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 5,
    "date": "2022-12-02",
    "review": "Such a great little find. Absolutely delish food with a great range of dishes on the menu. Lovely staff as well. Defiantly will be back.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "San Cristóbal de las Casas",
      "Mexico",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4738423cfda1e73b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4738423cfda1e73b",
    "maps_embed": "https://www.google.com/maps?q=Loving%20Hut%20Mexico%2C%20Chiapas%2C%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Barrio%20de%20Mexicanos%2C%20Av%2020%20de%20Noviembre&output=embed",
    "lat": 16.7416414,
    "lng": -92.6380112,
    "seo_title": "Loving Hut Review: Is It Worth A Visit?",
    "seo_description": "Such a great little find. Absolutely delish food with a great range of dishes on the menu. Lovely staff as well. Defiantly will be back.",
    "image": ""
  },
  {
    "id": "donki-burritos-sancris",
    "name": "Donki Burritos Sancris",
    "address": "Real de Guadalupe #139, Isabel La Católica e, entre Avenida Vicente Guerrero, 29230 San Cristóbal de las Casas, Chis., Mexico",
    "city": "29230 San Cristóbal de las Casas",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 4,
    "date": "2022-12-01",
    "review": "Ordered the bowl. Tasted great but I felt like there could have been more in the bowl. I was still hungry after. I’m glad we went on a Thursday where it was two for 200 donki size. Good service 😊",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      },
      {
        "label": "Price per person",
        "value": "$100–200"
      }
    ],
    "tags": [
      "Food & Drink",
      "29230 San Cristóbal de las Casas",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7bf918e98ce3d8f5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x7bf918e98ce3d8f5",
    "maps_embed": "https://www.google.com/maps?q=Donki%20Burritos%20Sancris%20Real%20de%20Guadalupe%20%23139%2C%20Isabel%20La%20Cat%C3%B3lica%20e%2C%20entre%20Avenida%20Vicente%20Guerrero%2C%2029230%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Chis.%2C%20Mexico&output=embed",
    "lat": 16.7377294,
    "lng": -92.6290285,
    "seo_title": "Donki Burritos Sancris Review: Is It Worth A Visit?",
    "seo_description": "Ordered the bowl. Tasted great but I felt like there could have been more in the bowl. I was still hungry after. I’m glad we went on a Thursday where …",
    "image": ""
  },
  {
    "id": "untitled-place-4",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 5,
    "date": "2022-11-29",
    "review": "The food tasted really good. The pineapple  flavoured one was the best.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dcf9218d1d36dde",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2dcf9218d1d36dde",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "The food tasted really good. The pineapple flavoured one was the best.",
    "image": ""
  },
  {
    "id": "sweetbeat",
    "name": "Sweetbeat",
    "address": "Belisario Domínguez 33, Barrio del Cerrillo, 29220 San Cristóbal de las Casas, Chis., Mexico",
    "city": "29220 San Cristóbal de las Casas",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 4,
    "date": "2022-11-29",
    "review": "Great vibe and good coffee.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "29220 San Cristóbal de las Casas",
      "Mexico",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4e2f4858d6fd7ba7",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x4e2f4858d6fd7ba7",
    "maps_embed": "https://www.google.com/maps?q=Sweetbeat%20Belisario%20Dom%C3%ADnguez%2033%2C%20Barrio%20del%20Cerrillo%2C%2029220%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Chis.%2C%20Mexico&output=embed",
    "lat": 16.7401729,
    "lng": -92.6354389,
    "seo_title": "Sweetbeat Review: Is It Worth A Visit?",
    "seo_description": "Great vibe and good coffee.",
    "image": ""
  },
  {
    "id": "kukulpan",
    "name": "Kukulpan",
    "address": "Dr. Navarro 10, Barrio del Cerrillo, 29220 San Cristóbal de las Casas, Chis., Mexico",
    "city": "29220 San Cristóbal de las Casas",
    "country": "Mexico",
    "country_code": "MX",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 2,
    "date": "2022-11-29",
    "review": "Honestly not worth the wait plus the size of the meal was so small for the price you pay. I ordered a croissant and on the menu it says with fruit or salad. When I question where it was they said you have to ask for it as some people don’t eat it and waste it.\nThey did have good tasting marmalade though",
    "questions": [],
    "tags": [
      "Food & Drink",
      "29220 San Cristóbal de las Casas",
      "Mexico",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xde09ee33068e939e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xde09ee33068e939e",
    "maps_embed": "https://www.google.com/maps?q=Kukulpan%20Dr.%20Navarro%2010%2C%20Barrio%20del%20Cerrillo%2C%2029220%20San%20Crist%C3%B3bal%20de%20las%20Casas%2C%20Chis.%2C%20Mexico&output=embed",
    "lat": 16.7405811,
    "lng": -92.6355345,
    "seo_title": "Kukulpan Review: Is It Worth A Visit?",
    "seo_description": "Honestly not worth the wait plus the size of the meal was so small for the price you pay. I ordered a croissant and on the menu it says with fruit or …",
    "image": ""
  },
  {
    "id": "d-chary-pizzer-a-artesanal",
    "name": "D'Chary Pizzería Artesanal",
    "address": "San Martin 1019, Caraz 02167, Peru",
    "city": "San Martin 1019",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 3,
    "date": "2022-07-18",
    "review": "Very big pizza. Cost 38. Tasted a little bland but I did ask for no cheese. Nice and crunchy. Nice venue. My partner asked for cheese and his came with none so they had to go back and put some on. I had finished eating the pizza by his came out.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "San Martin 1019",
      "Peru",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x500bf5f0e6d6127a",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x500bf5f0e6d6127a",
    "maps_embed": "https://www.google.com/maps?q=D%27Chary%20Pizzer%C3%ADa%20Artesanal%20San%20Martin%201019%2C%20Caraz%2002167%2C%20Peru&output=embed",
    "lat": -9.0478925,
    "lng": -77.8104862,
    "seo_title": "D'Chary Pizzería Artesanal Review: Is It Worth A Visit?",
    "seo_description": "Very big pizza. Cost 38. Tasted a little bland but I did ask for no cheese. Nice and crunchy. Nice venue. My partner asked for cheese and his came wit…",
    "image": ""
  },
  {
    "id": "asianica-street-food-vegan-restaurant",
    "name": "Asianica Street Food - Vegan Restaurant",
    "address": "Av. la Paz 678, Miraflores 15074, Peru",
    "city": "La Paz",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 1,
    "date": "2022-07-15",
    "review": "Very disappointed. All the food we ordered tasted very bland. The sausage was not even cooked on the inside. Not very filling portions. Felt like I ate greasy takeaway food. You know that feeling of feeling gross.\n\nThey have a lot of work to do to on their recipes. Also sad to see that all their food comes in cardboard boxes and not dishes that could be washed. Yells lazy to me and unsustainable.\n\nStaff were nice and it did look cute inside. Sadly can’t recommend.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Dinner"
      }
    ],
    "tags": [
      "Food & Drink",
      "La Paz",
      "Peru",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x80654ae2033b1f35",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x80654ae2033b1f35",
    "maps_embed": "https://www.google.com/maps?q=Asianica%20Street%20Food%20-%20Vegan%20Restaurant%20Av.%20la%20Paz%20678%2C%20Miraflores%2015074%2C%20Peru&output=embed",
    "lat": -12.1243548,
    "lng": -77.026978,
    "seo_title": "Asianica Street Food - Vegan Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Very disappointed. All the food we ordered tasted very bland. The sausage was not even cooked on the inside. Not very filling portions. Felt like I at…",
    "image": ""
  },
  {
    "id": "mr-sushi",
    "name": "Mr. Sushi",
    "address": "Av. Gral. Juan Antonio Pezet 1311, San Isidro 15076, Peru",
    "city": "Av. Gral. Juan Antonio Pezet 1311",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2022-07-14",
    "review": "Tofu poke. Tasted good. However they ran out of carrot and didn’t tell us. When I asked he said he put more of the other ingredients in.  Not so sure about that. Also took awhile. Only one person doing the food while the other sits and folds boxes in between being on their phone. Clean place",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Av. Gral. Juan Antonio Pezet 1311",
      "Peru",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8286a667779f1ed9",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8286a667779f1ed9",
    "maps_embed": "https://www.google.com/maps?q=Mr.%20Sushi%20Av.%20Gral.%20Juan%20Antonio%20Pezet%201311%2C%20San%20Isidro%2015076%2C%20Peru&output=embed",
    "lat": -12.1033819,
    "lng": -77.0517507,
    "seo_title": "Mr. Sushi Review: Is It Worth A Visit?",
    "seo_description": "Tofu poke. Tasted good. However they ran out of carrot and didn’t tell us. When I asked he said he put more of the other ingredients in. Not so sure a…",
    "image": ""
  },
  {
    "id": "dhaasu-cocina-delhi",
    "name": "Dhaasu Cocina Delhi",
    "address": "Av. Mariscal La Mar 1167, Miraflores 15074, Peru",
    "city": "Av. Mariscal La Mar 1167",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2022-07-14",
    "review": "A couple of vegan options and they were happy to do the garlic naan without butter. I got the only vegan curry and made sure 3 times that it wasn’t spicy. She said no and it ended up being spicy for me. It upset my stomach the next morning. Kind of expensive in my opinion but it looks very clean and organised. Small inside but cozy.",
    "questions": [
      {
        "label": "Order type",
        "value": "Dine in"
      },
      {
        "label": "Meal type",
        "value": "Lunch"
      }
    ],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Av. Mariscal La Mar 1167",
      "Peru",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa050b96d7fb2116",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa050b96d7fb2116",
    "maps_embed": "https://www.google.com/maps?q=Dhaasu%20Cocina%20Delhi%20Av.%20Mariscal%20La%20Mar%201167%2C%20Miraflores%2015074%2C%20Peru&output=embed",
    "lat": -12.1107807,
    "lng": -77.0482555,
    "seo_title": "Dhaasu Cocina Delhi Review: Is It Worth A Visit?",
    "seo_description": "A couple of vegan options and they were happy to do the garlic naan without butter. I got the only vegan curry and made sure 3 times that it wasn’t sp…",
    "image": ""
  },
  {
    "id": "quinoa-caf",
    "name": "Quinoa Café",
    "address": "C.C. Balboa Strip Mall, Av. Vasco Núñez de Balboa 785, Miraflores 15074, Peru",
    "city": "Av. Vasco Núñez de Balboa 785",
    "country": "Peru",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2022-07-12",
    "review": "Very clean and nice inside. Food was nicely presented but tasted a bit bland. Had a couple of vegan options but no options for plant based milk",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Av. Vasco Núñez de Balboa 785",
      "Peru",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb8580a996cb81ee3",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xb8580a996cb81ee3",
    "maps_embed": "https://www.google.com/maps?q=Quinoa%20Caf%C3%A9%20C.C.%20Balboa%20Strip%20Mall%2C%20Av.%20Vasco%20N%C3%BA%C3%B1ez%20de%20Balboa%20785%2C%20Miraflores%2015074%2C%20Peru&output=embed",
    "lat": -12.129313,
    "lng": -77.0241564,
    "seo_title": "Quinoa Café Review: Is It Worth A Visit?",
    "seo_description": "Very clean and nice inside. Food was nicely presented but tasted a bit bland. Had a couple of vegan options but no options for plant based milk",
    "image": ""
  },
  {
    "id": "salvajes-per",
    "name": "Salvajes Perú",
    "address": "C. San Agustín 275, Cusco 08002, Peru",
    "city": "Cusco",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 2,
    "date": "2022-07-05",
    "review": "My meal was pretty average. And the pineapple juice I ordered tasted very watery. They even made it again for me but tasted the same. My partner however enjoyed his burger.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Cusco",
      "Peru",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcb4a0560e8711c0f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcb4a0560e8711c0f",
    "maps_embed": "https://www.google.com/maps?q=Salvajes%20Per%C3%BA%20C.%20San%20Agust%C3%ADn%20275%2C%20Cusco%2008002%2C%20Peru&output=embed",
    "lat": -13.518073,
    "lng": -71.9755291,
    "seo_title": "Salvajes Perú Review: Is It Worth A Visit?",
    "seo_description": "My meal was pretty average. And the pineapple juice I ordered tasted very watery. They even made it again for me but tasted the same. My partner howev…",
    "image": ""
  },
  {
    "id": "viva-m-xico",
    "name": "Viva México",
    "address": "C. Plateros 392, Cusco 08002, Peru",
    "city": "Cusco",
    "country": "Peru",
    "country_code": "PE",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 2,
    "date": "2022-07-05",
    "review": "I got the mushroom tacos. They were ok. They forgot to put the lettuce on. I only knew this as my partner ordered some and his came with lettuce. Kind of expensive for what they are",
    "questions": [],
    "tags": [
      "Stays",
      "Cusco",
      "Peru",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe8243cc4797e65c7",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe8243cc4797e65c7",
    "maps_embed": "https://www.google.com/maps?q=Viva%20M%C3%A9xico%20C.%20Plateros%20392%2C%20Cusco%2008002%2C%20Peru&output=embed",
    "lat": -13.5154264,
    "lng": -71.980608,
    "seo_title": "Viva México Review: Is It Worth A Visit?",
    "seo_description": "I got the mushroom tacos. They were ok. They forgot to put the lettuce on. I only knew this as my partner ordered some and his came with lettuce. Kind…",
    "image": ""
  },
  {
    "id": "the-vegan-temple-by-prasada",
    "name": "The Vegan Temple by Prasada",
    "address": "Choqechaka 425, Cusco 08002, Peru",
    "city": "Cusco",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2022-07-04",
    "review": "Lovely setting with delicious food. They really put a lot of effort into making the food taste great",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Cusco",
      "Peru",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6f1cabd0e032dc97",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x6f1cabd0e032dc97",
    "maps_embed": "https://www.google.com/maps?q=The%20Vegan%20Temple%20by%20Prasada%20Choqechaka%20425%2C%20Cusco%2008002%2C%20Peru&output=embed",
    "lat": -13.5133484,
    "lng": -71.9772774,
    "seo_title": "The Vegan Temple by Prasada Review: Is It Worth A Visit?",
    "seo_description": "Lovely setting with delicious food. They really put a lot of effort into making the food taste great",
    "image": ""
  },
  {
    "id": "machu-pisco-bar-restaurant",
    "name": "Machu Pisco Bar & Restaurant",
    "address": "Imperio de los Incas 632, Aguas Calientes 08681, Peru",
    "city": "Imperio de los Incas 632",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2022-07-04",
    "review": "Crunchy pizza. Nice view. Pizza was ok for me with no cheese to make it vegan. Was still hungry after eating the medium pizza. Paid 30",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Imperio de los Incas 632",
      "Peru",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaccea12962d69c19",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xaccea12962d69c19",
    "maps_embed": "https://www.google.com/maps?q=Machu%20Pisco%20Bar%20%26%20Restaurant%20Imperio%20de%20los%20Incas%20632%2C%20Aguas%20Calientes%2008681%2C%20Peru&output=embed",
    "lat": -13.1564049,
    "lng": -72.5241875,
    "seo_title": "Machu Pisco Bar & Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Crunchy pizza. Nice view. Pizza was ok for me with no cheese to make it vegan. Was still hungry after eating the medium pizza. Paid 30",
    "image": ""
  },
  {
    "id": "full-house-machupicchu-restaurant",
    "name": "Full House Machupicchu Restaurant",
    "address": "Imperio de los Incas 620, Aguas Calientes 08681, Peru",
    "city": "Imperio de los Incas 620",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 2,
    "date": "2022-07-04",
    "review": "They had no vegan options on the menu for the main dish. They made me pasta and mushrooms and I’m pretty sure this pasta is made with egg. Very small portion was still hungry after",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Imperio de los Incas 620",
      "Peru",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe89c55a3408a7e59",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe89c55a3408a7e59",
    "maps_embed": "https://www.google.com/maps?q=Full%20House%20Machupicchu%20Restaurant%20Imperio%20de%20los%20Incas%20620%2C%20Aguas%20Calientes%2008681%2C%20Peru&output=embed",
    "lat": -13.1559379,
    "lng": -72.5247743,
    "seo_title": "Full House Machupicchu Restaurant Review: Is It Worth A Visit?",
    "seo_description": "They had no vegan options on the menu for the main dish. They made me pasta and mushrooms and I’m pretty sure this pasta is made with egg. Very small …",
    "image": ""
  },
  {
    "id": "chia-vegan-restaurant",
    "name": "CHIA VEGAN RESTAURANT",
    "address": "san blas, C. Carmen Alto 133, Cusco 08002, Peru",
    "city": "Cusco",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 2,
    "date": "2022-06-27",
    "review": "Overpriced for the portion they give you. We were both still hungry after so had to go somewhere else to eat. These tacos were 36 each. Staff are nice though",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Cusco",
      "Peru",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd473df6badd110fe",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd473df6badd110fe",
    "maps_embed": "https://www.google.com/maps?q=CHIA%20VEGAN%20RESTAURANT%20san%20blas%2C%20C.%20Carmen%20Alto%20133%2C%20Cusco%2008002%2C%20Peru&output=embed",
    "lat": -13.5147866,
    "lng": -71.9750513,
    "seo_title": "CHIA VEGAN RESTAURANT Review: Is It Worth A Visit?",
    "seo_description": "Overpriced for the portion they give you. We were both still hungry after so had to go somewhere else to eat. These tacos were 36 each. Staff are nice…",
    "image": ""
  },
  {
    "id": "vida-vegan-bistro",
    "name": "VIDA VEGAN BISTRO",
    "address": "C. Palacio 126, Cusco 08000, Peru",
    "city": "Cusco",
    "country": "Peru",
    "country_code": "PE",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-06-26",
    "review": "Best vegan burger. Nice and crunch chips with a range of different sauces. This place is absolutely amazing. Defiantly try it out if you are around !",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Cusco",
      "Peru",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x21848a7e53ab322c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x21848a7e53ab322c",
    "maps_embed": "https://www.google.com/maps?q=VIDA%20VEGAN%20BISTRO%20C.%20Palacio%20126%2C%20Cusco%2008000%2C%20Peru&output=embed",
    "lat": -13.5158403,
    "lng": -71.9766635,
    "seo_title": "VIDA VEGAN BISTRO Review: Is It Worth A Visit?",
    "seo_description": "Best vegan burger. Nice and crunch chips with a range of different sauces. This place is absolutely amazing. Defiantly try it out if you are around !",
    "image": ""
  },
  {
    "id": "lupito-cocina-vegana",
    "name": "Lupito Cocina Vegana",
    "address": "Cardón 14, La Paz, Bolivia",
    "city": "La Paz",
    "country": "Bolivia",
    "country_code": "BO",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 5,
    "date": "2022-06-16",
    "review": "Lovely space with a good size meal. Nice staff who aver welcoming",
    "questions": [],
    "tags": [
      "Wellness",
      "La Paz",
      "Bolivia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5129721378360a97",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5129721378360a97",
    "maps_embed": "https://www.google.com/maps?q=Lupito%20Cocina%20Vegana%20Card%C3%B3n%2014%2C%20La%20Paz%2C%20Bolivia&output=embed",
    "lat": -16.5131877,
    "lng": -68.1298514,
    "seo_title": "Lupito Cocina Vegana Review: Is It Worth A Visit?",
    "seo_description": "Lovely space with a good size meal. Nice staff who aver welcoming",
    "image": ""
  },
  {
    "id": "untitled-place-5",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 4,
    "date": "2022-06-16",
    "review": "We are here three times as it was just down the road of our hotel. Place has a great vibe. The vegan omelet was very salty but was a good size. All meals were decent price",
    "questions": [],
    "tags": [
      "Vegan options",
      "Stays",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x733daae4a950da70",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x733daae4a950da70",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "We are here three times as it was just down the road of our hotel. Place has a great vibe. The vegan omelet was very salty but was a good size. All me…",
    "image": ""
  },
  {
    "id": "rey-palace-hotel",
    "name": "Rey Palace Hotel",
    "address": "Av.20 de Octubre 1947, La Paz 0000, Bolivia",
    "city": "La Paz",
    "country": "Bolivia",
    "country_code": "BO",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 2,
    "date": "2022-06-16",
    "review": "This hotel feels old is very run down. We stayed 2 nights in different rooms. The first room the heating didn’t work but they gave us a plug in heater. The toilet seat was like a foam plastic that slipped into the toilet everyone you sat on it.\nThe second room had mould and paint coming off. Could hear all the noises from the other rooms. The place where you eat breakfast has a massive hole in the roof from water damage that they tired to cover with paper. They however let us park our car in there very small garage.",
    "questions": [],
    "tags": [
      "Stays",
      "La Paz",
      "Bolivia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2221b76476e87c8d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2221b76476e87c8d",
    "maps_embed": "https://www.google.com/maps?q=Rey%20Palace%20Hotel%20Av.20%20de%20Octubre%201947%2C%20La%20Paz%200000%2C%20Bolivia&output=embed",
    "lat": -16.505764,
    "lng": -68.13111,
    "seo_title": "Rey Palace Hotel Review: Is It Worth A Visit?",
    "seo_description": "This hotel feels old is very run down. We stayed 2 nights in different rooms. The first room the heating didn’t work but they gave us a plug in heater…",
    "image": ""
  },
  {
    "id": "tacuru",
    "name": "Tacuru",
    "address": "Av. Arce 42, Uyuni, Bolivia",
    "city": "Uyuni",
    "country": "Bolivia",
    "country_code": "BO",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 5,
    "date": "2022-06-16",
    "review": "This place has the best pizza. They also are happy to accommodate changing some things. Eg I changed the cheese for pesto. We ate here 3 times the best pizza we’ve had in awhile.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Uyuni",
      "Bolivia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc171980a24685fe8",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc171980a24685fe8",
    "maps_embed": "https://www.google.com/maps?q=Tacuru%20Av.%20Arce%2042%2C%20Uyuni%2C%20Bolivia&output=embed",
    "lat": -20.4630761,
    "lng": -66.8239291,
    "seo_title": "Tacuru Review: Is It Worth A Visit?",
    "seo_description": "This place has the best pizza. They also are happy to accommodate changing some things. Eg I changed the cheese for pesto. We ate here 3 times the bes…",
    "image": ""
  },
  {
    "id": "hotel-nido-del-flamenco",
    "name": "Hotel Nido del Flamenco",
    "address": "Sucre y, Uyuni, Bolivia",
    "city": "Uyuni",
    "country": "Bolivia",
    "country_code": "BO",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 5,
    "date": "2022-06-16",
    "review": "This place is the best we stayed at in all of Bolívia. The rooms are cozy, the showers are big and hot. The hotel is overall beautiful with salt walls. Ana is the best host and makes you feel very welcomed and will go to any effort to make sure you feel comfortable. One night after a shower she saw I had wet hair and the next minute she was giving me a hairdryer without me even asking.\nIf you are In Uyuni you should defiantly stay here you won’t regret it!",
    "questions": [],
    "tags": [
      "Stays",
      "Uyuni",
      "Bolivia",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1f882db638b4065a",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1f882db638b4065a",
    "maps_embed": "https://www.google.com/maps?q=Hotel%20Nido%20del%20Flamenco%20Sucre%20y%2C%20Uyuni%2C%20Bolivia&output=embed",
    "lat": -20.4678943,
    "lng": -66.8160471,
    "seo_title": "Hotel Nido del Flamenco Review: Is It Worth A Visit?",
    "seo_description": "This place is the best we stayed at in all of Bolívia. The rooms are cozy, the showers are big and hot. The hotel is overall beautiful with salt walls…",
    "image": ""
  },
  {
    "id": "caf-pizzer-a-4-estaciones",
    "name": "CAFÉ PIZZERÍA 4 ESTACIONES",
    "address": "Uyuni, Bolivia",
    "city": "Uyuni",
    "country": "Bolivia",
    "country_code": "BO",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 1,
    "date": "2022-06-06",
    "review": "Waited so long for a very average pizza. We ended up not eating as it didn’t taste good. Would recommend going to a different place.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Uyuni",
      "Bolivia",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xce7e05acc33431a8",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xce7e05acc33431a8",
    "maps_embed": "https://www.google.com/maps?q=CAF%C3%89%20PIZZER%C3%8DA%204%20ESTACIONES%20Uyuni%2C%20Bolivia&output=embed",
    "lat": -20.4634082,
    "lng": -66.8235074,
    "seo_title": "CAFÉ PIZZERÍA 4 ESTACIONES Review: Is It Worth A Visit?",
    "seo_description": "Waited so long for a very average pizza. We ended up not eating as it didn’t taste good. Would recommend going to a different place.",
    "image": ""
  },
  {
    "id": "untitled-place-6",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-05-22",
    "review": "Vegan dish was the best I’ve ever had !!",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x746937cb0adebd2c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x746937cb0adebd2c",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "Vegan dish was the best I’ve ever had !!",
    "image": ""
  },
  {
    "id": "menu-poke-joinville",
    "name": "Menu Poke Joinville",
    "address": "R. Blumenau, 64 - loja 06 - Centro, Joinville - SC, 89204-350, Brazil",
    "city": "Joinville - SC",
    "country": "",
    "country_code": "BR",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 1,
    "date": "2022-05-19",
    "review": "This place does not exist anymore. Apparently it shut down over 6 months ago. Please take down this restaurant as we waste our time going to it and it’s not even there",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Joinville - SC",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2c25ee26d5548f4d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2c25ee26d5548f4d",
    "maps_embed": "https://www.google.com/maps?q=Menu%20Poke%20Joinville%20R.%20Blumenau%2C%2064%20-%20loja%2006%20-%20Centro%2C%20Joinville%20-%20SC%2C%2089204-350%2C%20Brazil&output=embed",
    "lat": -26.2995541,
    "lng": -48.8503128,
    "seo_title": "Menu Poke Joinville Review: Is It Worth A Visit?",
    "seo_description": "This place does not exist anymore. Apparently it shut down over 6 months ago. Please take down this restaurant as we waste our time going to it and it…",
    "image": ""
  },
  {
    "id": "vim-pela-comida-restaurante-vegano",
    "name": "Vim pela comida - Restaurante vegano",
    "address": "R. Min. Heitor Bastos Tigre, 67 A - Monte Kemel, São Paulo - SP, 05634-060, Brazil",
    "city": "São Paulo - SP",
    "country": "",
    "country_code": "BR",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-05-18",
    "review": "Defiantly stop by this place for a great meal. This place is both quality and quantity. The meals were wholesome and nutritious. The kindest man works here, he gave us tea to help keep us warm and let us try the cookies and extra bread buns for free. Thank you 🙏",
    "questions": [],
    "tags": [
      "Food & Drink",
      "São Paulo - SP",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xda281f2eded51c2f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xda281f2eded51c2f",
    "maps_embed": "https://www.google.com/maps?q=Vim%20pela%20comida%20-%20Restaurante%20vegano%20R.%20Min.%20Heitor%20Bastos%20Tigre%2C%2067%20A%20-%20Monte%20Kemel%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2005634-060%2C%20Brazil&output=embed",
    "lat": -23.6007308,
    "lng": -46.7418236,
    "seo_title": "Vim pela comida - Restaurante vegano Review: Is It Worth A Visit?",
    "seo_description": "Defiantly stop by this place for a great meal. This place is both quality and quantity. The meals were wholesome and nutritious. The kindest man works…",
    "image": ""
  },
  {
    "id": "paraiso-caf",
    "name": "Paraiso Café",
    "address": "R. Manoel Tôrres, 75 - Parque Imperial, Paraty - RJ, 23970-000, Brazil",
    "city": "Paraty - RJ",
    "country": "",
    "country_code": "BR",
    "category": "Beaches & Nature",
    "subcategory": "Hikes",
    "rating": 4,
    "date": "2022-05-16",
    "review": "The place was cozy and had a good amount of vegan options. It did take awhile for my food to come out. But it was good. A bit overpriced for the amount of food. Nice staff who were friendly.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "Paraty - RJ",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd5050b3f71e021f1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd5050b3f71e021f1",
    "maps_embed": "https://www.google.com/maps?q=Paraiso%20Caf%C3%A9%20R.%20Manoel%20T%C3%B4rres%2C%2075%20-%20Parque%20Imperial%2C%20Paraty%20-%20RJ%2C%2023970-000%2C%20Brazil&output=embed",
    "lat": -23.2221879,
    "lng": -44.718253,
    "seo_title": "Paraiso Café Review: Is It Worth A Visit?",
    "seo_description": "The place was cozy and had a good amount of vegan options. It did take awhile for my food to come out. But it was good. A bit overpriced for the amoun…",
    "image": ""
  },
  {
    "id": "let-s-vegan-comida-vegana",
    "name": "Let's Vegan - Comida Vegana",
    "address": "Rua Dr. Álvaro Alvim, 201 - Vila Mariana, São Paulo - SP, 04018-010, Brazil",
    "city": "São Paulo - SP",
    "country": "",
    "country_code": "BR",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 3,
    "date": "2022-05-16",
    "review": "The burger took a long time to come out. It was good, although the bun was a little soggy. I was still hungry after, I think for the price it should come with fries. Also Saturday was so loud and busy from the bar beside it. Wouldn’t recommend for a quiet relaxing dinner place.",
    "questions": [],
    "tags": [
      "Practical Finds",
      "São Paulo - SP",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2cf985290f07ad48",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2cf985290f07ad48",
    "maps_embed": "https://www.google.com/maps?q=Let%27s%20Vegan%20-%20Comida%20Vegana%20Rua%20Dr.%20%C3%81lvaro%20Alvim%2C%20201%20-%20Vila%20Mariana%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004018-010%2C%20Brazil&output=embed",
    "lat": -23.5899714,
    "lng": -46.6411965,
    "seo_title": "Let's Vegan - Comida Vegana Review: Is It Worth A Visit?",
    "seo_description": "The burger took a long time to come out. It was good, although the bun was a little soggy. I was still hungry after, I think for the price it should c…",
    "image": ""
  },
  {
    "id": "pimenta-s-ria-b-zios",
    "name": "Pimenta Síria Búzios",
    "address": "R. César Augusto São Luís, 225 - Centro, Armação dos Búzios - RJ, 28950-000, Brazil",
    "city": "Armação dos Búzios - RJ",
    "country": "",
    "country_code": "BR",
    "category": "Beaches & Nature",
    "subcategory": "Hikes",
    "rating": 4,
    "date": "2022-05-16",
    "review": "The falafel wrap was great. The place was nice. Only giving 4 star as some of the things we order like the fries were over priced for the amount they gave",
    "questions": [],
    "tags": [
      "Beaches & Nature",
      "Armação dos Búzios - RJ",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd43e4b169fe69cd4",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd43e4b169fe69cd4",
    "maps_embed": "https://www.google.com/maps?q=Pimenta%20S%C3%ADria%20B%C3%BAzios%20R.%20C%C3%A9sar%20Augusto%20S%C3%A3o%20Lu%C3%ADs%2C%20225%20-%20Centro%2C%20Arma%C3%A7%C3%A3o%20dos%20B%C3%BAzios%20-%20RJ%2C%2028950-000%2C%20Brazil&output=embed",
    "lat": -22.7560364,
    "lng": -41.8868698,
    "seo_title": "Pimenta Síria Búzios Review: Is It Worth A Visit?",
    "seo_description": "The falafel wrap was great. The place was nice. Only giving 4 star as some of the things we order like the fries were over priced for the amount they …",
    "image": ""
  },
  {
    "id": "the-vegan-and-the-jagar",
    "name": "The Vegan and the Jagar",
    "address": "Av. Jabaquara, 729 - Jabaquara, Paraty - RJ, 23970-000, Brazil",
    "city": "Paraty - RJ",
    "country": "",
    "country_code": "BR",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 1,
    "date": "2022-05-16",
    "review": "I don’t think this place exists anymore",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Paraty - RJ",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x23794eba3effd1c4",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x23794eba3effd1c4",
    "maps_embed": "https://www.google.com/maps?q=The%20Vegan%20and%20the%20Jagar%20Av.%20Jabaquara%2C%20729%20-%20Jabaquara%2C%20Paraty%20-%20RJ%2C%2023970-000%2C%20Brazil&output=embed",
    "lat": -23.2081124,
    "lng": -44.7171181,
    "seo_title": "The Vegan and the Jagar Review: Is It Worth A Visit?",
    "seo_description": "I don’t think this place exists anymore",
    "image": ""
  },
  {
    "id": "beco-do-batman",
    "name": "Beco do Batman",
    "address": "R. Medeiros de Albuquerque, 82-154 - Jardim das Bandeiras, São Paulo - SP, 05436-060, Brazil",
    "city": "São Paulo - SP",
    "country": "",
    "country_code": "BR",
    "category": "Practical Finds",
    "subcategory": "ATM",
    "rating": 5,
    "date": "2022-05-16",
    "review": "Sunday is a vibe. Great atmosphere. Lots of people around",
    "questions": [],
    "tags": [
      "Practical Finds",
      "São Paulo - SP",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc5b1a9636043ff22",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc5b1a9636043ff22",
    "maps_embed": "https://www.google.com/maps?q=Beco%20do%20Batman%20R.%20Medeiros%20de%20Albuquerque%2C%2082-154%20-%20Jardim%20das%20Bandeiras%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2005436-060%2C%20Brazil&output=embed",
    "lat": -23.5566009,
    "lng": -46.686579,
    "seo_title": "Beco do Batman Review: Is It Worth A Visit?",
    "seo_description": "Sunday is a vibe. Great atmosphere. Lots of people around",
    "image": ""
  },
  {
    "id": "green-kitchen-pinheiros-restaurante-e-bar",
    "name": "Green Kitchen - Pinheiros/ restaurante e bar",
    "address": "Rua Benjamim Egas, 275 - Pinheiros, São Paulo - SP, 05418-030, Brazil",
    "city": "São Paulo - SP",
    "country": "",
    "country_code": "BR",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-05-16",
    "review": "A beautiful place with delicious vegan food. Best meal I’ve had in a long time.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "São Paulo - SP",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x73084bbc8859315b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x73084bbc8859315b",
    "maps_embed": "https://www.google.com/maps?q=Green%20Kitchen%20-%20Pinheiros/%20restaurante%20e%20bar%20Rua%20Benjamim%20Egas%2C%20275%20-%20Pinheiros%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2005418-030%2C%20Brazil&output=embed",
    "lat": -23.566417,
    "lng": -46.6888574,
    "seo_title": "Green Kitchen - Pinheiros/ restaurante e bar Review: Is It Worth A Visit?",
    "seo_description": "A beautiful place with delicious vegan food. Best meal I’ve had in a long time.",
    "image": ""
  },
  {
    "id": "atha-alimenta-o-saud-vel",
    "name": "Atha - Alimentação Saudável",
    "address": "R. Jaime Duarte, 114 - Divino Espírito Santo, Vila Velha - ES, 29101-620, Brazil",
    "city": "Vila Velha - ES",
    "country": "",
    "country_code": "",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 1,
    "date": "2022-05-04",
    "review": "This place does not exist anymore",
    "questions": [],
    "tags": [
      "Experiences",
      "Vila Velha - ES",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9d5faf5bf9f488a0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9d5faf5bf9f488a0",
    "maps_embed": "https://www.google.com/maps?q=Atha%20-%20Alimenta%C3%A7%C3%A3o%20Saud%C3%A1vel%20R.%20Jaime%20Duarte%2C%20114%20-%20Divino%20Esp%C3%ADrito%20Santo%2C%20Vila%20Velha%20-%20ES%2C%2029101-620%2C%20Brazil&output=embed",
    "lat": -20.3441566,
    "lng": -40.2915139,
    "seo_title": "Atha - Alimentação Saudável Review: Is It Worth A Visit?",
    "seo_description": "This place does not exist anymore",
    "image": ""
  },
  {
    "id": "bertone-s-pizzaria-montserrat",
    "name": "Bertone’s Pizzaria Montserrat",
    "address": "Av. Eldes Scherrer Souza, 2162 - Colina de Laranjeiras, Serra - ES, 29167-113, Brazil",
    "city": "Serra - ES",
    "country": "",
    "country_code": "BR",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 1,
    "date": "2022-04-12",
    "review": "Took way to long for a small pizza and it was only vegetable and no cheese. They told me 10 minutes. Took over half an hour. Disappointing.",
    "questions": [],
    "tags": [
      "Food & Drink",
      "Serra - ES",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x588caee77ce4bb3c",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x588caee77ce4bb3c",
    "maps_embed": "https://www.google.com/maps?q=Bertone%E2%80%99s%20Pizzaria%20Montserrat%20Av.%20Eldes%20Scherrer%20Souza%2C%202162%20-%20Colina%20de%20Laranjeiras%2C%20Serra%20-%20ES%2C%2029167-113%2C%20Brazil&output=embed",
    "lat": -20.1928017,
    "lng": -40.2657909,
    "seo_title": "Bertone’s Pizzaria Montserrat Review: Is It Worth A Visit?",
    "seo_description": "Took way to long for a small pizza and it was only vegetable and no cheese. They told me 10 minutes. Took over half an hour. Disappointing.",
    "image": ""
  },
  {
    "id": "shopping-montserrat",
    "name": "Shopping Montserrat",
    "address": "Av. Eldes Scherrer Souza, 2162 - Colina de Laranjeiras, Serra - ES, 29167-080, Brazil",
    "city": "Serra - ES",
    "country": "",
    "country_code": "BR",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 1,
    "date": "2022-04-12",
    "review": "Most of the food places were under maintenance. I ordered a small pizza from farinella and it took nearly half an hour and no one was waiting. This mall is below average",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Serra - ES",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc6d2f9e7068a8e85",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc6d2f9e7068a8e85",
    "maps_embed": "https://www.google.com/maps?q=Shopping%20Montserrat%20Av.%20Eldes%20Scherrer%20Souza%2C%202162%20-%20Colina%20de%20Laranjeiras%2C%20Serra%20-%20ES%2C%2029167-080%2C%20Brazil&output=embed",
    "lat": -20.1931374,
    "lng": -40.2663088,
    "seo_title": "Shopping Montserrat Review: Is It Worth A Visit?",
    "seo_description": "Most of the food places were under maintenance. I ordered a small pizza from farinella and it took nearly half an hour and no one was waiting. This ma…",
    "image": ""
  },
  {
    "id": "street-organics",
    "name": "Street Organics",
    "address": "1 Byron Avenue, Takapuna, Auckland 0622, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2022-02-02",
    "review": "Beautiful place with lovely staff. Food was nicely prepared and tasted delicious. Vegan friendly meals that actually fill you up.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2eeb5d5e13679d41",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2eeb5d5e13679d41",
    "maps_embed": "https://www.google.com/maps?q=Street%20Organics%201%20Byron%20Avenue%2C%20Takapuna%2C%20Auckland%200622%2C%20New%20Zealand&output=embed",
    "lat": -36.7902817,
    "lng": 174.7722804,
    "seo_title": "Street Organics Review: Is It Worth A Visit?",
    "seo_description": "Beautiful place with lovely staff. Food was nicely prepared and tasted delicious. Vegan friendly meals that actually fill you up.",
    "image": ""
  },
  {
    "id": "asb-albany-branch",
    "name": "ASB Albany Branch",
    "address": "Shop S218, Westfield Albany 219 Don McKinnon Drive, 0632, New Zealand",
    "city": "Westfield Albany 219 Don McKinnon Drive",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 1,
    "date": "2022-02-01",
    "review": "I’ve been with ASB for nearly 20 years and they treat you with such disrespect at this branch. Really has got me considering a new bank.",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Westfield Albany 219 Don McKinnon Drive",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5b0d88912cc7117",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x5b0d88912cc7117",
    "maps_embed": "https://www.google.com/maps?q=ASB%20Albany%20Branch%20Shop%20S218%2C%20Westfield%20Albany%20219%20Don%20McKinnon%20Drive%2C%200632%2C%20New%20Zealand&output=embed",
    "lat": -36.7286526,
    "lng": 174.7106994,
    "seo_title": "ASB Albany Branch Review: Is It Worth A Visit?",
    "seo_description": "I’ve been with ASB for nearly 20 years and they treat you with such disrespect at this branch. Really has got me considering a new bank.",
    "image": ""
  },
  {
    "id": "burger-burger-the-mount",
    "name": "Burger Burger The Mount",
    "address": "Dining Laneway, 1 Girven Road, Bayfair, Mount Maunganui 3116, New Zealand",
    "city": "Bayfair",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Beaches & Nature",
    "subcategory": "Hikes",
    "rating": 3,
    "date": "2022-01-14",
    "review": "The vibe is nice but the burgers are super expensive for what they are. I ordered the vegan beef and cheese for $16 and it doesn’t even have salad on it.\nMy bf got the vege ‘chicken’ and he really enjoyed it but doesn’t think it was worth $19 as he was still hungry after 😆",
    "questions": [],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "Bayfair",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa07955ba0819a752",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa07955ba0819a752",
    "maps_embed": "https://www.google.com/maps?q=Burger%20Burger%20The%20Mount%20Dining%20Laneway%2C%201%20Girven%20Road%2C%20Bayfair%2C%20Mount%20Maunganui%203116%2C%20New%20Zealand&output=embed",
    "lat": -37.6754077,
    "lng": 176.2227729,
    "seo_title": "Burger Burger The Mount Review: Is It Worth A Visit?",
    "seo_description": "The vibe is nice but the burgers are super expensive for what they are. I ordered the vegan beef and cheese for $16 and it doesn’t even have salad on …",
    "image": ""
  },
  {
    "id": "the-shroom-room",
    "name": "The Shroom Room",
    "address": "48 London Street, Lyttelton 8082, New Zealand",
    "city": "48 London Street",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 5,
    "date": "2022-01-03",
    "review": "Loads of vegan options. Both my partner and my meal was amazing !! Nice vibe. Would def recommend if you are in this area.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Stays",
      "48 London Street",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcfd311e609498d18",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xcfd311e609498d18",
    "maps_embed": "https://www.google.com/maps?q=The%20Shroom%20Room%2048%20London%20Street%2C%20Lyttelton%208082%2C%20New%20Zealand&output=embed",
    "lat": -43.6022061,
    "lng": 172.7201505,
    "seo_title": "The Shroom Room Review: Is It Worth A Visit?",
    "seo_description": "Loads of vegan options. Both my partner and my meal was amazing !! Nice vibe. Would def recommend if you are in this area.",
    "image": ""
  },
  {
    "id": "the-greedy-cow-cafe",
    "name": "The Greedy Cow Cafe",
    "address": "16 Rapuwai Lane, Lake Tekapo 7945, New Zealand",
    "city": "16 Rapuwai Lane",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Beaches & Nature",
    "subcategory": "Nature & Attractions",
    "rating": 3,
    "date": "2022-01-02",
    "review": "Bought the vegan wrap. Didn’t actually state was inside but tasted like curry flavour. Was pretty average. Coffee was good and the place seemed clean",
    "questions": [],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "16 Rapuwai Lane",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe73d91c02038ca2b",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe73d91c02038ca2b",
    "maps_embed": "https://www.google.com/maps?q=The%20Greedy%20Cow%20Cafe%2016%20Rapuwai%20Lane%2C%20Lake%20Tekapo%207945%2C%20New%20Zealand&output=embed",
    "lat": -44.0041406,
    "lng": 170.4768992,
    "seo_title": "The Greedy Cow Cafe Review: Is It Worth A Visit?",
    "seo_description": "Bought the vegan wrap. Didn’t actually state was inside but tasted like curry flavour. Was pretty average. Coffee was good and the place seemed clean",
    "image": ""
  },
  {
    "id": "fergburger",
    "name": "Fergburger",
    "address": "42 Shotover Street, Queenstown 9300, New Zealand",
    "city": "Queenstown",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 3,
    "date": "2021-12-31",
    "review": "Is this place really worth the line?\nMaybe but not for the vegan burger. Tasted average. Personally for me not worth the hype at all.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Queenstown",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x178a1ab4a5dea81f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x178a1ab4a5dea81f",
    "maps_embed": "https://www.google.com/maps?q=Fergburger%2042%20Shotover%20Street%2C%20Queenstown%209300%2C%20New%20Zealand&output=embed",
    "lat": -45.0317349,
    "lng": 168.6594775,
    "seo_title": "Fergburger Review: Is It Worth A Visit?",
    "seo_description": "Is this place really worth the line? Maybe but not for the vegan burger. Tasted average. Personally for me not worth the hype at all.",
    "image": ""
  },
  {
    "id": "ditto",
    "name": "Ditto",
    "address": "92 Town Centre, Te Anau 9600, New Zealand",
    "city": "92 Town Centre",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2021-12-29",
    "review": "I had the crispy tofu bowl. Tasted super fresh and delicious. Only missing a star as it was quite expensive for the size -$15",
    "questions": [],
    "tags": [
      "Food & Drink",
      "92 Town Centre",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x858dbf478af1c4a0",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x858dbf478af1c4a0",
    "maps_embed": "https://www.google.com/maps?q=Ditto%2092%20Town%20Centre%2C%20Te%20Anau%209600%2C%20New%20Zealand&output=embed",
    "lat": -45.4154321,
    "lng": 167.7159973,
    "seo_title": "Ditto Review: Is It Worth A Visit?",
    "seo_description": "I had the crispy tofu bowl. Tasted super fresh and delicious. Only missing a star as it was quite expensive for the size -$15",
    "image": ""
  },
  {
    "id": "roys-peak",
    "name": "Roys Peak",
    "address": "Wānaka 9382, New Zealand",
    "city": "Wānaka",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Gyms",
    "subcategory": "Gyms",
    "rating": 5,
    "date": "2021-12-28",
    "review": "The walk is step and got cold up the top. I started around 7:30. The clouds covered the very top point so the view was actually better just below. Such a spectacular view.\nI did it in gym shoes. Be sure to bring a hat and jacket. Enjoy :)",
    "questions": [],
    "tags": [
      "Gyms",
      "Wānaka",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe6ef50dbcb0458ea",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe6ef50dbcb0458ea",
    "maps_embed": "https://www.google.com/maps?q=Roys%20Peak%20W%C4%81naka%209382%2C%20New%20Zealand&output=embed",
    "lat": -44.7,
    "lng": 169.05,
    "seo_title": "Roys Peak Review: Is It Worth A Visit?",
    "seo_description": "The walk is step and got cold up the top. I started around 7:30. The clouds covered the very top point so the view was actually better just below. Suc…",
    "image": ""
  },
  {
    "id": "burrito-craft",
    "name": "Burrito Craft",
    "address": "42 Brownston Street, Wānaka 9305, New Zealand",
    "city": "Wānaka",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2021-12-28",
    "review": "A couple of vegan options. The big size is a decent size, does end up in a mess however. I asked for no spice and it was still spicy for me. Overall it’s a cool vibe there and a beautiful view",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Wānaka",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa0eea35684ace748",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa0eea35684ace748",
    "maps_embed": "https://www.google.com/maps?q=Burrito%20Craft%2042%20Brownston%20Street%2C%20W%C4%81naka%209305%2C%20New%20Zealand&output=embed",
    "lat": -44.6962245,
    "lng": 169.1377506,
    "seo_title": "Burrito Craft Review: Is It Worth A Visit?",
    "seo_description": "A couple of vegan options. The big size is a decent size, does end up in a mess however. I asked for no spice and it was still spicy for me. Overall i…",
    "image": ""
  },
  {
    "id": "eatery-at-rothesay-bay",
    "name": "Eatery at Rothesay Bay",
    "address": "2 Knights Road, Parking available at 70 Lyons Avenue, Rothesay Bay, Auckland 0630, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Transport",
    "rating": 5,
    "date": "2021-08-08",
    "review": "Nice wholesome meals with quick service even when busy.",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe82143b0ddef1372",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe82143b0ddef1372",
    "maps_embed": "https://www.google.com/maps?q=Eatery%20at%20Rothesay%20Bay%202%20Knights%20Road%2C%20Parking%20available%20at%2070%20Lyons%20Avenue%2C%20Rothesay%20Bay%2C%20Auckland%200630%2C%20New%20Zealand&output=embed",
    "lat": -36.7268504,
    "lng": 174.7473315,
    "seo_title": "Eatery at Rothesay Bay Review: Is It Worth A Visit?",
    "seo_description": "Nice wholesome meals with quick service even when busy.",
    "image": ""
  },
  {
    "id": "vitality-kitchen",
    "name": "Vitality Kitchen",
    "address": "114 Willow Street, Tauranga 3110, New Zealand",
    "city": "114 Willow Street",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2021-08-03",
    "review": "I keep forgetting to review this place but it’s an absolute gem. The food is top notch and the staff are very attentive and friendly. My fav place to go when passing through Tauranga for tasty vegan meals and treats",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "114 Willow Street",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd0089d5c3437368e",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xd0089d5c3437368e",
    "maps_embed": "https://www.google.com/maps?q=Vitality%20Kitchen%20114%20Willow%20Street%2C%20Tauranga%203110%2C%20New%20Zealand&output=embed",
    "lat": -37.6836897,
    "lng": 176.1690656,
    "seo_title": "Vitality Kitchen Review: Is It Worth A Visit?",
    "seo_description": "I keep forgetting to review this place but it’s an absolute gem. The food is top notch and the staff are very attentive and friendly. My fav place to …",
    "image": ""
  },
  {
    "id": "kind-cafe-eatery",
    "name": "Kind Cafe & Eatery",
    "address": "16 McDonald Street, Morningside, Auckland 1025, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2021-07-25",
    "review": "A few vegan options with delish coffee. Nice ambience",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x214c30552dc66c51",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x214c30552dc66c51",
    "maps_embed": "https://www.google.com/maps?q=Kind%20Cafe%20%26%20Eatery%2016%20McDonald%20Street%2C%20Morningside%2C%20Auckland%201025%2C%20New%20Zealand&output=embed",
    "lat": -36.8755639,
    "lng": 174.7370851,
    "seo_title": "Kind Cafe & Eatery Review: Is It Worth A Visit?",
    "seo_description": "A few vegan options with delish coffee. Nice ambience",
    "image": ""
  },
  {
    "id": "burgerfuel-albany",
    "name": "BurgerFuel Albany",
    "address": "7 Mercari Way, Albany, Auckland 0632, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 1,
    "date": "2021-07-10",
    "review": "I go the v twin vege and asked to make it vegan. I waited 25 minutes and after the first bite I realised it had dairy cheese. This is not the first time it’s happened.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa791acf504045151",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xa791acf504045151",
    "maps_embed": "https://www.google.com/maps?q=BurgerFuel%20Albany%207%20Mercari%20Way%2C%20Albany%2C%20Auckland%200632%2C%20New%20Zealand&output=embed",
    "lat": -36.732776,
    "lng": 174.709195,
    "seo_title": "BurgerFuel Albany Review: Is It Worth A Visit?",
    "seo_description": "I go the v twin vege and asked to make it vegan. I waited 25 minutes and after the first bite I realised it had dairy cheese. This is not the first ti…",
    "image": ""
  },
  {
    "id": "goodburgers",
    "name": "Goodburgers",
    "address": "Shop 6/1 Marine Parade, Mount Maunganui 3116, New Zealand",
    "city": "Shop 6/1 Marine Parade",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Beaches & Nature",
    "subcategory": "Nature & Attractions",
    "rating": 1,
    "date": "2021-04-30",
    "review": "Average food. Glad I had a GrabOne voucher that gave a discount. Otherwise would be disappointed to have to pay the full price because it is not worth it.",
    "questions": [],
    "tags": [
      "Beaches & Nature",
      "Shop 6/1 Marine Parade",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfbe58b551d09574f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xfbe58b551d09574f",
    "maps_embed": "https://www.google.com/maps?q=Goodburgers%20Shop%206/1%20Marine%20Parade%2C%20Mount%20Maunganui%203116%2C%20New%20Zealand&output=embed",
    "lat": -37.6318475,
    "lng": 176.1775901,
    "seo_title": "Goodburgers Review: Is It Worth A Visit?",
    "seo_description": "Average food. Glad I had a GrabOne voucher that gave a discount. Otherwise would be disappointed to have to pay the full price because it is not worth…",
    "image": ""
  },
  {
    "id": "untitled-place-7",
    "name": "Untitled place",
    "address": "",
    "city": "",
    "country": "",
    "country_code": "",
    "category": "Experiences",
    "subcategory": "Experiences",
    "rating": 1,
    "date": "2021-04-06",
    "review": "Place is such a mess.\nLooks like it’s closing down with so much stuff missing. Not worth it",
    "questions": [],
    "tags": [
      "Experiences",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9961a098be91a5b5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x9961a098be91a5b5",
    "maps_embed": "https://www.google.com/maps?q=Untitled%20place&output=embed",
    "lat": 0,
    "lng": 0,
    "seo_title": "Untitled place Review: Is It Worth A Visit?",
    "seo_description": "Place is such a mess. Looks like it’s closing down with so much stuff missing. Not worth it",
    "image": ""
  },
  {
    "id": "domino-s-pizza-albany-nz",
    "name": "Domino's Pizza Albany (NZ)",
    "address": "Shop C, Albany, Auckland 0632, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Practical Finds",
    "subcategory": "Services",
    "rating": 3,
    "date": "2021-03-17",
    "review": "Pizza was good but hardly any toppings",
    "questions": [],
    "tags": [
      "Practical Finds",
      "Auckland",
      "New Zealand",
      "Mixed"
    ],
    "verdict": "Mixed",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2719a155e7e0f8db",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x2719a155e7e0f8db",
    "maps_embed": "https://www.google.com/maps?q=Domino%27s%20Pizza%20Albany%20%28NZ%29%20Shop%20C%2C%20Albany%2C%20Auckland%200632%2C%20New%20Zealand&output=embed",
    "lat": -36.7258647,
    "lng": 174.6971692,
    "seo_title": "Domino's Pizza Albany (NZ) Review: Is It Worth A Visit?",
    "seo_description": "Pizza was good but hardly any toppings",
    "image": ""
  },
  {
    "id": "mexico-ellerslie",
    "name": "Mexico Ellerslie",
    "address": "Corner Ladies Mile &, Main Highway, Ellerslie, Auckland 1051, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 4,
    "date": "2021-03-15",
    "review": "Lots of yummy vegan treats.\nGreat vibe and ambiance.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x240f528f85dd851",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x240f528f85dd851",
    "maps_embed": "https://www.google.com/maps?q=Mexico%20Ellerslie%20Corner%20Ladies%20Mile%20%26%2C%20Main%20Highway%2C%20Ellerslie%2C%20Auckland%201051%2C%20New%20Zealand&output=embed",
    "lat": -36.8977252,
    "lng": 174.8092622,
    "seo_title": "Mexico Ellerslie Review: Is It Worth A Visit?",
    "seo_description": "Lots of yummy vegan treats. Great vibe and ambiance.",
    "image": ""
  },
  {
    "id": "franklins-bar-eatery",
    "name": "Franklins Bar & Eatery",
    "address": "Cnr West St & 1 Queen Street, Pukekohe 2120, New Zealand",
    "city": "Cnr West St & 1 Queen Street",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Wellness",
    "subcategory": "Wellness",
    "rating": 4,
    "date": "2021-03-15",
    "review": "Ordered the salad and made it vegan. They didn’t have any asparagus as they had run out. Tasted wonderful although I was still hungry after.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Wellness",
      "Cnr West St & 1 Queen Street",
      "New Zealand",
      "Worth considering"
    ],
    "verdict": "Worth considering",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe8418ed09db03a80",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe8418ed09db03a80",
    "maps_embed": "https://www.google.com/maps?q=Franklins%20Bar%20%26%20Eatery%20Cnr%20West%20St%20%26%201%20Queen%20Street%2C%20Pukekohe%202120%2C%20New%20Zealand&output=embed",
    "lat": -37.2008673,
    "lng": 174.9010503,
    "seo_title": "Franklins Bar & Eatery Review: Is It Worth A Visit?",
    "seo_description": "Ordered the salad and made it vegan. They didn’t have any asparagus as they had run out. Tasted wonderful although I was still hungry after.",
    "image": ""
  },
  {
    "id": "the-flying-burrito-brothers-albany",
    "name": "The Flying Burrito Brothers Albany",
    "address": "270 Oteha Valley Road, Albany, Auckland 0632, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 2,
    "date": "2021-02-26",
    "review": "Slow service,\nSome vegetation options that can be made vegan. Had the tacos which were tasty but very greasy.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x436c6145d00b7a54",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x436c6145d00b7a54",
    "maps_embed": "https://www.google.com/maps?q=The%20Flying%20Burrito%20Brothers%20Albany%20270%20Oteha%20Valley%20Road%2C%20Albany%2C%20Auckland%200632%2C%20New%20Zealand&output=embed",
    "lat": -36.7227869,
    "lng": 174.7047492,
    "seo_title": "The Flying Burrito Brothers Albany Review: Is It Worth A Visit?",
    "seo_description": "Slow service, Some vegetation options that can be made vegan. Had the tacos which were tasty but very greasy.",
    "image": ""
  },
  {
    "id": "little-bird-kitchen",
    "name": "Little Bird Kitchen",
    "address": "Summer Street &, Ponsonby Road, Ponsonby, Auckland 1011, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Stays",
    "subcategory": "Accommodation",
    "rating": 5,
    "date": "2021-02-14",
    "review": "Vegan mushrooms, bloody dam good !!\nSuch a good vibe at this place",
    "questions": [],
    "tags": [
      "Vegan options",
      "Stays",
      "Auckland",
      "New Zealand",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x378e9291390791c1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x378e9291390791c1",
    "maps_embed": "https://www.google.com/maps?q=Little%20Bird%20Kitchen%20Summer%20Street%20%26%2C%20Ponsonby%20Road%2C%20Ponsonby%2C%20Auckland%201011%2C%20New%20Zealand&output=embed",
    "lat": -36.8517462,
    "lng": 174.7443671,
    "seo_title": "Little Bird Kitchen Review: Is It Worth A Visit?",
    "seo_description": "Vegan mushrooms, bloody dam good !! Such a good vibe at this place",
    "image": ""
  },
  {
    "id": "sand-dunz-beach-cafe",
    "name": "Sand Dunz Beach Cafe",
    "address": "455 Motutara Road, Muriwai 0881, New Zealand",
    "city": "455 Motutara Road",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Beaches & Nature",
    "subcategory": "Beaches",
    "rating": 2,
    "date": "2021-02-13",
    "review": "Both my partner and I had the vegetarian stack. I made my vegan they just added extra vegetables and took away the pesto and halloumi. It was nice but the portion was pretty small and we were both hungry after. Don’t think it was worth the $22",
    "questions": [],
    "tags": [
      "Vegan options",
      "Beaches & Nature",
      "455 Motutara Road",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x63e30d92e2939be1",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x63e30d92e2939be1",
    "maps_embed": "https://www.google.com/maps?q=Sand%20Dunz%20Beach%20Cafe%20455%20Motutara%20Road%2C%20Muriwai%200881%2C%20New%20Zealand&output=embed",
    "lat": -36.82967,
    "lng": 174.4293575,
    "seo_title": "Sand Dunz Beach Cafe Review: Is It Worth A Visit?",
    "seo_description": "Both my partner and I had the vegetarian stack. I made my vegan they just added extra vegetables and took away the pesto and halloumi. It was nice but…",
    "image": ""
  },
  {
    "id": "calendula-cottage-cafe-gardens",
    "name": "Calendula Cottage Cafe & Gardens",
    "address": "12 Collie Road, Auckland 2681, New Zealand",
    "city": "Auckland",
    "country": "New Zealand",
    "country_code": "NZ",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 2,
    "date": "2020-10-09",
    "review": "Doesn’t offer any vegan food on the menu. Was asked to pick stuff off the sides.\nWhen it came I had to put it all together and the smash avo didn’t even cover the two slim bits of toast. (It was $4) when I asked for more they required I pay for extra. I refused and they finally gave me some more. I felt like they were arguing with me and it was my fault as it was what I ordered.\nThe 2 stars are for the great coffee and the beautiful outdoor setting.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "Auckland",
      "New Zealand",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe66d606b5a67faa5",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe66d606b5a67faa5",
    "maps_embed": "https://www.google.com/maps?q=Calendula%20Cottage%20Cafe%20%26%20Gardens%2012%20Collie%20Road%2C%20Auckland%202681%2C%20New%20Zealand&output=embed",
    "lat": -37.2029035,
    "lng": 174.7774471,
    "seo_title": "Calendula Cottage Cafe & Gardens Review: Is It Worth A Visit?",
    "seo_description": "Doesn’t offer any vegan food on the menu. Was asked to pick stuff off the sides. When it came I had to put it all together and the smash avo didn’t ev…",
    "image": ""
  },
  {
    "id": "rgb-coffee-at-the-bean-hive",
    "name": "RGB Coffee at the Bean Hive",
    "address": "35, Jalan Damai, Kampung Datuk Keramat, 55000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur, Malaysia",
    "city": "55000 Kuala Lumpur",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Cafes & Coffee",
    "rating": 5,
    "date": "2020-08-21",
    "review": "Some great nutritious vegan options",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "55000 Kuala Lumpur",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x508ed6a86bf3bfb6",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x508ed6a86bf3bfb6",
    "maps_embed": "https://www.google.com/maps?q=RGB%20Coffee%20at%20the%20Bean%20Hive%2035%2C%20Jalan%20Damai%2C%20Kampung%20Datuk%20Keramat%2C%2055000%20Kuala%20Lumpur%2C%20Wilayah%20Persekutuan%20Kuala%20Lumpur%2C%20Malaysia&output=embed",
    "lat": 3.1647773,
    "lng": 101.7188838,
    "seo_title": "RGB Coffee at the Bean Hive Review: Is It Worth A Visit?",
    "seo_description": "Some great nutritious vegan options",
    "image": ""
  },
  {
    "id": "wtf-restaurant",
    "name": "WTF Restaurant",
    "address": "98, Lrg Maarof, Bangsar, 59100 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur, Malaysia",
    "city": "59100 Kuala Lumpur",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2020-08-19",
    "review": "Friendly staff and Great Indian cuisine with meals that can easily be adapted to be vegan.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "59100 Kuala Lumpur",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x68b928b7b30278ad",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x68b928b7b30278ad",
    "maps_embed": "https://www.google.com/maps?q=WTF%20Restaurant%2098%2C%20Lrg%20Maarof%2C%20Bangsar%2C%2059100%20Kuala%20Lumpur%2C%20Wilayah%20Persekutuan%20Kuala%20Lumpur%2C%20Malaysia&output=embed",
    "lat": 3.1324601,
    "lng": 101.6731023,
    "seo_title": "WTF Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Friendly staff and Great Indian cuisine with meals that can easily be adapted to be vegan.",
    "image": ""
  },
  {
    "id": "chuk-lim-vege-restaurant",
    "name": "Chuk Lim Vege Restaurant",
    "address": "37, Jalan Syed Zain, 20300 Kuala Terengganu, Terengganu, Malaysia",
    "city": "20300 Kuala Terengganu",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2020-08-15",
    "review": "Very delicious vegetarian/vegan food.",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "20300 Kuala Terengganu",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe4516e3d549e556d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xe4516e3d549e556d",
    "maps_embed": "https://www.google.com/maps?q=Chuk%20Lim%20Vege%20Restaurant%2037%2C%20Jalan%20Syed%20Zain%2C%2020300%20Kuala%20Terengganu%2C%20Terengganu%2C%20Malaysia&output=embed",
    "lat": 5.3260502,
    "lng": 103.1335605,
    "seo_title": "Chuk Lim Vege Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Very delicious vegetarian/vegan food.",
    "image": ""
  },
  {
    "id": "happy-vegetarian-restaurant",
    "name": "常悦素食 Happy Vegetarian Restaurant",
    "address": "Lot 1768, Jalan Kemajuan, 20300 Kuala Terengganu, Terengganu, Malaysia",
    "city": "20300 Kuala Terengganu",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Restaurants",
    "rating": 1,
    "date": "2020-08-15",
    "review": "Closed and did not mention it. Came in a grab, don’t waste your time like we did",
    "questions": [],
    "tags": [
      "Food & Drink",
      "20300 Kuala Terengganu",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8dbcb19418f8906d",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x8dbcb19418f8906d",
    "maps_embed": "https://www.google.com/maps?q=%E5%B8%B8%E6%82%A6%E7%B4%A0%E9%A3%9F%20Happy%20Vegetarian%20Restaurant%20Lot%201768%2C%20Jalan%20Kemajuan%2C%2020300%20Kuala%20Terengganu%2C%20Terengganu%2C%20Malaysia&output=embed",
    "lat": 5.321797,
    "lng": 103.135954,
    "seo_title": "常悦素食 Happy Vegetarian Restaurant Review: Is It Worth A Visit?",
    "seo_description": "Closed and did not mention it. Came in a grab, don’t waste your time like we did",
    "image": ""
  },
  {
    "id": "grace-hotel-semporna",
    "name": "Grace Hotel Semporna",
    "address": "Lot 8, Seafront Resort Township, 10, Jln Kastam, 91300 Semporna, Sabah, Malaysia",
    "city": "91300 Semporna",
    "country": "",
    "country_code": "MY",
    "category": "Stays",
    "subcategory": "Hotels",
    "rating": 1,
    "date": "2020-08-10",
    "review": "Such bad customer service",
    "questions": [],
    "tags": [
      "Stays",
      "91300 Semporna",
      "Skip"
    ],
    "verdict": "Skip",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1c1d2d6ab29cdf4f",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x1c1d2d6ab29cdf4f",
    "maps_embed": "https://www.google.com/maps?q=Grace%20Hotel%20Semporna%20Lot%208%2C%20Seafront%20Resort%20Township%2C%2010%2C%20Jln%20Kastam%2C%2091300%20Semporna%2C%20Sabah%2C%20Malaysia&output=embed",
    "lat": 4.4794693,
    "lng": 118.6138279,
    "seo_title": "Grace Hotel Semporna Review: Is It Worth A Visit?",
    "seo_description": "Such bad customer service",
    "image": ""
  },
  {
    "id": "damai-studio",
    "name": "Damai Studio",
    "address": "23, Jalan Damai, Kampung Datuk Keramat, 55000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur, Malaysia",
    "city": "55000 Kuala Lumpur",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2020-07-31",
    "review": "Nice wholesome vegan meals",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "55000 Kuala Lumpur",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc2a32b0d9d795a50",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0xc2a32b0d9d795a50",
    "maps_embed": "https://www.google.com/maps?q=Damai%20Studio%2023%2C%20Jalan%20Damai%2C%20Kampung%20Datuk%20Keramat%2C%2055000%20Kuala%20Lumpur%2C%20Wilayah%20Persekutuan%20Kuala%20Lumpur%2C%20Malaysia&output=embed",
    "lat": 3.1649953,
    "lng": 101.7175023,
    "seo_title": "Damai Studio Review: Is It Worth A Visit?",
    "seo_description": "Nice wholesome vegan meals",
    "image": ""
  },
  {
    "id": "pinxin-vegan-cuisine",
    "name": "Pinxin Vegan Cuisine",
    "address": "38, Lebuh Tye Sin, 10300 George Town, Pulau Pinang, Malaysia",
    "city": "10300 George Town",
    "country": "",
    "country_code": "MY",
    "category": "Food & Drink",
    "subcategory": "Vegan Options",
    "rating": 5,
    "date": "2020-05-30",
    "review": "Fav vegan place in Penang. ❤️",
    "questions": [],
    "tags": [
      "Vegan options",
      "Food & Drink",
      "10300 George Town",
      "Worth a visit"
    ],
    "verdict": "Worth a visit",
    "google_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x778eb7e371152677",
    "maps_url": "https://www.google.com/maps/place//data=!4m2!3m1!1s0x0:0x778eb7e371152677",
    "maps_embed": "https://www.google.com/maps?q=Pinxin%20Vegan%20Cuisine%2038%2C%20Lebuh%20Tye%20Sin%2C%2010300%20George%20Town%2C%20Pulau%20Pinang%2C%20Malaysia&output=embed",
    "lat": 5.4101913,
    "lng": 100.3305877,
    "seo_title": "Pinxin Vegan Cuisine Review: Is It Worth A Visit?",
    "seo_description": "Fav vegan place in Penang. ❤️",
    "image": ""
  }
];
